(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.accordion-panel{position:relative;border:1px solid}.accordion-panel:not(first-child){margin-top:-1px}.accordion-panel .accordion-panel-heading{font-size:1.5em;padding:1rem;transition:none}.accordion-panel .accordion-panel-heading .icon{color:inherit}.accordion-panel[open] .accordion-panel-heading{box-shadow:0 2px 2px #0003}html[data-theme=lp] .accordion-panel{border-color:#cfcbc0;background:#fbfbf9}html[data-theme=lp] .accordion-panel .accordion-panel-heading{background-color:#f2f1ec;color:#52504a}html[data-theme=lp] .accordion-panel[open] .accordion-panel-heading{color:#e49640}html[data-theme=gp] .accordion-panel{border-color:#bdbcbc;background:#fafafa}html[data-theme=gp] .accordion-panel .accordion-panel-heading{background-color:#ececec;color:#525252}html[data-theme=gp] .accordion-panel[open] .accordion-panel-heading{color:#036e36}.alert-box{display:flex;position:relative;box-sizing:border-box;gap:.5rem;padding:.75rem;border:1px solid;border-radius:4px;min-width:300px;max-width:100%}html[data-theme=lp] .alert-box:not(.info,.warning,.error,.success){border-color:#cfcbc0;background:#f2f1ec}html[data-theme=gp] .alert-box:not(.info,.warning,.error,.success){border-color:#bdbcbc;background:#ececec}.alert-box.full{width:100%}.alert-box .alert-icon{font-size:1.5em}.alert-box h1,.alert-box h2,.alert-box h3{font-size:1.4em;font-weight:500}.alert-box .alert-message{color:inherit;display:inline-flex;gap:.25rem;flex-grow:1;margin-top:.25rem}.alert-box .alert-message p:last-child{margin-bottom:0}.alert-box.info{border-color:#266fbb;background:#d9e6f9;color:#1c528a}.alert-box.info .icon{color:#266fbb}.alert-box.warning{border-color:#ffc107;background:#fffce5;color:#a87807}.alert-box.warning .icon{color:#ffc107}.alert-box.error{border-color:#dc3545;background:#ffdcde;color:#ab2936}.alert-box.error .icon{color:#dc3545}.alert-box.success{border-color:#28a745;background:#f8fff0;color:#1f8531}.alert-box.success .icon{color:#28a745}.alert-message.info{color:#266fbb}.alert-message.warning{color:#ffc107}.alert-message.error{color:#dc3545}.alert-message.success{color:#28a745}html[data-theme=lp] .alert-message.color{color:#e49640}html[data-theme=gp] .alert-message.color{color:#036e36}.alert-banner{bottom:0;background:#dc3545 linear-gradient(#0000,#0000 50%,#0000000d);color:#ffdcde;padding:.75rem 1rem;font-size:.9rem;gap:1.5rem}.alert-banner .alert-banner-content{overflow:hidden}.alert-banner .alert-banner-content p{margin:0}.alert-banner .alert-banner-content a{color:inherit}.alert-banner button.text-only{text-decoration:underline;flex-grow:0;flex-shrink:0}.alerts-container{position:absolute;top:100%;width:100%;box-shadow:#0000004d 0 1px 2px,#00000026 0 2px 4px}.icon.success{color:#28a745}.icon.warning{color:#ffc107}.icon.danger{color:#dc3545}.icon.info{color:#266fbb}html[data-theme=lp] .icon.color{color:#e49640}html[data-theme=gp] .icon.color{color:#036e36}.icon.custom{display:inline-block;content:"";vertical-align:-.125em;background-color:currentColor;mask-repeat:no-repeat;-webkit-mask-repeat:no-repeat;-moz-mask-repeat:no-repeat;-ms-mask-repeat:no-repeat;mask-size:1em 1em;-webkit-mask-size:1em 1em;-moz-mask-size:1em 1em;-ms-mask-size:1em 1em;width:1em;height:1em}.icon.large{font-size:1.25em}.icon.xl{font-size:1.5em}nav.breadcrumbs{font-size:1rem;font-weight:500;margin-bottom:1rem}nav.breadcrumbs li:not(:first-child):before{content:">";margin-right:.5rem}details.content-block{gap:0}details.content-block summary:hover{cursor:pointer}details.content-block summary .content-block-heading-text{gap:1rem}details.content-block summary>.icon{font-size:1.25rem}details.content-block[open] summary>.icon{transform:rotate(90deg)}.content-block{padding:0}.content-block .content-block-heading{padding:.8rem;border-top-right-radius:8px;border-top-left-radius:8px;gap:1rem}.content-block .content-block-heading h1,.content-block .content-block-heading h2,.content-block .content-block-heading h3,.content-block .content-block-heading h4,.content-block .content-block-heading h5{margin:0;padding:0;font-family:Roboto,Arial,sans-serif}.content-block .content-block-heading i{font-size:1.8em}html[data-theme=lp] .content-block .content-block-heading{color:#52504a}html[data-theme=lp] .content-block .content-block-heading i{color:#e49640}html[data-theme=gp] .content-block .content-block-heading{color:#525252}html[data-theme=gp] .content-block .content-block-heading i{color:#f7b145}.content-block .content{padding:.8rem}.content-block.loading .content-block-heading,.content-block.loading{animation:skeleton-pulse .5s infinite;animation-direction:alternate;animation-timing-function:linear}.content-block.loading .content{min-height:260px}html[data-theme=lp] .content-block.loading{background:#f2f1ec!important}html[data-theme=lp] .content-block.loading .content-block-heading{background:#eae8e1!important}html[data-theme=gp] .content-block.loading{background:#f5f5f5!important}html[data-theme=gp] .content-block.loading .content-block-heading{background:#e6e6e6!important}.content-block.disabled{color:#9a9a9a!important;background-color:#dedede!important}.content-block.disabled .icon{color:inherit!important}.page-footer{display:flex;flex-direction:column;justify-content:stretch;align-items:stretch;flex-wrap:nowrap}.page-footer .footer-section{display:flex;flex-direction:row;justify-content:center;align-items:center;flex-wrap:nowrap}.page-footer .footer-section .footer-wrapper{flex-grow:1;max-width:1900px}.page-footer .footer-section.primary{padding:2rem}.page-footer .footer-section.primary .footer-wrapper{display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex-wrap:nowrap}html[data-theme=lp] .page-footer .footer-section.primary{background:#1d2f42;color:#fbfbf9}html[data-theme=lp] .page-footer .footer-section.primary a{color:#fbfbf9}html[data-theme=gp] .page-footer .footer-section.primary{background:#00602a;color:#fafafa}html[data-theme=gp] .page-footer .footer-section.primary a{color:#fafafa}.page-footer .footer-section.secondary{padding:.75rem 2rem}.page-footer .footer-section.secondary .footer-wrapper{text-align:center}html[data-theme=lp] .page-footer .footer-section.secondary{background:#f1ebdc;color:#6d5b2c}html[data-theme=lp] .page-footer .footer-section.secondary .footer-wrapper .caption{color:#6d5b2c}html[data-theme=gp] .page-footer .footer-section.secondary{background:#dedede;color:#6d6c6c}html[data-theme=gp] .page-footer .footer-section.secondary .footer-wrapper .caption{color:#6d6c6c}.validation-error-tooltip{border-radius:4px 4px 4px 0;border:1px solid;position:absolute;display:inline-flex;align-items:center;gap:.2rem;z-index:2;white-space:nowrap;width:fit-content;padding:.35rem;top:-36px;left:75%;right:0;animation:appear .1s;font-size:.8rem;animation:fade-out .5s forwards;animation-delay:6s}.validation-error-tooltip:after{content:"";height:14px;width:14px;background:transparent;position:absolute;bottom:0;left:0;transform:translateY(70%);border:1px solid #D2CFC1;rotate:48deg;clip-path:polygon(50% 50%,100% 0%,100% 100%,50% 50%)}.validation-error-tooltip:before{content:"";height:10px;width:10px;position:absolute;bottom:0;left:-1px;border:1px solid;border-top:none;transform:translateY(100%);clip-path:polygon(0 0,100% 0,0 100%)}html[data-theme=lp] .validation-error-tooltip,html[data-theme=lp] .validation-error-tooltip:before,html[data-theme=lp] .validation-error-tooltip:after{border-color:#d2cfc1}html[data-theme=lp] .validation-error-tooltip:not(:after),html[data-theme=lp] .validation-error-tooltip:before:not(:after),html[data-theme=lp] .validation-error-tooltip:after:not(:after){background:#f2f1ec}html[data-theme=gp] .validation-error-tooltip{border-color:#bdbcbc;background:#ececec}html[data-theme=gp] .validation-error-tooltip:before{border-color:#bdbcbc;background:#ececec}html[data-theme=gp] .validation-error-tooltip:after{border-color:#bdbcbc}.loading-bars,.loading-bars:before,.loading-bars:after{-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loading-bars{text-indent:-9999em;font-size:11px;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s;position:absolute;left:50%;transform:translate(-50%);z-index:100}.loading-bars.overlay{position:fixed;top:40%;left:50%}html[data-theme=gp] .loading-bars{background:#0f9248;color:#0f9248}html[data-theme=lp] .loading-bars{background:#e49640;color:#e49640}.loading-bars:before,.loading-bars:after{position:absolute;content:""}.loading-bars:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}html[data-theme=gp] .loading-bars:before{background:#0f9248;color:#0f9248}html[data-theme=lp] .loading-bars:before{background:#e49640;color:#e49640}.loading-bars:after{left:1.5em}html[data-theme=gp] .loading-bars:after{background:#0f9248;color:#0f9248}html[data-theme=lp] .loading-bars:after{background:#e49640;color:#e49640}@-webkit-keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{box-shadow:0 0;height:4em}40%{box-shadow:0 -2em;height:5em}}.loading-circle{display:inline-flex;position:relative;vertical-align:sub;width:1em;height:1em;animation:spin 1s linear infinite}.loading-circle.large{font-size:1.5em}.loading-circle .icon{color:inherit}html[data-theme=lp] .loading-circle.color .icon{color:#e49640}html[data-theme=gp] .loading-circle.color .icon{color:#036e36}.loading-circle.overlay{display:block;font-size:5rem;position:fixed;z-index:100;top:40%;left:50%;margin-left:-3.5rem}.loading-backdrop{position:fixed;z-index:99;top:0;left:0;width:100vw;height:100vh;background:#00000040}.loading-gears-wrapper{min-height:100vh;min-width:100vw;background-color:#0000004d;position:fixed;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:absolute;top:0;left:0}.loading-gears-wrapper img{margin:0;padding:0}.loading-gears-text{max-height:7rem;width:auto;position:fixed;top:45%;left:48%}@media only screen and (max-width:600px){.loading-gears-text{left:35%}}.loading-gears-span{-webkit-animation:flickerAnimation 1.4s infinite;animation:flickerAnimation 1.4s infinite}.loading-gears-span-2{-webkit-animation:flickerAnimation 1.5s infinite;animation:flickerAnimation 1.5s infinite}.loading-gears-span-3{-webkit-animation:flickerAnimation 1.6s infinite;animation:flickerAnimation 1.6s infinite}.loading-gears-icon{max-height:4rem;width:auto;filter:invert(20%) sepia(8%) saturate(81%) hue-rotate(22deg) brightness(100%) contrast(90%);position:fixed;top:40%;text-indent:-9999em;margin-top:88px;left:99%;-webkit-animation:roll-out-left 1.5s ease-in infinite both;animation:roll-out-left 1.5s ease-in infinite both;-webkit-animation-delay:.1s;animation-delay:.1s}.loading-gears-icon-2{max-height:4rem;width:auto;filter:invert(20%) sepia(8%) saturate(81%) hue-rotate(22deg) brightness(100%) contrast(90%);position:fixed;top:40%;text-indent:-9999em;margin-top:88px;left:99%;-webkit-animation:roll-out-left 1.5s ease-in infinite both;animation:roll-out-left 1.5s ease-in infinite both;-webkit-animation-delay:.3s;animation-delay:.3s}.loading-gears-icon-3{max-height:4rem;width:auto;filter:invert(20%) sepia(8%) saturate(81%) hue-rotate(22deg) brightness(100%) contrast(90%);position:fixed;top:40%;text-indent:-9999em;margin-top:88px;left:99%;-webkit-animation:roll-out-left 1.5s ease-in infinite both;animation:roll-out-left 1.5s ease-in infinite both;-webkit-animation-delay:.5s;animation-delay:.5s}.loading-gears-icon-4{max-height:4rem;width:auto;filter:invert(20%) sepia(8%) saturate(81%) hue-rotate(22deg) brightness(100%) contrast(90%);position:fixed;top:40%;text-indent:-9999em;margin-top:88px;left:99%;-webkit-animation:roll-out-left 1.5s ease-in infinite both;animation:roll-out-left 1.5s ease-in infinite both;-webkit-animation-delay:.8s;animation-delay:.8s}@-webkit-keyframes roll-out-left{0%{-webkit-transform:translateX(0) rotate(0deg);transform:translate(0) rotate(0);opacity:1}to{-webkit-transform:translateX(-1000px) rotate(-540deg);transform:translate(-1000px) rotate(-540deg);opacity:0}}@keyframes roll-out-left{0%{-webkit-transform:translateX(0) rotate(0deg);transform:translate(0) rotate(0);opacity:1}to{-webkit-transform:translateX(-1000px) rotate(-540deg);transform:translate(-1000px) rotate(-540deg);opacity:0}}@media only screen and (min-width:1000px){@keyframes roll-out-left{0%{-webkit-transform:translateX(0) rotate(0deg);transform:translate(0) rotate(0);opacity:1}to{-webkit-transform:translateX(-1800px) rotate(-540deg);transform:translate(-1800px) rotate(-540deg);opacity:0}}@-webkit-keyframes roll-out-left{0%{-webkit-transform:translateX(0) rotate(0deg);transform:translate(0) rotate(0);opacity:1}to{-webkit-transform:translateX(-1800px) rotate(-540deg);transform:translate(-1800px) rotate(-540deg);opacity:0}}}@keyframes flickerAnimation{0%{opacity:1}50%{opacity:0}to{opacity:1}}@-webkit-keyframes flickerAnimation{0%{opacity:1}50%{opacity:0}to{opacity:1}}.logo img{height:100%;object-fit:contain}html[data-theme=lp] dialog.modal{color:#52504a;background-color:#fbfbf9}html[data-theme=gp] dialog.modal{color:#525252;background-color:#fafafa}dialog.modal{border:0;padding:1.5rem;position:fixed;left:50vw;right:-50vw;top:10vh;max-width:min(1200px,95%);max-height:80vh;transform:translate(-50%);box-shadow:#0003 0 12px 28px,#0000001a 0 2px 4px,#ffffff0d 0 0 0 1px inset;animation:drop-in .2s}dialog.modal::backdrop{background:#0000004d}dialog.modal:focus{outline:none}dialog.modal.medium{width:clamp(50%,460px,95%)}dialog.modal.full{width:100%}dialog.modal:not([open]){display:none}dialog.modal.blur::backdrop{-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}.page-header{width:100%}@media screen and (max-width:1300px){.page-header{position:sticky;top:0;z-index:10}}.header-navigation{display:flex;flex-direction:column;justify-content:center;align-items:stretch;flex-wrap:nowrap}.header-navigation nav .nav-wrapper{display:flex;flex-direction:row;justify-content:flex-end;align-items:stretch;flex-wrap:nowrap}.header-navigation nav .nav-link-wrapper{display:flex;flex-direction:row;justify-content:center;align-items:stretch;flex-wrap:nowrap;position:relative}.header-navigation nav .nav-link{display:inline-flex;align-items:center;gap:.25rem}.header-navigation nav .nav-link:hover{cursor:pointer}.header-navigation nav .nav-link.space{justify-content:space-between}.header-navigation nav .nav-link .icon{font-size:1.2em}.header-navigation nav.primary span.text-loading{display:inline-block;width:100px;height:1rem;animation:skeleton-pulse .5s infinite;animation-direction:alternate;animation-timing-function:linear}.header-navigation nav.primary .logo{height:60px}@media screen and (max-width:984px){.header-navigation nav.primary .logo{height:48px}}.header-navigation nav.primary .nav-link{font-size:.8rem;padding:0;line-height:normal}.header-navigation nav.primary .nav-link:hover{text-decoration:underline}.header-navigation nav.primary .nav-wrapper{justify-content:space-between;align-items:flex-start;padding:1rem}.header-navigation nav.primary .nav-wrapper .nav-link-wrapper{gap:1rem}.header-navigation nav.primary .nav-wrapper .separator{width:1.5px;height:1rem}.header-navigation nav.primary .nav-wrapper .current-dealer{text-transform:uppercase;margin-top:1rem}.header-navigation nav.primary .nav-wrapper .current-dealer span.text-loading{width:340px;height:1.25rem}html[data-theme=lp] .header-navigation nav.primary span.text-loading{background-color:#2c4763}html[data-theme=lp] .header-navigation nav.primary .nav-link{color:#fbfbf9}html[data-theme=lp] .header-navigation nav.primary .nav-link .icon{color:#e49640}html[data-theme=lp] .header-navigation nav.primary .nav-link.user-account .icon{color:#fbfbf9}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper{background:#1d2f42}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper .separator{background:#fbfbf9}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper .current-dealer{color:#fbfbf9}html[data-theme=gp] .header-navigation nav.primary span.text-loading{background-color:#036e36}html[data-theme=gp] .header-navigation nav.primary .nav-link{color:#fafafa}html[data-theme=gp] .header-navigation nav.primary .nav-link .icon{color:#f7b145}html[data-theme=gp] .header-navigation nav.primary .nav-link.user-account .icon{color:#fafafa}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper{background:#00602a}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper .separator{background:#fafafa}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper .current-dealer{color:#fafafa}.header-navigation nav.secondary .nav-link{font-weight:700;font-size:.85rem;text-transform:uppercase;padding:.5rem}.header-navigation nav.secondary .nav-link:hover{text-decoration:none}html[data-theme=lp] .header-navigation nav.secondary .nav-wrapper{background:#e49640}html[data-theme=lp] .header-navigation nav.secondary .nav-wrapper .nav-link{color:#fbfbf9}html[data-theme=lp] .header-navigation nav.secondary .nav-wrapper .nav-link:hover{background:#fcb96e}html[data-theme=gp] .header-navigation nav.secondary .nav-wrapper{background:#000}html[data-theme=gp] .header-navigation nav.secondary .nav-wrapper .nav-link{color:#fafafa}html[data-theme=gp] .header-navigation nav.secondary .nav-wrapper .nav-link:hover{background:#333}@media screen and (max-width:984px){.header-navigation nav .nav-link{padding:1.25rem;font-size:1.25rem}.header-navigation nav.primary span.text-loading{width:200px;min-height:1.25rem}.header-navigation nav.primary .menu-toggle{padding:1rem;color:#fff;font-size:1.75rem}.header-navigation nav.primary .menu-toggle:hover{cursor:pointer}.header-navigation nav.primary .nav-wrapper{align-items:center;position:relative}.header-navigation nav.primary .nav-wrapper .current-dealer{margin-top:.5rem}.header-navigation nav.primary .nav-wrapper .current-dealer span.text-loading{width:240px;height:1.25rem}.header-navigation nav.primary .nav-wrapper .primary-menu{z-index:2;position:absolute;top:100%;left:0;width:100vw;align-items:stretch}.header-navigation nav.primary .nav-wrapper .primary-menu .separator{display:none}.header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper{gap:0;flex-direction:column;flex-grow:1}.header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link{order:10;padding:1.5rem;font-size:1rem;border-top:1px solid}.header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link.user-account{order:1;justify-content:space-between;border-top:none;font-size:1.25rem}.header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link.user-account .mobile-only{font-size:1rem}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper .primary-menu{background-color:#1d2f42}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link{border-top-color:#2c4763}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link.user-account .mobile-only .icon{color:#e49640}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper.mobile-only{background:#e49640}html[data-theme=lp] .header-navigation nav.primary .nav-wrapper.mobile-only .nav-link{color:#fbfbf9;border-bottom:1px solid #ffd594}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper .primary-menu{background-color:#f7b145}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link{border-top-color:#ffc46a}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper .primary-menu .nav-link-wrapper .nav-link.user-account .mobile-only .icon{color:#fafafa}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper.mobile-only{background:#f7b145}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper.mobile-only .nav-link{border-bottom:1px solid #ffd594}html[data-theme=gp] .header-navigation nav.primary .nav-wrapper.mobile-only .nav-link:hover{background:#ffc46a}.header-navigation nav.secondary .nav-wrapper{overflow:auto}.header-navigation nav.secondary .nav-wrapper .nav-link-wrapper{max-width:100%;white-space:nowrap;position:static}html[data-theme=lp] .header-navigation nav.secondary .nav-wrapper{background:#e49640}html[data-theme=gp] .header-navigation nav.secondary .nav-wrapper{background:#f7b145}html[data-theme=gp] .header-navigation nav.secondary .nav-wrapper .nav-link:hover{background:#ffc46a}.header-navigation nav.secondary .nav-link{font-weight:500;font-size:.85rem}}.progress-bar{width:100%;background-color:#fbfbf9}.progress-bar.no-background{background-color:transparent}.progress-bar .progress-bar-steps{display:flex;flex-direction:row;justify-content:space-between;align-items:stretch;flex-wrap:nowrap;width:100%;margin:0;padding:0;list-style:none}.progress-bar .progress-bar-step{display:flex;flex-direction:column;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;flex:1 1 0;min-width:0}.progress-bar .progress-bar-button{display:flex;flex-direction:row;justify-content:center;align-items:center;flex-wrap:nowrap;gap:.5rem;width:100%;height:100%;padding:.75rem .5rem;background-color:transparent;border:none;border-bottom:3px solid transparent;border-radius:0;box-shadow:none;font-family:Roboto,Arial,sans-serif;font-size:1rem;color:inherit;transition:border-color .3s ease,color .3s ease}.progress-bar .progress-bar-button:not([disabled]){cursor:pointer}.progress-bar .progress-bar-button:hover:not([disabled]){background-color:#e8e8e8}html[data-theme=lp] .progress-bar .progress-bar-button:hover:not([disabled]){background-color:#e8e7de}html[data-theme=gp] .progress-bar .progress-bar-button:hover:not([disabled]){background-color:#e8e8e8}.progress-bar .progress-bar-button[disabled]{cursor:default;opacity:1;background-color:transparent!important;color:inherit!important}.progress-bar .progress-bar-button:focus-visible{outline:2px solid currentColor;outline-offset:-2px}.progress-bar .progress-bar-indicator{display:flex;flex-direction:row;justify-content:center;align-items:center;flex-wrap:nowrap;flex:0 0 auto;width:1.5rem;height:1.5rem;background-color:transparent;color:#9a9a9a;font-size:.8rem;font-weight:500;line-height:1;transition:background-color .3s ease,border-color .3s ease,color .3s ease}.progress-bar .progress-bar-indicator .icon{font-size:1.25rem;color:currentColor}.progress-bar .progress-bar-label{min-width:0;font-size:.9rem;font-weight:500;line-height:1.25em;overflow-wrap:anywhere;color:#9a9a9a}.progress-bar .progress-bar-label.mobile{display:none}html[data-theme=gp] .progress-bar .progress-bar-step.completed .progress-bar-button{border-bottom-color:#036e36}html[data-theme=gp] .progress-bar .progress-bar-step.completed .progress-bar-indicator{border-color:#036e36;color:#036e36}html[data-theme=gp] .progress-bar .progress-bar-step.completed .progress-bar-label{color:#6d6c6c}html[data-theme=gp] .progress-bar .progress-bar-step.available .progress-bar-button{border-bottom-color:#036e36}html[data-theme=gp] .progress-bar .progress-bar-step.available .progress-bar-label{color:#9a9a9a}html[data-theme=gp] .progress-bar .progress-bar-step.active .progress-bar-button{border-bottom-color:#036e36}html[data-theme=gp] .progress-bar .progress-bar-step.active .progress-bar-indicator,html[data-theme=gp] .progress-bar .progress-bar-step.active .progress-bar-label{color:#036e36}html[data-theme=lp] .progress-bar .progress-bar-step.completed .progress-bar-button{border-bottom-color:#e49640}html[data-theme=lp] .progress-bar .progress-bar-step.completed .progress-bar-indicator{border-color:#e49640;color:#e49640}html[data-theme=lp] .progress-bar .progress-bar-step.completed .progress-bar-label{color:#e49640}html[data-theme=lp] .progress-bar .progress-bar-step.available .progress-bar-button{border-bottom-color:#e49640}html[data-theme=lp] .progress-bar .progress-bar-step.available .progress-bar-label{color:#9a9a9a}html[data-theme=lp] .progress-bar .progress-bar-step.active .progress-bar-button{border-bottom-color:#e49640}html[data-theme=lp] .progress-bar .progress-bar-step.active .progress-bar-indicator,html[data-theme=lp] .progress-bar .progress-bar-step.active .progress-bar-label{color:#e49640}@media screen and (max-width:564px){.progress-bar .progress-bar-button{gap:.35rem;padding:.5rem .25rem}.progress-bar .progress-bar-label{font-size:.8rem}.progress-bar.mobile-labels-short .progress-bar-label:not(.mobile){display:none}.progress-bar.mobile-labels-short .progress-bar-label.mobile{display:inline}.progress-bar.mobile-labels-none .progress-bar-label{display:none}}.quick-links-menu{display:none;position:absolute;top:100%;right:0;padding:1rem;box-shadow:#0000004d 0 1px 2px,#00000026 0 2px 4px;width:320px;white-space:normal;z-index:2}.quick-links-menu:hover{display:flex}.quick-links-menu .category-heading{font-size:1.15rem}.quick-links-menu .icon{display:inline;color:#366b96}.quick-links-menu ul{margin:.5rem 0}.quick-links-menu ul li{padding:0}.quick-links-menu ul li a{display:inline-flex;padding:.25rem 0;line-height:1.5rem}html[data-theme=lp] .quick-links-menu{background:#fbfbf9}html[data-theme=lp] .quick-links-menu .message{color:#a8a699}html[data-theme=lp] .quick-links-menu .category-heading .icon{color:#e49640}html[data-theme=gp] .quick-links-menu{background:#fafafa}html[data-theme=gp] .quick-links-menu .message{color:#a8a8a8}html[data-theme=gp] .quick-links-menu .category-heading .icon{color:inherit}#quick-links-menu-button:hover+.quick-links-menu{display:flex}@media screen and (max-width:984px){#quick-links-menu-button:not(.active){background:initial}#quick-links-menu-button:not(.active)+.quick-links-menu{display:none}#quick-links-menu-button.active+.quick-links-menu{display:flex}}.switch-dealer-modal.modal{display:flex;flex-direction:column;justify-content:stretch;align-items:stretch;flex-wrap:nowrap;gap:1rem;width:550px;max-width:85vw;height:100%;border-radius:8px}html[data-theme=lp] .switch-dealer-modal.modal{background:#f2f1ec}html[data-theme=lp] .switch-dealer-modal.modal .dealer-block{background-color:#fbfbf9}html[data-theme=gp] .switch-dealer-modal.modal{background:#f5f5f5}html[data-theme=gp] .switch-dealer-modal.modal .dealer-block{background-color:#fafafa}.switch-dealer-modal.modal .dealer-wrapper{gap:1.5rem}.switch-dealer-modal.modal .dealer-wrapper .block-heading{font-weight:700;text-transform:uppercase}.switch-dealer-modal.modal .dealer-wrapper .dealer-search{padding:1rem}.switch-dealer-modal.modal .dealer-wrapper .dealer-search .input-wrapper{width:90%;font-size:1.5rem}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper{gap:1rem}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper .dealer-block{border-radius:4px}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper .dealer-block .dealer-info{gap:0}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper .dealer-block .dealer-info .dealer-name{font-weight:500}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper .dealer-block .dealer-info .dealer-number{font-size:.9rem}.switch-dealer-modal.modal .dealer-wrapper .dealer-block-wrapper .dealer-block .dealer-info .dealer-number:before{content:"#"}aside.sidebar-container{width:380px;flex-shrink:0}aside.sidebar-container .sidebar-wrapper{flex-grow:1}html[data-theme=gp] aside.side-drawer{background-color:#fafafa}html[data-theme=gp] aside.side-drawer .side-drawer-toggle:hover,html[data-theme=gp] aside.side-drawer .side-drawer-toggle:focus,html[data-theme=gp] aside.side-drawer .side-drawer-toggle:active{background-color:#036e36!important}html[data-theme=lp] aside.side-drawer{background-color:#fbfbf9}html[data-theme=lp] aside.side-drawer .side-drawer-toggle:hover,html[data-theme=lp] aside.side-drawer .side-drawer-toggle:focus,html[data-theme=lp] aside.side-drawer .side-drawer-toggle:active{background-color:#e49640!important}aside.side-drawer{height:100%;width:380px;max-width:90vw;transform:translate(100%);position:absolute;top:0;right:0;z-index:5;box-shadow:-4px 0 12px #00000059;transition:transform .2s ease-out}aside.side-drawer:before{content:"";visibility:hidden;width:100vw;height:100%;position:absolute;right:100%;transition:background-color .3s;background-color:#0000}aside.side-drawer .side-drawer-toggle{display:block;position:absolute;right:100%;top:33%;padding:1.5rem .5rem;border-top-right-radius:0;border-bottom-right-radius:0;box-shadow:-4px 0 12px #00000059}aside.side-drawer .side-drawer-toggle .icon{transition:transform .2s;display:inline-block}aside.side-drawer .side-drawer-scroll-region{display:flex;flex-direction:column;justify-content:stretch;align-items:stretch;flex-wrap:nowrap;min-height:0;overflow-y:auto;height:100%;width:100%}aside.side-drawer.show{transform:translate(0)}aside.side-drawer.show:before{visibility:visible;background-color:#00000059}aside.side-drawer.show .side-drawer-toggle .icon{transform:rotate(180deg)}.style-guide-container section{margin:2rem 0}.style-guide-container .sample-text{color:#00000059}.style-guide-container #blocks_containers{font-size:1.25rem}.style-guide-container #blocks_containers .flex-col,.style-guide-container #blocks_containers .flex-row,.style-guide-container #blocks_containers .flex-inline{border:1px dashed magenta;margin:.5rem 0}.style-guide-container #blocks_containers .flex-group{display:flex;flex-direction:column}.style-guide-container #blocks_containers .flex-group.full{align-self:stretch}.style-guide-container #blocks_containers .flex-group{border:1px dashed magenta}.style-guide-container #blocks_containers .flex-group .flex-row,.style-guide-container #blocks_containers .flex-group .flex-col{border:none}.style-guide-container #blocks_containers .grid{border:1px dashed magenta}.style-guide-container fieldset{border:1px dashed orangered}.style-guide-container fieldset.stretch label{border:1px dashed indigo}.tabbed-content-container{gap:0}.tabbed-content-container .tab-content-container{width:100%;border:1px solid #bdbcbc}html[data-theme=gp] .tabbed-content-container .tab-content-container{background:#fafafa}html[data-theme=lp] .tabbed-content-container .tab-content-container{background:#fbfbf9}.tabs-container{width:100%}.tabs-container .tabs-wrapper{gap:0;align-items:stretch}.tabs-container .tabs-wrapper .tab{display:flex;gap:.25rem;font-weight:500;transition:none;white-space:normal;word-wrap:break-word;line-height:1.25em;min-width:min-content;border:1px solid;border-radius:0;border-bottom-color:transparent;margin-bottom:-1px;box-shadow:none;padding:.5rem}.tabs-container .tabs-wrapper .tab:not(:last-child){border-right-color:transparent!important}html[data-theme=gp] .tabs-container .tabs-wrapper .tab{background-color:#ececec;color:#525252;border-color:#bdbcbc}html[data-theme=lp] .tabs-container .tabs-wrapper .tab{background-color:#f2f1ec;color:#52504a;border-color:#cfcbc0}html[data-theme=gp] .tabs-container .tabs-wrapper .tab:hover{color:#036e36;background-color:#ececec}html[data-theme=lp] .tabs-container .tabs-wrapper .tab:hover{color:#e49640;background-color:#f2f1ec}.tabs-container .tabs-wrapper .tab.selected{z-index:1}.tabs-container .tabs-wrapper .tab.selected .icon{color:currentColor}html[data-theme=gp] .tabs-container .tabs-wrapper .tab.selected{color:#036e36;background-color:#fafafa;border-bottom-color:#fafafa}html[data-theme=lp] .tabs-container .tabs-wrapper .tab.selected{color:#e49640;background-color:#fbfbf9;border-bottom-color:#fbfbf9}.content-table-container{width:100%;overflow:auto;gap:1.5rem;padding-bottom:1rem}.content-table-container .content-table{font-size:.9rem;min-width:690px}.content-table-container .content-table:not(.nostyle) tr,.content-table-container .content-table:not(.nostyle) td,.content-table-container .content-table:not(.nostyle) th{border:none}.content-table-container .content-table:not(.nostyle) thead,.content-table-container .content-table:not(.nostyle) th{background:transparent!important}.content-table-container .content-table:not(.nostyle) tbody tr{border-bottom:1px solid}html[data-theme=lp] .content-table-container .content-table:not(.nostyle) tbody tr{border-bottom-color:#d2cfc1}html[data-theme=gp] .content-table-container .content-table:not(.nostyle) tbody tr{border-bottom-color:#bdbcbc}.content-table-container .content-table:not(.nostyle){border:none}.content-table-container .content-table:not(.nostyle) thead{border-bottom:2px solid;font-size:1.1em}html[data-theme=lp] .content-table-container .content-table:not(.nostyle) thead{border-bottom-color:#e49640}html[data-theme=gp] .content-table-container .content-table:not(.nostyle) thead{border-bottom-color:#bdbcbc}.content-table-container .content-table:not(.nostyle) tbody td{padding:.8rem .5rem}.content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper{gap:.25rem}.content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper .pagination-button{padding:0;width:2rem;height:2rem;border-radius:50%;transition-duration:0ms}html[data-theme=lp] .content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper .pagination-button:hover{background-color:#e4964040}html[data-theme=gp] .content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper .pagination-button:hover{background-color:#0f924840}html[data-theme=lp] .content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper .pagination-button.selected{background-color:#e4964040}html[data-theme=gp] .content-table-container .content-table:not(.nostyle) tfoot.pagination .pagination-wrapper .pagination-button.selected{background-color:#0f924840}html[data-theme=lp] body .date-picker .rdp-root{--rdp-accent-color: #e49640;--rdp-accent-background-color: rgba(228, 150, 64, .25);--rdp-range_middle-background-color: rgba(228, 150, 64, .25)}html[data-theme=gp] body .date-picker .rdp-root{--rdp-accent-color: #036e36;--rdp-accent-background-color: rgba(15, 146, 72, .25);--rdp-range_middle-background-color: rgba(15, 146, 72, .25)}html[data-theme=gp] body .date-picker .rdp-root thead,html[data-theme=gp] body .date-picker .rdp-root th{background-color:transparent}body .date-picker .rdp-root td.rdp-day.rdp-disabled .rdp-day_button[disabled]{background-color:transparent!important}body .date-picker .rdp-root button{min-width:0;background-color:transparent;color:currentColor;box-shadow:none}body .date-picker .rdp-root button:hover{background-color:transparent}body .date-picker .rdp-root button svg{fill:currentColor}body .date-picker .rdp-root table{border:none}body .date-picker .rdp-root table thead{background-color:transparent}body .date-picker .rdp-root table thead,body .date-picker .rdp-root table tbody,body .date-picker .rdp-root table tfoot,body .date-picker .rdp-root table th,body .date-picker .rdp-root table tr,body .date-picker .rdp-root table td{border:none;padding:0}body .date-picker .rdp-root table tbody tr:nth-child(2n),body .date-picker .rdp-root table tbody tr:nth-child(odd){background:transparent}body .date-picker .rdp-root table tbody .rdp-range_start .rdp-day_button,body .date-picker .rdp-root table tbody .rdp-range_end .rdp-day_button{background-color:var(--rdp-accent-color);color:var(--rdp-range_start-color)}.date-picker-input{position:relative}.date-picker-input .date-clear-button{position:absolute;right:1.5rem;top:50%;transform:translateY(-50%)}.date-picker-input .date-picker-popup{position:absolute;padding:1rem;box-shadow:#0003 0 12px 28px,#0000001a 0 2px 4px,#ffffff0d 0 0 0 1px inset;border-radius:4px}html[data-theme=lp] .date-picker-input .date-picker-popup{background-color:#fbfbf9}html[data-theme=gp] .date-picker-input .date-picker-popup{background-color:#fafafa}.animate{transition:all .2s}.rotate-90-cw{transform:rotate(90deg)}@keyframes drop-in{0%{opacity:0;margin-top:-15px}to{opacity:1;margin-top:0}}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes fade-out{0%{opacity:100%}to{opacity:0%}}@keyframes skeleton-pulse{0%{filter:brightness(100%)}to{filter:brightness(95%)}}.info-tooltip{position:relative;display:inline-block;--info-tooltip-popup-top: calc(100% + .5rem) ;--info-tooltip-popup-bottom: auto;--info-tooltip-popup-left: 50%;--info-tooltip-popup-right: auto;--info-tooltip-popup-translate-x: -50%;--info-tooltip-popup-translate-y: 0;--info-tooltip-arrow-top: -6px;--info-tooltip-arrow-bottom: auto;--info-tooltip-arrow-left: 50%;--info-tooltip-arrow-right: auto;--info-tooltip-arrow-translate-x: -50%;--info-tooltip-arrow-translate-y: 0}.info-tooltip .info-tooltip-icon{display:inline-flex;cursor:help}.info-tooltip .info-tooltip-icon:hover+.info-tooltip-popup{opacity:1;visibility:visible}html[data-theme=lp] .info-tooltip .info-tooltip-icon{color:#e49640}html[data-theme=gp] .info-tooltip .info-tooltip-icon{color:#036e36}.info-tooltip .info-tooltip-popup{position:absolute;top:var(--info-tooltip-popup-top);bottom:var(--info-tooltip-popup-bottom);left:var(--info-tooltip-popup-left);right:var(--info-tooltip-popup-right);transform:translate(var(--info-tooltip-popup-translate-x),var(--info-tooltip-popup-translate-y));width:250px;padding:.75rem;box-shadow:0 4px 12px #00000026;opacity:0;visibility:hidden;transition:opacity .15s ease;z-index:1000}.info-tooltip .info-tooltip-popup:hover{opacity:1;visibility:visible}html[data-theme=lp] .info-tooltip .info-tooltip-popup{background-color:#fbfbf9}html[data-theme=lp] .info-tooltip .info-tooltip-popup:before{background-color:#fbfbf9}html[data-theme=gp] .info-tooltip .info-tooltip-popup{background-color:#fafafa}html[data-theme=gp] .info-tooltip .info-tooltip-popup:before{background-color:#fafafa}.info-tooltip .info-tooltip-popup:before{content:"";position:absolute;top:var(--info-tooltip-arrow-top);bottom:var(--info-tooltip-arrow-bottom);left:var(--info-tooltip-arrow-left);right:var(--info-tooltip-arrow-right);transform:translate(var(--info-tooltip-arrow-translate-x),var(--info-tooltip-arrow-translate-y)) rotate(45deg);width:12px;height:12px}.info-tooltip .info-tooltip-popup .info-tooltip-title{font-weight:600;margin-bottom:.5rem}.info-tooltip .info-tooltip-popup .info-tooltip-content{font-size:.875rem;line-height:1.4}.info-tooltip--v-top{--info-tooltip-popup-top: auto;--info-tooltip-popup-bottom: calc(100% + .5rem) ;--info-tooltip-popup-translate-y: 0;--info-tooltip-arrow-top: auto;--info-tooltip-arrow-bottom: -6px;--info-tooltip-arrow-translate-y: 0}.info-tooltip--v-center{--info-tooltip-popup-top: 50%;--info-tooltip-popup-bottom: auto;--info-tooltip-popup-translate-y: -50%;--info-tooltip-arrow-top: 50%;--info-tooltip-arrow-bottom: auto;--info-tooltip-arrow-translate-y: -50%}.info-tooltip--v-bottom{--info-tooltip-popup-top: calc(100% + .5rem) ;--info-tooltip-popup-bottom: auto;--info-tooltip-popup-translate-y: 0;--info-tooltip-arrow-top: -6px;--info-tooltip-arrow-bottom: auto;--info-tooltip-arrow-translate-y: 0}.info-tooltip--h-left{--info-tooltip-popup-left: auto;--info-tooltip-popup-right: calc(100% + .5rem) ;--info-tooltip-popup-translate-x: 0;--info-tooltip-arrow-left: auto;--info-tooltip-arrow-right: -6px;--info-tooltip-arrow-translate-x: 0}.info-tooltip--h-center{--info-tooltip-popup-left: 50%;--info-tooltip-popup-right: auto;--info-tooltip-popup-translate-x: -50%;--info-tooltip-arrow-left: 50%;--info-tooltip-arrow-right: auto;--info-tooltip-arrow-translate-x: -50%}.info-tooltip--h-right{--info-tooltip-popup-left: calc(100% + .5rem) ;--info-tooltip-popup-right: auto;--info-tooltip-popup-translate-x: 0;--info-tooltip-arrow-left: -6px;--info-tooltip-arrow-right: auto;--info-tooltip-arrow-translate-x: 0}.info-tooltip.info-tooltip--h-right.info-tooltip--v-bottom .info-tooltip-popup:before,.info-tooltip.info-tooltip--h-left.info-tooltip--v-bottom .info-tooltip-popup:before{clip-path:polygon(100% 100%,100% 0,0 100%)}.info-tooltip.info-tooltip--h-right.info-tooltip--v-top .info-tooltip-popup:before,.info-tooltip.info-tooltip--h-left.info-tooltip--v-top .info-tooltip-popup:before{clip-path:polygon(0 0,100% 0,0 100%)}')),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import F, { useRef as _t, useLayoutEffect as pl, useEffect as cn, Children as bu, isValidElement as vu, useState as Pe, Component as xu, createContext as wu, useContext as Tu, useCallback as Et, useMemo as Fi } from "react";
import { AppGlobalContext as ku, AppGlobalUpdateContext as Eu, ThemeContext as Su, ThemeUpdateContext as Nu } from "@gplibraries/react/context";
import { useMsal as gl, useIsAuthenticated as _l, MsalProvider as Ou } from "@azure/msal-react";
import { EventType as Cu, PublicClientApplication as ju, InteractionStatus as Du } from "@azure/msal-browser";
import { useNavigate as no, useLocation as ts, Outlet as ro, Link as Ve, Navigate as Mu } from "react-router";
import { useQuery as ir, useMutation as Ho } from "@tanstack/react-query";
import { useLogger as io, useTheme as sr, useTokenProvider as ns, useAuthorizer as rs, useBreakpoint as yl, useConfig as is, useDealerInfo as so, useDealerMask as Au, useAssociatedDealers as oo, useDealerSwitch as Ru, useQuickLinks as Pu, usePagination as Iu, useSessionStorage as Lu, useAppContext as Fu } from "@gplibraries/react/hooks";
import { fetchDealerDivisions as Wu, fetchUserMask as Yu, removeUserMask as Bu, updateUserMask as zu, fetchActiveAlerts as Uu } from "@gplibraries/react/api";
import { iconMap as Hu } from "@gplibraries/react/config";
function bl(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Ci = { exports: {} }, Wr = {};
var Go;
function Gu() {
  if (Go) return Wr;
  Go = 1;
  var r = F, e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, c, u) {
    var f, d = {}, p = null, _ = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (_ = c.ref);
    for (f in c) n.call(c, f) && !s.hasOwnProperty(f) && (d[f] = c[f]);
    if (a && a.defaultProps) for (f in c = a.defaultProps, c) d[f] === void 0 && (d[f] = c[f]);
    return { $$typeof: e, type: a, key: p, ref: _, props: d, _owner: i.current };
  }
  return Wr.Fragment = t, Wr.jsx = o, Wr.jsxs = o, Wr;
}
var Yr = {};
var qo;
function qu() {
  return qo || (qo = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = F, e = /* @__PURE__ */ Symbol.for("react.element"), t = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), s = /* @__PURE__ */ Symbol.for("react.profiler"), o = /* @__PURE__ */ Symbol.for("react.provider"), a = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), u = /* @__PURE__ */ Symbol.for("react.suspense"), f = /* @__PURE__ */ Symbol.for("react.suspense_list"), d = /* @__PURE__ */ Symbol.for("react.memo"), p = /* @__PURE__ */ Symbol.for("react.lazy"), _ = /* @__PURE__ */ Symbol.for("react.offscreen"), v = Symbol.iterator, m = "@@iterator";
    function y(T) {
      if (T === null || typeof T != "object")
        return null;
      var M = v && T[v] || T[m];
      return typeof M == "function" ? M : null;
    }
    var x = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(T) {
      {
        for (var M = arguments.length, L = new Array(M > 1 ? M - 1 : 0), V = 1; V < M; V++)
          L[V - 1] = arguments[V];
        E("error", T, L);
      }
    }
    function E(T, M, L) {
      {
        var V = x.ReactDebugCurrentFrame, ne = V.getStackAddendum();
        ne !== "" && (M += "%s", L = L.concat([ne]));
        var ue = L.map(function(re) {
          return String(re);
        });
        ue.unshift("Warning: " + M), Function.prototype.apply.call(console[T], console, ue);
      }
    }
    var O = !1, h = !1, b = !1, w = !1, C = !1, N;
    N = /* @__PURE__ */ Symbol.for("react.module.reference");
    function j(T) {
      return !!(typeof T == "string" || typeof T == "function" || T === n || T === s || C || T === i || T === u || T === f || w || T === _ || O || h || b || typeof T == "object" && T !== null && (T.$$typeof === p || T.$$typeof === d || T.$$typeof === o || T.$$typeof === a || T.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      T.$$typeof === N || T.getModuleId !== void 0));
    }
    function A(T, M, L) {
      var V = T.displayName;
      if (V)
        return V;
      var ne = M.displayName || M.name || "";
      return ne !== "" ? L + "(" + ne + ")" : L;
    }
    function B(T) {
      return T.displayName || "Context";
    }
    function z(T) {
      if (T == null)
        return null;
      if (typeof T.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof T == "function")
        return T.displayName || T.name || null;
      if (typeof T == "string")
        return T;
      switch (T) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case a:
            var M = T;
            return B(M) + ".Consumer";
          case o:
            var L = T;
            return B(L._context) + ".Provider";
          case c:
            return A(T, T.render, "ForwardRef");
          case d:
            var V = T.displayName || null;
            return V !== null ? V : z(T.type) || "Memo";
          case p: {
            var ne = T, ue = ne._payload, re = ne._init;
            try {
              return z(re(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = Object.assign, I = 0, X, oe, Oe, pe, _e, Ce, ze;
    function jt() {
    }
    jt.__reactDisabledLog = !0;
    function Fe() {
      {
        if (I === 0) {
          X = console.log, oe = console.info, Oe = console.warn, pe = console.error, _e = console.group, Ce = console.groupCollapsed, ze = console.groupEnd;
          var T = {
            configurable: !0,
            enumerable: !0,
            value: jt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: T,
            log: T,
            warn: T,
            error: T,
            group: T,
            groupCollapsed: T,
            groupEnd: T
          });
        }
        I++;
      }
    }
    function J() {
      {
        if (I--, I === 0) {
          var T = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: P({}, T, {
              value: X
            }),
            info: P({}, T, {
              value: oe
            }),
            warn: P({}, T, {
              value: Oe
            }),
            error: P({}, T, {
              value: pe
            }),
            group: P({}, T, {
              value: _e
            }),
            groupCollapsed: P({}, T, {
              value: Ce
            }),
            groupEnd: P({}, T, {
              value: ze
            })
          });
        }
        I < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var un = x.ReactCurrentDispatcher, fn;
    function dn(T, M, L) {
      {
        if (fn === void 0)
          try {
            throw Error();
          } catch (ne) {
            var V = ne.stack.trim().match(/\n( *(at )?)/);
            fn = V && V[1] || "";
          }
        return `
` + fn + T;
      }
    }
    var hn = !1, Dt;
    {
      var Ar = typeof WeakMap == "function" ? WeakMap : Map;
      Dt = new Ar();
    }
    function Pn(T, M) {
      if (!T || hn)
        return "";
      {
        var L = Dt.get(T);
        if (L !== void 0)
          return L;
      }
      var V;
      hn = !0;
      var ne = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = un.current, un.current = null, Fe();
      try {
        if (M) {
          var re = function() {
            throw Error();
          };
          if (Object.defineProperty(re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(re, []);
            } catch (Ge) {
              V = Ge;
            }
            Reflect.construct(T, [], re);
          } else {
            try {
              re.call();
            } catch (Ge) {
              V = Ge;
            }
            T.call(re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ge) {
            V = Ge;
          }
          T();
        }
      } catch (Ge) {
        if (Ge && V && typeof Ge.stack == "string") {
          for (var U = Ge.stack.split(`
`), Se = V.stack.split(`
`), be = U.length - 1, ve = Se.length - 1; be >= 1 && ve >= 0 && U[be] !== Se[ve]; )
            ve--;
          for (; be >= 1 && ve >= 0; be--, ve--)
            if (U[be] !== Se[ve]) {
              if (be !== 1 || ve !== 1)
                do
                  if (be--, ve--, ve < 0 || U[be] !== Se[ve]) {
                    var He = `
` + U[be].replace(" at new ", " at ");
                    return T.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", T.displayName)), typeof T == "function" && Dt.set(T, He), He;
                  }
                while (be >= 1 && ve >= 0);
              break;
            }
        }
      } finally {
        hn = !1, un.current = ue, J(), Error.prepareStackTrace = ne;
      }
      var Jt = T ? T.displayName || T.name : "", Ft = Jt ? dn(Jt) : "";
      return typeof T == "function" && Dt.set(T, Ft), Ft;
    }
    function Rr(T, M, L) {
      return Pn(T, !1);
    }
    function ar(T) {
      var M = T.prototype;
      return !!(M && M.isReactComponent);
    }
    function ae(T, M, L) {
      if (T == null)
        return "";
      if (typeof T == "function")
        return Pn(T, ar(T));
      if (typeof T == "string")
        return dn(T);
      switch (T) {
        case u:
          return dn("Suspense");
        case f:
          return dn("SuspenseList");
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case c:
            return Rr(T.render);
          case d:
            return ae(T.type, M, L);
          case p: {
            var V = T, ne = V._payload, ue = V._init;
            try {
              return ae(ue(ne), M, L);
            } catch {
            }
          }
        }
      return "";
    }
    var Mt = Object.prototype.hasOwnProperty, ce = {}, mn = x.ReactDebugCurrentFrame;
    function We(T) {
      if (T) {
        var M = T._owner, L = ae(T.type, T._source, M ? M.type : null);
        mn.setExtraStackFrame(L);
      } else
        mn.setExtraStackFrame(null);
    }
    function Vt(T, M, L, V, ne) {
      {
        var ue = Function.call.bind(Mt);
        for (var re in T)
          if (ue(T, re)) {
            var U = void 0;
            try {
              if (typeof T[re] != "function") {
                var Se = Error((V || "React class") + ": " + L + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof T[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Se.name = "Invariant Violation", Se;
              }
              U = T[re](M, re, V, L, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (be) {
              U = be;
            }
            U && !(U instanceof Error) && (We(ne), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", V || "React class", L, re, typeof U), We(null)), U instanceof Error && !(U.message in ce) && (ce[U.message] = !0, We(ne), k("Failed %s type: %s", L, U.message), We(null));
          }
      }
    }
    var lr = Array.isArray;
    function Je(T) {
      return lr(T);
    }
    function In(T) {
      {
        var M = typeof Symbol == "function" && Symbol.toStringTag, L = M && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return L;
      }
    }
    function Xt(T) {
      try {
        return Kt(T), !1;
      } catch {
        return !0;
      }
    }
    function Kt(T) {
      return "" + T;
    }
    function Ln(T) {
      if (Xt(T))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", In(T)), Kt(T);
    }
    var ct = x.ReactCurrentOwner, At = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, wt, pn;
    function gn(T) {
      if (Mt.call(T, "ref")) {
        var M = Object.getOwnPropertyDescriptor(T, "ref").get;
        if (M && M.isReactWarning)
          return !1;
      }
      return T.ref !== void 0;
    }
    function _n(T) {
      if (Mt.call(T, "key")) {
        var M = Object.getOwnPropertyDescriptor(T, "key").get;
        if (M && M.isReactWarning)
          return !1;
      }
      return T.key !== void 0;
    }
    function Fn(T, M) {
      typeof T.ref == "string" && ct.current;
    }
    function It(T, M) {
      {
        var L = function() {
          wt || (wt = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", M));
        };
        L.isReactWarning = !0, Object.defineProperty(T, "key", {
          get: L,
          configurable: !0
        });
      }
    }
    function yn(T, M) {
      {
        var L = function() {
          pn || (pn = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", M));
        };
        L.isReactWarning = !0, Object.defineProperty(T, "ref", {
          get: L,
          configurable: !0
        });
      }
    }
    var bn = function(T, M, L, V, ne, ue, re) {
      var U = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: T,
        key: M,
        ref: L,
        props: re,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return U._store = {}, Object.defineProperty(U._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(U, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.defineProperty(U, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ne
      }), Object.freeze && (Object.freeze(U.props), Object.freeze(U)), U;
    };
    function Wn(T, M, L, V, ne) {
      {
        var ue, re = {}, U = null, Se = null;
        L !== void 0 && (Ln(L), U = "" + L), _n(M) && (Ln(M.key), U = "" + M.key), gn(M) && (Se = M.ref, Fn(M, ne));
        for (ue in M)
          Mt.call(M, ue) && !At.hasOwnProperty(ue) && (re[ue] = M[ue]);
        if (T && T.defaultProps) {
          var be = T.defaultProps;
          for (ue in be)
            re[ue] === void 0 && (re[ue] = be[ue]);
        }
        if (U || Se) {
          var ve = typeof T == "function" ? T.displayName || T.name || "Unknown" : T;
          U && It(re, ve), Se && yn(re, ve);
        }
        return bn(T, U, Se, ne, V, ct.current, re);
      }
    }
    var Qt = x.ReactCurrentOwner, Yn = x.ReactDebugCurrentFrame;
    function q(T) {
      if (T) {
        var M = T._owner, L = ae(T.type, T._source, M ? M.type : null);
        Yn.setExtraStackFrame(L);
      } else
        Yn.setExtraStackFrame(null);
    }
    var Q;
    Q = !1;
    function $(T) {
      return typeof T == "object" && T !== null && T.$$typeof === e;
    }
    function le() {
      {
        if (Qt.current) {
          var T = z(Qt.current.type);
          if (T)
            return `

Check the render method of \`` + T + "`.";
        }
        return "";
      }
    }
    function te(T) {
      return "";
    }
    var Ue = {};
    function ee(T) {
      {
        var M = le();
        if (!M) {
          var L = typeof T == "string" ? T : T.displayName || T.name;
          L && (M = `

Check the top-level render call using <` + L + ">.");
        }
        return M;
      }
    }
    function Bn(T, M) {
      {
        if (!T._store || T._store.validated || T.key != null)
          return;
        T._store.validated = !0;
        var L = ee(M);
        if (Ue[L])
          return;
        Ue[L] = !0;
        var V = "";
        T && T._owner && T._owner !== Qt.current && (V = " It was passed a child from " + z(T._owner.type) + "."), q(T), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', L, V), q(null);
      }
    }
    function zn(T, M) {
      {
        if (typeof T != "object")
          return;
        if (Je(T))
          for (var L = 0; L < T.length; L++) {
            var V = T[L];
            $(V) && Bn(V, M);
          }
        else if ($(T))
          T._store && (T._store.validated = !0);
        else if (T) {
          var ne = y(T);
          if (typeof ne == "function" && ne !== T.entries)
            for (var ue = ne.call(T), re; !(re = ue.next()).done; )
              $(re.value) && Bn(re.value, M);
        }
      }
    }
    function vn(T) {
      {
        var M = T.type;
        if (M == null || typeof M == "string")
          return;
        var L;
        if (typeof M == "function")
          L = M.propTypes;
        else if (typeof M == "object" && (M.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        M.$$typeof === d))
          L = M.propTypes;
        else
          return;
        if (L) {
          var V = z(M);
          Vt(L, T.props, "prop", V, T);
        } else if (M.PropTypes !== void 0 && !Q) {
          Q = !0;
          var ne = z(M);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ne || "Unknown");
        }
        typeof M.getDefaultProps == "function" && !M.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Lt(T) {
      {
        for (var M = Object.keys(T.props), L = 0; L < M.length; L++) {
          var V = M[L];
          if (V !== "children" && V !== "key") {
            q(T), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", V), q(null);
            break;
          }
        }
        T.ref !== null && (q(T), k("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
      }
    }
    var Ye = {};
    function Zt(T, M, L, V, ne, ue) {
      {
        var re = j(T);
        if (!re) {
          var U = "";
          (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Se = te();
          Se ? U += Se : U += le();
          var be;
          T === null ? be = "null" : Je(T) ? be = "array" : T !== void 0 && T.$$typeof === e ? (be = "<" + (z(T.type) || "Unknown") + " />", U = " Did you accidentally export a JSX literal instead of a component?") : be = typeof T, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", be, U);
        }
        var ve = Wn(T, M, L, ne, ue);
        if (ve == null)
          return ve;
        if (re) {
          var He = M.children;
          if (He !== void 0)
            if (V)
              if (Je(He)) {
                for (var Jt = 0; Jt < He.length; Jt++)
                  zn(He[Jt], T);
                Object.freeze && Object.freeze(He);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              zn(He, T);
        }
        if (Mt.call(M, "key")) {
          var Ft = z(T), Ge = Object.keys(M).filter(function(hs) {
            return hs !== "key";
          }), Lr = Ge.length > 0 ? "{key: someKey, " + Ge.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ye[Ft + Lr]) {
            var ds = Ge.length > 0 ? "{" + Ge.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Lr, Ft, ds, Ft), Ye[Ft + Lr] = !0;
          }
        }
        return T === n ? Lt(ve) : vn(ve), ve;
      }
    }
    function Pr(T, M, L) {
      return Zt(T, M, L, !0);
    }
    function Ir(T, M, L) {
      return Zt(T, M, L, !1);
    }
    var fs = Ir, wi = Pr;
    Yr.Fragment = n, Yr.jsx = fs, Yr.jsxs = wi;
  })()), Yr;
}
var $o;
function $u() {
  return $o || ($o = 1, process.env.NODE_ENV === "production" ? Ci.exports = Gu() : Ci.exports = qu()), Ci.exports;
}
var l = $u();
function en(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function vl(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.__proto__ = e;
}
var yt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, oi = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, ao, Be, ye, Ot = 1e8, me = 1 / Ot, Ws = Math.PI * 2, Vu = Ws / 4, Xu = 0, xl = Math.sqrt, Ku = Math.cos, Qu = Math.sin, Ie = function(e) {
  return typeof e == "string";
}, Ne = function(e) {
  return typeof e == "function";
}, an = function(e) {
  return typeof e == "number";
}, lo = function(e) {
  return typeof e > "u";
}, qt = function(e) {
  return typeof e == "object";
}, it = function(e) {
  return e !== !1;
}, co = function() {
  return typeof window < "u";
}, ji = function(e) {
  return Ne(e) || Ie(e);
}, wl = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Qe = Array.isArray, Zu = /random\([^)]+\)/g, Ju = /,\s*/g, Vo = /(?:-?\.?\d|\.)+/gi, Tl = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, yr = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _s = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, kl = /[+-]=-?[.\d]+/, ef = /[^,'"\[\]\s]+/gi, tf = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, ke, Bt, Ys, uo, bt = {}, Hi = {}, El, Sl = function(e) {
  return (Hi = Er(e, bt)) && lt;
}, fo = function(e, t) {
  return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
}, ai = function(e, t) {
  return !t && console.warn(e);
}, Nl = function(e, t) {
  return e && (bt[e] = t) && Hi && (Hi[e] = t) || bt;
}, li = function() {
  return 0;
}, nf = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Wi = {
  suppressEvents: !0,
  kill: !1
}, rf = {
  suppressEvents: !0
}, ho = {}, On = [], Bs = {}, Ol, ht = {}, ys = {}, Xo = 30, Yi = [], mo = "", po = function(e) {
  var t = e[0], n, i;
  if (qt(t) || Ne(t) || (e = [e]), !(n = (t._gsap || {}).harness)) {
    for (i = Yi.length; i-- && !Yi[i].targetTest(t); )
      ;
    n = Yi[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new Kl(e[i], n))) || e.splice(i, 1);
  return e;
}, er = function(e) {
  return e._gsap || po(Ct(e))[0]._gsap;
}, Cl = function(e, t, n) {
  return (n = e[t]) && Ne(n) ? e[t]() : lo(n) && e.getAttribute && e.getAttribute(t) || n;
}, st = function(e, t) {
  return (e = e.split(",")).forEach(t) || e;
}, je = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Te = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, vr = function(e, t) {
  var n = t.charAt(0), i = parseFloat(t.substr(2));
  return e = parseFloat(e), n === "+" ? e + i : n === "-" ? e - i : n === "*" ? e * i : e / i;
}, sf = function(e, t) {
  for (var n = t.length, i = 0; e.indexOf(t[i]) < 0 && ++i < n; )
    ;
  return i < n;
}, Gi = function() {
  var e = On.length, t = On.slice(0), n, i;
  for (Bs = {}, On.length = 0, n = 0; n < e; n++)
    i = t[n], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, go = function(e) {
  return !!(e._initted || e._startAt || e.add);
}, jl = function(e, t, n, i) {
  On.length && !Be && Gi(), e.render(t, n, !!(Be && t < 0 && go(e))), On.length && !Be && Gi();
}, Dl = function(e) {
  var t = parseFloat(e);
  return (t || t === 0) && (e + "").match(ef).length < 2 ? t : Ie(e) ? e.trim() : e;
}, Ml = function(e) {
  return e;
}, vt = function(e, t) {
  for (var n in t)
    n in e || (e[n] = t[n]);
  return e;
}, of = function(e) {
  return function(t, n) {
    for (var i in n)
      i in t || i === "duration" && e || i === "ease" || (t[i] = n[i]);
  };
}, Er = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, Ko = function r(e, t) {
  for (var n in t)
    n !== "__proto__" && n !== "constructor" && n !== "prototype" && (e[n] = qt(t[n]) ? r(e[n] || (e[n] = {}), t[n]) : t[n]);
  return e;
}, qi = function(e, t) {
  var n = {}, i;
  for (i in e)
    i in t || (n[i] = e[i]);
  return n;
}, ri = function(e) {
  var t = e.parent || ke, n = e.keyframes ? of(Qe(e.keyframes)) : vt;
  if (it(e.inherit))
    for (; t; )
      n(e, t.vars.defaults), t = t.parent || t._dp;
  return e;
}, af = function(e, t) {
  for (var n = e.length, i = n === t.length; i && n-- && e[n] === t[n]; )
    ;
  return n < 0;
}, Al = function(e, t, n, i, s) {
  var o = e[i], a;
  if (s)
    for (a = t[s]; o && o[s] > a; )
      o = o._prev;
  return o ? (t._next = o._next, o._next = t) : (t._next = e[n], e[n] = t), t._next ? t._next._prev = t : e[i] = t, t._prev = o, t.parent = t._dp = e, t;
}, ss = function(e, t, n, i) {
  n === void 0 && (n = "_first"), i === void 0 && (i = "_last");
  var s = t._prev, o = t._next;
  s ? s._next = o : e[n] === t && (e[n] = o), o ? o._prev = s : e[i] === t && (e[i] = s), t._next = t._prev = t.parent = null;
}, Dn = function(e, t) {
  e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, tr = function(e, t) {
  if (e && (!t || t._end > e._dur || t._start < 0))
    for (var n = e; n; )
      n._dirty = 1, n = n.parent;
  return e;
}, lf = function(e) {
  for (var t = e.parent; t && t.parent; )
    t._dirty = 1, t.totalDuration(), t = t.parent;
  return e;
}, zs = function(e, t, n, i) {
  return e._startAt && (Be ? e._startAt.revert(Wi) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, i));
}, cf = function r(e) {
  return !e || e._ts && r(e.parent);
}, Qo = function(e) {
  return e._repeat ? Sr(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Sr = function(e, t) {
  var n = Math.floor(e = Te(e / t));
  return e && n === e ? n - 1 : n;
}, $i = function(e, t) {
  return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
}, os = function(e) {
  return e._end = Te(e._start + (e._tDur / Math.abs(e._ts || e._rts || me) || 0));
}, as = function(e, t) {
  var n = e._dp;
  return n && n.smoothChildTiming && e._ts && (e._start = Te(n._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), os(e), n._dirty || tr(n, e)), e;
}, Rl = function(e, t) {
  var n;
  if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (n = $i(e.rawTime(), t), (!t._dur || bi(0, t.totalDuration(), n) - t._tTime > me) && t.render(n, !0)), tr(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (n = e; n._dp; )
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
    e._zTime = -me;
  }
}, zt = function(e, t, n, i) {
  return t.parent && Dn(t), t._start = Te((an(n) ? n : n || e !== ke ? St(e, n, t) : e._time) + t._delay), t._end = Te(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Al(e, t, "_first", "_last", e._sort ? "_start" : 0), Us(t) || (e._recent = t), i || Rl(e, t), e._ts < 0 && as(e, e._tTime), e;
}, Pl = function(e, t) {
  return (bt.ScrollTrigger || fo("scrollTrigger", t)) && bt.ScrollTrigger.create(t, e);
}, Il = function(e, t, n, i, s) {
  if (yo(e, t, s), !e._initted)
    return 1;
  if (!n && e._pt && !Be && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && Ol !== mt.frame)
    return On.push(e), e._lazy = [s, i], 1;
}, uf = function r(e) {
  var t = e.parent;
  return t && t._ts && t._initted && !t._lock && (t.rawTime() < 0 || r(t));
}, Us = function(e) {
  var t = e.data;
  return t === "isFromStart" || t === "isStart";
}, ff = function(e, t, n, i) {
  var s = e.ratio, o = t < 0 || !t && (!e._start && uf(e) && !(!e._initted && Us(e)) || (e._ts < 0 || e._dp._ts < 0) && !Us(e)) ? 0 : 1, a = e._rDelay, c = 0, u, f, d;
  if (a && e._repeat && (c = bi(0, e._tDur, t), f = Sr(c, a), e._yoyo && f & 1 && (o = 1 - o), f !== Sr(e._tTime, a) && (s = 1 - o, e.vars.repeatRefresh && e._initted && e.invalidate())), o !== s || Be || i || e._zTime === me || !t && e._zTime) {
    if (!e._initted && Il(e, t, i, n, c))
      return;
    for (d = e._zTime, e._zTime = t || (n ? me : 0), n || (n = t && !d), e.ratio = o, e._from && (o = 1 - o), e._time = 0, e._tTime = c, u = e._pt; u; )
      u.r(o, u.d), u = u._next;
    t < 0 && zs(e, t, n, !0), e._onUpdate && !n && pt(e, "onUpdate"), c && e._repeat && !n && e.parent && pt(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === o && (o && Dn(e, 1), !n && !Be && (pt(e, o ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = t);
}, df = function(e, t, n) {
  var i;
  if (n > t)
    for (i = e._first; i && i._start <= n; ) {
      if (i.data === "isPause" && i._start > t)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= n; ) {
      if (i.data === "isPause" && i._start < t)
        return i;
      i = i._prev;
    }
}, Nr = function(e, t, n, i) {
  var s = e._repeat, o = Te(t) || 0, a = e._tTime / e._tDur;
  return a && !i && (e._time *= o / e._dur), e._dur = o, e._tDur = s ? s < 0 ? 1e10 : Te(o * (s + 1) + e._rDelay * s) : o, a > 0 && !i && as(e, e._tTime = e._tDur * a), e.parent && os(e), n || tr(e.parent, e), e;
}, Zo = function(e) {
  return e instanceof rt ? tr(e) : Nr(e, e._dur);
}, hf = {
  _start: 0,
  endTime: li,
  totalDuration: li
}, St = function r(e, t, n) {
  var i = e.labels, s = e._recent || hf, o = e.duration() >= Ot ? s.endTime(!1) : e._dur, a, c, u;
  return Ie(t) && (isNaN(t) || t in i) ? (c = t.charAt(0), u = t.substr(-1) === "%", a = t.indexOf("="), c === "<" || c === ">" ? (a >= 0 && (t = t.replace(/=/, "")), (c === "<" ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(t.substr(1)) || 0) * (u ? (a < 0 ? s : n).totalDuration() / 100 : 1)) : a < 0 ? (t in i || (i[t] = o), i[t]) : (c = parseFloat(t.charAt(a - 1) + t.substr(a + 1)), u && n && (c = c / 100 * (Qe(n) ? n[0] : n).totalDuration()), a > 1 ? r(e, t.substr(0, a - 1), n) + c : o + c)) : t == null ? o : +t;
}, ii = function(e, t, n) {
  var i = an(t[1]), s = (i ? 2 : 1) + (e < 2 ? 0 : 1), o = t[s], a, c;
  if (i && (o.duration = t[1]), o.parent = n, e) {
    for (a = o, c = n; c && !("immediateRender" in a); )
      a = c.vars.defaults || {}, c = it(c.vars.inherit) && c.parent;
    o.immediateRender = it(a.immediateRender), e < 2 ? o.runBackwards = 1 : o.startAt = t[s - 1];
  }
  return new De(t[0], o, t[s + 1]);
}, Rn = function(e, t) {
  return e || e === 0 ? t(e) : t;
}, bi = function(e, t, n) {
  return n < e ? e : n > t ? t : n;
}, Xe = function(e, t) {
  return !Ie(e) || !(t = tf.exec(e)) ? "" : t[1];
}, mf = function(e, t, n) {
  return Rn(n, function(i) {
    return bi(e, t, i);
  });
}, Hs = [].slice, Ll = function(e, t) {
  return e && qt(e) && "length" in e && (!t && !e.length || e.length - 1 in e && qt(e[0])) && !e.nodeType && e !== Bt;
}, pf = function(e, t, n) {
  return n === void 0 && (n = []), e.forEach(function(i) {
    var s;
    return Ie(i) && !t || Ll(i, 1) ? (s = n).push.apply(s, Ct(i)) : n.push(i);
  }) || n;
}, Ct = function(e, t, n) {
  return ye && !t && ye.selector ? ye.selector(e) : Ie(e) && !n && (Ys || !Or()) ? Hs.call((t || uo).querySelectorAll(e), 0) : Qe(e) ? pf(e, n) : Ll(e) ? Hs.call(e, 0) : e ? [e] : [];
}, Gs = function(e) {
  return e = Ct(e)[0] || ai("Invalid scope") || {}, function(t) {
    var n = e.current || e.nativeElement || e;
    return Ct(t, n.querySelectorAll ? n : n === e ? ai("Invalid scope") || uo.createElement("div") : e);
  };
}, Fl = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, Wl = function(e) {
  if (Ne(e))
    return e;
  var t = qt(e) ? e : {
    each: e
  }, n = nr(t.ease), i = t.from || 0, s = parseFloat(t.base) || 0, o = {}, a = i > 0 && i < 1, c = isNaN(i) || a, u = t.axis, f = i, d = i;
  return Ie(i) ? f = d = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !a && c && (f = i[0], d = i[1]), function(p, _, v) {
    var m = (v || t).length, y = o[m], x, k, E, O, h, b, w, C, N;
    if (!y) {
      if (N = t.grid === "auto" ? 0 : (t.grid || [1, Ot])[1], !N) {
        for (w = -Ot; w < (w = v[N++].getBoundingClientRect().left) && N < m; )
          ;
        N < m && N--;
      }
      for (y = o[m] = [], x = c ? Math.min(N, m) * f - 0.5 : i % N, k = N === Ot ? 0 : c ? m * d / N - 0.5 : i / N | 0, w = 0, C = Ot, b = 0; b < m; b++)
        E = b % N - x, O = k - (b / N | 0), y[b] = h = u ? Math.abs(u === "y" ? O : E) : xl(E * E + O * O), h > w && (w = h), h < C && (C = h);
      i === "random" && Fl(y), y.max = w - C, y.min = C, y.v = m = (parseFloat(t.amount) || parseFloat(t.each) * (N > m ? m - 1 : u ? u === "y" ? m / N : N : Math.max(N, m / N)) || 0) * (i === "edges" ? -1 : 1), y.b = m < 0 ? s - m : s, y.u = Xe(t.amount || t.each) || 0, n = n && m < 0 ? Of(n) : n;
    }
    return m = (y[p] - y.min) / y.max || 0, Te(y.b + (n ? n(m) : m) * y.v) + y.u;
  };
}, qs = function(e) {
  var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(n) {
    var i = Te(Math.round(parseFloat(n) / e) * e * t);
    return (i - i % 1) / t + (an(n) ? 0 : Xe(n));
  };
}, Yl = function(e, t) {
  var n = Qe(e), i, s;
  return !n && qt(e) && (i = n = e.radius || Ot, e.values ? (e = Ct(e.values), (s = !an(e[0])) && (i *= i)) : e = qs(e.increment)), Rn(t, n ? Ne(e) ? function(o) {
    return s = e(o), Math.abs(s - o) <= i ? s : o;
  } : function(o) {
    for (var a = parseFloat(s ? o.x : o), c = parseFloat(s ? o.y : 0), u = Ot, f = 0, d = e.length, p, _; d--; )
      s ? (p = e[d].x - a, _ = e[d].y - c, p = p * p + _ * _) : p = Math.abs(e[d] - a), p < u && (u = p, f = d);
    return f = !i || u <= i ? e[f] : o, s || f === o || an(o) ? f : f + Xe(o);
  } : qs(e));
}, Bl = function(e, t, n, i) {
  return Rn(Qe(e) ? !t : n === !0 ? !!(n = 0) : !i, function() {
    return Qe(e) ? e[~~(Math.random() * e.length)] : (n = n || 1e-5) && (i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((e - n / 2 + Math.random() * (t - e + n * 0.99)) / n) * n * i) / i;
  });
}, gf = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(i) {
    return t.reduce(function(s, o) {
      return o(s);
    }, i);
  };
}, _f = function(e, t) {
  return function(n) {
    return e(parseFloat(n)) + (t || Xe(n));
  };
}, yf = function(e, t, n) {
  return Ul(e, t, 0, 1, n);
}, zl = function(e, t, n) {
  return Rn(n, function(i) {
    return e[~~t(i)];
  });
}, bf = function r(e, t, n) {
  var i = t - e;
  return Qe(e) ? zl(e, r(0, e.length), t) : Rn(n, function(s) {
    return (i + (s - e) % i) % i + e;
  });
}, vf = function r(e, t, n) {
  var i = t - e, s = i * 2;
  return Qe(e) ? zl(e, r(0, e.length - 1), t) : Rn(n, function(o) {
    return o = (s + (o - e) % s) % s || 0, e + (o > i ? s - o : o);
  });
}, ci = function(e) {
  return e.replace(Zu, function(t) {
    var n = t.indexOf("[") + 1, i = t.substring(n || 7, n ? t.indexOf("]") : t.length - 1).split(Ju);
    return Bl(n ? i : +i[0], n ? 0 : +i[1], +i[2] || 1e-5);
  });
}, Ul = function(e, t, n, i, s) {
  var o = t - e, a = i - n;
  return Rn(s, function(c) {
    return n + ((c - e) / o * a || 0);
  });
}, xf = function r(e, t, n, i) {
  var s = isNaN(e + t) ? 0 : function(_) {
    return (1 - _) * e + _ * t;
  };
  if (!s) {
    var o = Ie(e), a = {}, c, u, f, d, p;
    if (n === !0 && (i = 1) && (n = null), o)
      e = {
        p: e
      }, t = {
        p: t
      };
    else if (Qe(e) && !Qe(t)) {
      for (f = [], d = e.length, p = d - 2, u = 1; u < d; u++)
        f.push(r(e[u - 1], e[u]));
      d--, s = function(v) {
        v *= d;
        var m = Math.min(p, ~~v);
        return f[m](v - m);
      }, n = t;
    } else i || (e = Er(Qe(e) ? [] : {}, e));
    if (!f) {
      for (c in t)
        _o.call(a, e, c, "get", t[c]);
      s = function(v) {
        return xo(v, a) || (o ? e.p : e);
      };
    }
  }
  return Rn(n, s);
}, Jo = function(e, t, n) {
  var i = e.labels, s = Ot, o, a, c;
  for (o in i)
    a = i[o] - t, a < 0 == !!n && a && s > (a = Math.abs(a)) && (c = o, s = a);
  return c;
}, pt = function(e, t, n) {
  var i = e.vars, s = i[t], o = ye, a = e._ctx, c, u, f;
  if (s)
    return c = i[t + "Params"], u = i.callbackScope || e, n && On.length && Gi(), a && (ye = a), f = c ? s.apply(u, c) : s.call(u), ye = o, f;
}, Zr = function(e) {
  return Dn(e), e.scrollTrigger && e.scrollTrigger.kill(!!Be), e.progress() < 1 && pt(e, "onInterrupt"), e;
}, br, Hl = [], Gl = function(e) {
  if (e)
    if (e = !e.name && e.default || e, co() || e.headless) {
      var t = e.name, n = Ne(e), i = t && !n && e.init ? function() {
        this._props = [];
      } : e, s = {
        init: li,
        render: xo,
        add: _o,
        kill: Ff,
        modifier: Lf,
        rawVars: 0
      }, o = {
        targetTest: 0,
        get: 0,
        getSetter: vo,
        aliases: {},
        register: 0
      };
      if (Or(), e !== i) {
        if (ht[t])
          return;
        vt(i, vt(qi(e, s), o)), Er(i.prototype, Er(s, qi(e, o))), ht[i.prop = t] = i, e.targetTest && (Yi.push(i), ho[t] = 1), t = (t === "css" ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
      }
      Nl(t, i), e.register && e.register(lt, i, ot);
    } else
      Hl.push(e);
}, he = 255, Jr = {
  aqua: [0, he, he],
  lime: [0, he, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, he],
  navy: [0, 0, 128],
  white: [he, he, he],
  olive: [128, 128, 0],
  yellow: [he, he, 0],
  orange: [he, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [he, 0, 0],
  pink: [he, 192, 203],
  cyan: [0, he, he],
  transparent: [he, he, he, 0]
}, bs = function(e, t, n) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? t + (n - t) * e * 6 : e < 0.5 ? n : e * 3 < 2 ? t + (n - t) * (2 / 3 - e) * 6 : t) * he + 0.5 | 0;
}, ql = function(e, t, n) {
  var i = e ? an(e) ? [e >> 16, e >> 8 & he, e & he] : 0 : Jr.black, s, o, a, c, u, f, d, p, _, v;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), Jr[e])
      i = Jr[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (s = e.charAt(1), o = e.charAt(2), a = e.charAt(3), e = "#" + s + s + o + o + a + a + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & he, i & he, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & he, e & he];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = v = e.match(Vo), !t)
        c = +i[0] % 360 / 360, u = +i[1] / 100, f = +i[2] / 100, o = f <= 0.5 ? f * (u + 1) : f + u - f * u, s = f * 2 - o, i.length > 3 && (i[3] *= 1), i[0] = bs(c + 1 / 3, s, o), i[1] = bs(c, s, o), i[2] = bs(c - 1 / 3, s, o);
      else if (~e.indexOf("="))
        return i = e.match(Tl), n && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(Vo) || Jr.transparent;
    i = i.map(Number);
  }
  return t && !v && (s = i[0] / he, o = i[1] / he, a = i[2] / he, d = Math.max(s, o, a), p = Math.min(s, o, a), f = (d + p) / 2, d === p ? c = u = 0 : (_ = d - p, u = f > 0.5 ? _ / (2 - d - p) : _ / (d + p), c = d === s ? (o - a) / _ + (o < a ? 6 : 0) : d === o ? (a - s) / _ + 2 : (s - o) / _ + 4, c *= 60), i[0] = ~~(c + 0.5), i[1] = ~~(u * 100 + 0.5), i[2] = ~~(f * 100 + 0.5)), n && i.length < 4 && (i[3] = 1), i;
}, $l = function(e) {
  var t = [], n = [], i = -1;
  return e.split(Cn).forEach(function(s) {
    var o = s.match(yr) || [];
    t.push.apply(t, o), n.push(i += o.length + 1);
  }), t.c = n, t;
}, ea = function(e, t, n) {
  var i = "", s = (e + i).match(Cn), o = t ? "hsla(" : "rgba(", a = 0, c, u, f, d;
  if (!s)
    return e;
  if (s = s.map(function(p) {
    return (p = ql(p, t, 1)) && o + (t ? p[0] + "," + p[1] + "%," + p[2] + "%," + p[3] : p.join(",")) + ")";
  }), n && (f = $l(e), c = n.c, c.join(i) !== f.c.join(i)))
    for (u = e.replace(Cn, "1").split(yr), d = u.length - 1; a < d; a++)
      i += u[a] + (~c.indexOf(a) ? s.shift() || o + "0,0,0,0)" : (f.length ? f : s.length ? s : n).shift());
  if (!u)
    for (u = e.split(Cn), d = u.length - 1; a < d; a++)
      i += u[a] + s[a];
  return i + u[d];
}, Cn = (function() {
  var r = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in Jr)
    r += "|" + e + "\\b";
  return new RegExp(r + ")", "gi");
})(), wf = /hsl[a]?\(/, Vl = function(e) {
  var t = e.join(" "), n;
  if (Cn.lastIndex = 0, Cn.test(t))
    return n = wf.test(t), e[1] = ea(e[1], n), e[0] = ea(e[0], n, $l(e[1])), !0;
}, ui, mt = (function() {
  var r = Date.now, e = 500, t = 33, n = r(), i = n, s = 1e3 / 240, o = s, a = [], c, u, f, d, p, _, v = function m(y) {
    var x = r() - i, k = y === !0, E, O, h, b;
    if ((x > e || x < 0) && (n += x - t), i += x, h = i - n, E = h - o, (E > 0 || k) && (b = ++d.frame, p = h - d.time * 1e3, d.time = h = h / 1e3, o += E + (E >= s ? 4 : s - E), O = 1), k || (c = u(m)), O)
      for (_ = 0; _ < a.length; _++)
        a[_](h, p, b, y);
  };
  return d = {
    time: 0,
    frame: 0,
    tick: function() {
      v(!0);
    },
    deltaRatio: function(y) {
      return p / (1e3 / (y || 60));
    },
    wake: function() {
      El && (!Ys && co() && (Bt = Ys = window, uo = Bt.document || {}, bt.gsap = lt, (Bt.gsapVersions || (Bt.gsapVersions = [])).push(lt.version), Sl(Hi || Bt.GreenSockGlobals || !Bt.gsap && Bt || {}), Hl.forEach(Gl)), f = typeof requestAnimationFrame < "u" && requestAnimationFrame, c && d.sleep(), u = f || function(y) {
        return setTimeout(y, o - d.time * 1e3 + 1 | 0);
      }, ui = 1, v(2));
    },
    sleep: function() {
      (f ? cancelAnimationFrame : clearTimeout)(c), ui = 0, u = li;
    },
    lagSmoothing: function(y, x) {
      e = y || 1 / 0, t = Math.min(x || 33, e);
    },
    fps: function(y) {
      s = 1e3 / (y || 240), o = d.time * 1e3 + s;
    },
    add: function(y, x, k) {
      var E = x ? function(O, h, b, w) {
        y(O, h, b, w), d.remove(E);
      } : y;
      return d.remove(y), a[k ? "unshift" : "push"](E), Or(), E;
    },
    remove: function(y, x) {
      ~(x = a.indexOf(y)) && a.splice(x, 1) && _ >= x && _--;
    },
    _listeners: a
  }, d;
})(), Or = function() {
  return !ui && mt.wake();
}, ie = {}, Tf = /^[\d.\-M][\d.\-,\s]/, kf = /["']/g, Ef = function(e) {
  for (var t = {}, n = e.substr(1, e.length - 3).split(":"), i = n[0], s = 1, o = n.length, a, c, u; s < o; s++)
    c = n[s], a = s !== o - 1 ? c.lastIndexOf(",") : c.length, u = c.substr(0, a), t[i] = isNaN(u) ? u.replace(kf, "").trim() : +u, i = c.substr(a + 1).trim();
  return t;
}, Sf = function(e) {
  var t = e.indexOf("(") + 1, n = e.indexOf(")"), i = e.indexOf("(", t);
  return e.substring(t, ~i && i < n ? e.indexOf(")", n + 1) : n);
}, Nf = function(e) {
  var t = (e + "").split("("), n = ie[t[0]];
  return n && t.length > 1 && n.config ? n.config.apply(null, ~e.indexOf("{") ? [Ef(t[1])] : Sf(e).split(",").map(Dl)) : ie._CE && Tf.test(e) ? ie._CE("", e) : n;
}, Of = function(e) {
  return function(t) {
    return 1 - e(1 - t);
  };
}, nr = function(e, t) {
  return e && (Ne(e) ? e : ie[e] || Nf(e)) || t;
}, or = function(e, t, n, i) {
  n === void 0 && (n = function(c) {
    return 1 - t(1 - c);
  }), i === void 0 && (i = function(c) {
    return c < 0.5 ? t(c * 2) / 2 : 1 - t((1 - c) * 2) / 2;
  });
  var s = {
    easeIn: t,
    easeOut: n,
    easeInOut: i
  }, o;
  return st(e, function(a) {
    ie[a] = bt[a] = s, ie[o = a.toLowerCase()] = n;
    for (var c in s)
      ie[o + (c === "easeIn" ? ".in" : c === "easeOut" ? ".out" : ".inOut")] = ie[a + "." + c] = s[c];
  }), s;
}, Xl = function(e) {
  return function(t) {
    return t < 0.5 ? (1 - e(1 - t * 2)) / 2 : 0.5 + e((t - 0.5) * 2) / 2;
  };
}, vs = function r(e, t, n) {
  var i = t >= 1 ? t : 1, s = (n || (e ? 0.3 : 0.45)) / (t < 1 ? t : 1), o = s / Ws * (Math.asin(1 / i) || 0), a = function(f) {
    return f === 1 ? 1 : i * Math.pow(2, -10 * f) * Qu((f - o) * s) + 1;
  }, c = e === "out" ? a : e === "in" ? function(u) {
    return 1 - a(1 - u);
  } : Xl(a);
  return s = Ws / s, c.config = function(u, f) {
    return r(e, u, f);
  }, c;
}, xs = function r(e, t) {
  t === void 0 && (t = 1.70158);
  var n = function(o) {
    return o ? --o * o * ((t + 1) * o + t) + 1 : 0;
  }, i = e === "out" ? n : e === "in" ? function(s) {
    return 1 - n(1 - s);
  } : Xl(n);
  return i.config = function(s) {
    return r(e, s);
  }, i;
};
st("Linear,Quad,Cubic,Quart,Quint,Strong", function(r, e) {
  var t = e < 5 ? e + 1 : e;
  or(r + ",Power" + (t - 1), e ? function(n) {
    return Math.pow(n, t);
  } : function(n) {
    return n;
  }, function(n) {
    return 1 - Math.pow(1 - n, t);
  }, function(n) {
    return n < 0.5 ? Math.pow(n * 2, t) / 2 : 1 - Math.pow((1 - n) * 2, t) / 2;
  });
});
ie.Linear.easeNone = ie.none = ie.Linear.easeIn;
or("Elastic", vs("in"), vs("out"), vs());
(function(r, e) {
  var t = 1 / e, n = 2 * t, i = 2.5 * t, s = function(a) {
    return a < t ? r * a * a : a < n ? r * Math.pow(a - 1.5 / e, 2) + 0.75 : a < i ? r * (a -= 2.25 / e) * a + 0.9375 : r * Math.pow(a - 2.625 / e, 2) + 0.984375;
  };
  or("Bounce", function(o) {
    return 1 - s(1 - o);
  }, s);
})(7.5625, 2.75);
or("Expo", function(r) {
  return Math.pow(2, 10 * (r - 1)) * r + r * r * r * r * r * r * (1 - r);
});
or("Circ", function(r) {
  return -(xl(1 - r * r) - 1);
});
or("Sine", function(r) {
  return r === 1 ? 1 : -Ku(r * Vu) + 1;
});
or("Back", xs("in"), xs("out"), xs());
ie.SteppedEase = ie.steps = bt.SteppedEase = {
  config: function(e, t) {
    e === void 0 && (e = 1);
    var n = 1 / e, i = e + (t ? 0 : 1), s = t ? 1 : 0, o = 1 - me;
    return function(a) {
      return ((i * bi(0, o, a) | 0) + s) * n;
    };
  }
};
oi.ease = ie["quad.out"];
st("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(r) {
  return mo += r + "," + r + "Params,";
});
var Kl = function(e, t) {
  this.id = Xu++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : Cl, this.set = t ? t.getSetter : vo;
}, fi = /* @__PURE__ */ (function() {
  function r(t) {
    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Nr(this, +t.duration, 1, 1), this.data = t.data, ye && (this._ctx = ye, ye.data.push(this)), ui || mt.wake();
  }
  var e = r.prototype;
  return e.delay = function(n) {
    return n || n === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + n - this._delay), this._delay = n, this) : this._delay;
  }, e.duration = function(n) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? n + (n + this._rDelay) * this._repeat : n) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(n) {
    return arguments.length ? (this._dirty = 0, Nr(this, this._repeat < 0 ? n : (n - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(n, i) {
    if (Or(), !arguments.length)
      return this._tTime;
    var s = this._dp;
    if (s && s.smoothChildTiming && this._ts) {
      for (as(this, n), !s._dp || s.parent || Rl(s, this); s && s.parent; )
        s.parent._time !== s._start + (s._ts >= 0 ? s._tTime / s._ts : (s.totalDuration() - s._tTime) / -s._ts) && s.totalTime(s._tTime, !0), s = s.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && n < this._tDur || this._ts < 0 && n > 0 || !this._tDur && !n) && zt(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== n || !this._dur && !i || this._initted && Math.abs(this._zTime) === me || !this._initted && this._dur && n || !n && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = n), jl(this, n, i)), this;
  }, e.time = function(n, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), n + Qo(this)) % (this._dur + this._rDelay) || (n ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(n, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * n, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(n, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - n : n) + Qo(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(n, i) {
    var s = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (n - 1) * s, i) : this._repeat ? Sr(this._tTime, s) + 1 : 1;
  }, e.timeScale = function(n, i) {
    if (!arguments.length)
      return this._rts === -me ? 0 : this._rts;
    if (this._rts === n)
      return this;
    var s = this.parent && this._ts ? $i(this.parent._time, this) : this._tTime;
    return this._rts = +n || 0, this._ts = this._ps || n === -me ? 0 : this._rts, this.totalTime(bi(-Math.abs(this._delay), this.totalDuration(), s), i !== !1), os(this), lf(this);
  }, e.paused = function(n) {
    return arguments.length ? (this._ps !== n && (this._ps = n, n ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Or(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== me && (this._tTime -= me)))), this) : this._ps;
  }, e.startTime = function(n) {
    if (arguments.length) {
      this._start = Te(n);
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && zt(i, this, this._start - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(n) {
    return this._start + (it(n) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(n) {
    var i = this.parent || this._dp;
    return i ? n && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? $i(i.rawTime(n), this) : this._tTime : this._tTime;
  }, e.revert = function(n) {
    n === void 0 && (n = rf);
    var i = Be;
    return Be = n, go(this) && (this.timeline && this.timeline.revert(n), this.totalTime(-0.01, n.suppressEvents)), this.data !== "nested" && n.kill !== !1 && this.kill(), Be = i, this;
  }, e.globalTime = function(n) {
    for (var i = this, s = arguments.length ? n : i.rawTime(); i; )
      s = i._start + s / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(n) : s;
  }, e.repeat = function(n) {
    return arguments.length ? (this._repeat = n === 1 / 0 ? -2 : n, Zo(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(n) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = n, Zo(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(n) {
    return arguments.length ? (this._yoyo = n, this) : this._yoyo;
  }, e.seek = function(n, i) {
    return this.totalTime(St(this, n), it(i));
  }, e.restart = function(n, i) {
    return this.play().totalTime(n ? -this._delay : 0, it(i)), this._dur || (this._zTime = -me), this;
  }, e.play = function(n, i) {
    return n != null && this.seek(n, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(n, i) {
    return n != null && this.seek(n || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(n, i) {
    return n != null && this.seek(n, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(n) {
    return arguments.length ? (!!n !== this.reversed() && this.timeScale(-this._rts || (n ? -me : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -me, this;
  }, e.isActive = function() {
    var n = this.parent || this._dp, i = this._start, s;
    return !!(!n || this._ts && this._initted && n.isActive() && (s = n.rawTime(!0)) >= i && s < this.endTime(!0) - me);
  }, e.eventCallback = function(n, i, s) {
    var o = this.vars;
    return arguments.length > 1 ? (i ? (o[n] = i, s && (o[n + "Params"] = s), n === "onUpdate" && (this._onUpdate = i)) : delete o[n], this) : o[n];
  }, e.then = function(n) {
    var i = this, s = i._prom;
    return new Promise(function(o) {
      var a = Ne(n) ? n : Ml, c = function() {
        var f = i.then;
        i.then = null, s && s(), Ne(a) && (a = a(i)) && (a.then || a === i) && (i.then = f), o(a), i.then = f;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? c() : i._prom = c;
    });
  }, e.kill = function() {
    Zr(this);
  }, r;
})();
vt(fi.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -me,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var rt = /* @__PURE__ */ (function(r) {
  vl(e, r);
  function e(n, i) {
    var s;
    return n === void 0 && (n = {}), s = r.call(this, n) || this, s.labels = {}, s.smoothChildTiming = !!n.smoothChildTiming, s.autoRemoveChildren = !!n.autoRemoveChildren, s._sort = it(n.sortChildren), ke && zt(n.parent || ke, en(s), i), n.reversed && s.reverse(), n.paused && s.paused(!0), n.scrollTrigger && Pl(en(s), n.scrollTrigger), s;
  }
  var t = e.prototype;
  return t.to = function(i, s, o) {
    return ii(0, arguments, this), this;
  }, t.from = function(i, s, o) {
    return ii(1, arguments, this), this;
  }, t.fromTo = function(i, s, o, a) {
    return ii(2, arguments, this), this;
  }, t.set = function(i, s, o) {
    return s.duration = 0, s.parent = this, ri(s).repeatDelay || (s.repeat = 0), s.immediateRender = !!s.immediateRender, new De(i, s, St(this, o), 1), this;
  }, t.call = function(i, s, o) {
    return zt(this, De.delayedCall(0, i, s), o);
  }, t.staggerTo = function(i, s, o, a, c, u, f) {
    return o.duration = s, o.stagger = o.stagger || a, o.onComplete = u, o.onCompleteParams = f, o.parent = this, new De(i, o, St(this, c)), this;
  }, t.staggerFrom = function(i, s, o, a, c, u, f) {
    return o.runBackwards = 1, ri(o).immediateRender = it(o.immediateRender), this.staggerTo(i, s, o, a, c, u, f);
  }, t.staggerFromTo = function(i, s, o, a, c, u, f, d) {
    return a.startAt = o, ri(a).immediateRender = it(a.immediateRender), this.staggerTo(i, s, a, c, u, f, d);
  }, t.render = function(i, s, o) {
    var a = this._time, c = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, f = i <= 0 ? 0 : Te(i), d = this._zTime < 0 != i < 0 && (this._initted || !u), p, _, v, m, y, x, k, E, O, h, b, w;
    if (this !== ke && f > c && i >= 0 && (f = c), f !== this._tTime || o || d) {
      if (a !== this._time && u && (f += this._time - a, i += this._time - a), p = f, O = this._start, E = this._ts, x = !E, d && (u || (a = this._zTime), (i || !s) && (this._zTime = i)), this._repeat) {
        if (b = this._yoyo, y = u + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(y * 100 + i, s, o);
        if (p = Te(f % y), f === c ? (m = this._repeat, p = u) : (h = Te(f / y), m = ~~h, m && m === h && (p = u, m--), p > u && (p = u)), h = Sr(this._tTime, y), !a && this._tTime && h !== m && this._tTime - h * y - this._dur <= 0 && (h = m), b && m & 1 && (p = u - p, w = 1), m !== h && !this._lock) {
          var C = b && h & 1, N = C === (b && m & 1);
          if (m < h && (C = !C), a = C ? 0 : f % u ? u : f, this._lock = 1, this.render(a || (w ? 0 : Te(m * y)), s, !u)._lock = 0, this._tTime = f, !s && this.parent && pt(this, "onRepeat"), this.vars.repeatRefresh && !w && (this.invalidate()._lock = 1, h = m), a && a !== this._time || x !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, c = this._tDur, N && (this._lock = 2, a = C ? u : -1e-4, this.render(a, !0), this.vars.repeatRefresh && !w && this.invalidate()), this._lock = 0, !this._ts && !x)
            return this;
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (k = df(this, Te(a), Te(p)), k && (f -= p - (p = k._start))), this._tTime = f, this._time = p, this._act = !!E, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, a = 0), !a && f && u && !s && !h && (pt(this, "onStart"), this._tTime !== f))
        return this;
      if (p >= a && i >= 0)
        for (_ = this._first; _; ) {
          if (v = _._next, (_._act || p >= _._start) && _._ts && k !== _) {
            if (_.parent !== this)
              return this.render(i, s, o);
            if (_.render(_._ts > 0 ? (p - _._start) * _._ts : (_._dirty ? _.totalDuration() : _._tDur) + (p - _._start) * _._ts, s, o), p !== this._time || !this._ts && !x) {
              k = 0, v && (f += this._zTime = -me);
              break;
            }
          }
          _ = v;
        }
      else {
        _ = this._last;
        for (var j = i < 0 ? i : p; _; ) {
          if (v = _._prev, (_._act || j <= _._end) && _._ts && k !== _) {
            if (_.parent !== this)
              return this.render(i, s, o);
            if (_.render(_._ts > 0 ? (j - _._start) * _._ts : (_._dirty ? _.totalDuration() : _._tDur) + (j - _._start) * _._ts, s, o || Be && go(_)), p !== this._time || !this._ts && !x) {
              k = 0, v && (f += this._zTime = j ? -me : me);
              break;
            }
          }
          _ = v;
        }
      }
      if (k && !s && (this.pause(), k.render(p >= a ? 0 : -me)._zTime = p >= a ? 1 : -1, this._ts))
        return this._start = O, os(this), this.render(i, s, o);
      this._onUpdate && !s && pt(this, "onUpdate", !0), (f === c && this._tTime >= this.totalDuration() || !f && a) && (O === this._start || Math.abs(E) !== Math.abs(this._ts)) && (this._lock || ((i || !u) && (f === c && this._ts > 0 || !f && this._ts < 0) && Dn(this, 1), !s && !(i < 0 && !a) && (f || a || !c) && (pt(this, f === c && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(f < c && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, t.add = function(i, s) {
    var o = this;
    if (an(s) || (s = St(this, s, i)), !(i instanceof fi)) {
      if (Qe(i))
        return i.forEach(function(a) {
          return o.add(a, s);
        }), this;
      if (Ie(i))
        return this.addLabel(i, s);
      if (Ne(i))
        i = De.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? zt(this, i, s) : this;
  }, t.getChildren = function(i, s, o, a) {
    i === void 0 && (i = !0), s === void 0 && (s = !0), o === void 0 && (o = !0), a === void 0 && (a = -Ot);
    for (var c = [], u = this._first; u; )
      u._start >= a && (u instanceof De ? s && c.push(u) : (o && c.push(u), i && c.push.apply(c, u.getChildren(!0, s, o)))), u = u._next;
    return c;
  }, t.getById = function(i) {
    for (var s = this.getChildren(1, 1, 1), o = s.length; o--; )
      if (s[o].vars.id === i)
        return s[o];
  }, t.remove = function(i) {
    return Ie(i) ? this.removeLabel(i) : Ne(i) ? this.killTweensOf(i) : (i.parent === this && ss(this, i), i === this._recent && (this._recent = this._last), tr(this));
  }, t.totalTime = function(i, s) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Te(mt.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), r.prototype.totalTime.call(this, i, s), this._forcing = 0, this) : this._tTime;
  }, t.addLabel = function(i, s) {
    return this.labels[i] = St(this, s), this;
  }, t.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, t.addPause = function(i, s, o) {
    var a = De.delayedCall(0, s || li, o);
    return a.data = "isPause", this._hasPause = 1, zt(this, a, St(this, i));
  }, t.removePause = function(i) {
    var s = this._first;
    for (i = St(this, i); s; )
      s._start === i && s.data === "isPause" && Dn(s), s = s._next;
  }, t.killTweensOf = function(i, s, o) {
    for (var a = this.getTweensOf(i, o), c = a.length; c--; )
      En !== a[c] && a[c].kill(i, s);
    return this;
  }, t.getTweensOf = function(i, s) {
    for (var o = [], a = Ct(i), c = this._first, u = an(s), f; c; )
      c instanceof De ? sf(c._targets, a) && (u ? (!En || c._initted && c._ts) && c.globalTime(0) <= s && c.globalTime(c.totalDuration()) > s : !s || c.isActive()) && o.push(c) : (f = c.getTweensOf(a, s)).length && o.push.apply(o, f), c = c._next;
    return o;
  }, t.tweenTo = function(i, s) {
    s = s || {};
    var o = this, a = St(o, i), c = s, u = c.startAt, f = c.onStart, d = c.onStartParams, p = c.immediateRender, _, v = De.to(o, vt({
      ease: s.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: a,
      overwrite: "auto",
      duration: s.duration || Math.abs((a - (u && "time" in u ? u.time : o._time)) / o.timeScale()) || me,
      onStart: function() {
        if (o.pause(), !_) {
          var y = s.duration || Math.abs((a - (u && "time" in u ? u.time : o._time)) / o.timeScale());
          v._dur !== y && Nr(v, y, 0, 1).render(v._time, !0, !0), _ = 1;
        }
        f && f.apply(v, d || []);
      }
    }, s));
    return p ? v.render(0) : v;
  }, t.tweenFromTo = function(i, s, o) {
    return this.tweenTo(s, vt({
      startAt: {
        time: St(this, i)
      }
    }, o));
  }, t.recent = function() {
    return this._recent;
  }, t.nextLabel = function(i) {
    return i === void 0 && (i = this._time), Jo(this, St(this, i));
  }, t.previousLabel = function(i) {
    return i === void 0 && (i = this._time), Jo(this, St(this, i), 1);
  }, t.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + me);
  }, t.shiftChildren = function(i, s, o) {
    o === void 0 && (o = 0);
    var a = this._first, c = this.labels, u;
    for (i = Te(i); a; )
      a._start >= o && (a._start += i, a._end += i), a = a._next;
    if (s)
      for (u in c)
        c[u] >= o && (c[u] += i);
    return tr(this);
  }, t.invalidate = function(i) {
    var s = this._first;
    for (this._lock = 0; s; )
      s.invalidate(i), s = s._next;
    return r.prototype.invalidate.call(this, i);
  }, t.clear = function(i) {
    i === void 0 && (i = !0);
    for (var s = this._first, o; s; )
      o = s._next, this.remove(s), s = o;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), tr(this);
  }, t.totalDuration = function(i) {
    var s = 0, o = this, a = o._last, c = Ot, u, f, d;
    if (arguments.length)
      return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -i : i));
    if (o._dirty) {
      for (d = o.parent; a; )
        u = a._prev, a._dirty && a.totalDuration(), f = a._start, f > c && o._sort && a._ts && !o._lock ? (o._lock = 1, zt(o, a, f - a._delay, 1)._lock = 0) : c = f, f < 0 && a._ts && (s -= f, (!d && !o._dp || d && d.smoothChildTiming) && (o._start += Te(f / o._ts), o._time -= f, o._tTime -= f), o.shiftChildren(-f, !1, -1 / 0), c = 0), a._end > s && a._ts && (s = a._end), a = u;
      Nr(o, o === ke && o._time > s ? o._time : s, 1, 1), o._dirty = 0;
    }
    return o._tDur;
  }, e.updateRoot = function(i) {
    if (ke._ts && (jl(ke, $i(i, ke)), Ol = mt.frame), mt.frame >= Xo) {
      Xo += yt.autoSleep || 120;
      var s = ke._first;
      if ((!s || !s._ts) && yt.autoSleep && mt._listeners.length < 2) {
        for (; s && !s._ts; )
          s = s._next;
        s || mt.sleep();
      }
    }
  }, e;
})(fi);
vt(rt.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var Cf = function(e, t, n, i, s, o, a) {
  var c = new ot(this._pt, e, t, 0, 1, nc, null, s), u = 0, f = 0, d, p, _, v, m, y, x, k;
  for (c.b = n, c.e = i, n += "", i += "", (x = ~i.indexOf("random(")) && (i = ci(i)), o && (k = [n, i], o(k, e, t), n = k[0], i = k[1]), p = n.match(_s) || []; d = _s.exec(i); )
    v = d[0], m = i.substring(u, d.index), _ ? _ = (_ + 1) % 5 : m.substr(-5) === "rgba(" && (_ = 1), v !== p[f++] && (y = parseFloat(p[f - 1]) || 0, c._pt = {
      _next: c._pt,
      p: m || f === 1 ? m : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: y,
      c: v.charAt(1) === "=" ? vr(y, v) - y : parseFloat(v) - y,
      m: _ && _ < 4 ? Math.round : 0
    }, u = _s.lastIndex);
  return c.c = u < i.length ? i.substring(u, i.length) : "", c.fp = a, (kl.test(i) || x) && (c.e = 0), this._pt = c, c;
}, _o = function(e, t, n, i, s, o, a, c, u, f) {
  Ne(i) && (i = i(s || 0, e, o));
  var d = e[t], p = n !== "get" ? n : Ne(d) ? u ? e[t.indexOf("set") || !Ne(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](u) : e[t]() : d, _ = Ne(d) ? u ? Rf : ec : bo, v;
  if (Ie(i) && (~i.indexOf("random(") && (i = ci(i)), i.charAt(1) === "=" && (v = vr(p, i) + (Xe(p) || 0), (v || v === 0) && (i = v))), !f || p !== i || $s)
    return !isNaN(p * i) && i !== "" ? (v = new ot(this._pt, e, t, +p || 0, i - (p || 0), typeof d == "boolean" ? If : tc, 0, _), u && (v.fp = u), a && v.modifier(a, this, e), this._pt = v) : (!d && !(t in e) && fo(t, i), Cf.call(this, e, t, p, i, _, c || yt.stringFilter, u));
}, jf = function(e, t, n, i, s) {
  if (Ne(e) && (e = si(e, s, t, n, i)), !qt(e) || e.style && e.nodeType || Qe(e) || wl(e))
    return Ie(e) ? si(e, s, t, n, i) : e;
  var o = {}, a;
  for (a in e)
    o[a] = si(e[a], s, t, n, i);
  return o;
}, Ql = function(e, t, n, i, s, o) {
  var a, c, u, f;
  if (ht[e] && (a = new ht[e]()).init(s, a.rawVars ? t[e] : jf(t[e], i, s, o, n), n, i, o) !== !1 && (n._pt = c = new ot(n._pt, s, e, 0, 1, a.render, a, 0, a.priority), n !== br))
    for (u = n._ptLookup[n._targets.indexOf(s)], f = a._props.length; f--; )
      u[a._props[f]] = c;
  return a;
}, En, $s, yo = function r(e, t, n) {
  var i = e.vars, s = i.ease, o = i.startAt, a = i.immediateRender, c = i.lazy, u = i.onUpdate, f = i.runBackwards, d = i.yoyoEase, p = i.keyframes, _ = i.autoRevert, v = e._dur, m = e._startAt, y = e._targets, x = e.parent, k = x && x.data === "nested" ? x.vars.targets : y, E = e._overwrite === "auto" && !ao, O = e.timeline, h = i.easeReverse || d, b, w, C, N, j, A, B, z, P, I, X, oe, Oe;
  if (O && (!p || !s) && (s = "none"), e._ease = nr(s, oi.ease), e._rEase = h && (nr(h) || e._ease), e._from = !O && !!i.runBackwards, e._from && (e.ratio = 1), !O || p && !i.stagger) {
    if (z = y[0] ? er(y[0]).harness : 0, oe = z && i[z.prop], b = qi(i, ho), m && (m._zTime < 0 && m.progress(1), t < 0 && f && a && !_ ? m.render(-1, !0) : m.revert(f && v ? Wi : nf), m._lazy = 0), o) {
      if (Dn(e._startAt = De.set(y, vt({
        data: "isStart",
        overwrite: !1,
        parent: x,
        immediateRender: !0,
        lazy: !m && it(c),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return pt(e, "onUpdate");
        },
        stagger: 0
      }, o))), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Be || !a && !_) && e._startAt.revert(Wi), a && v && t <= 0 && n <= 0) {
        t && (e._zTime = t);
        return;
      }
    } else if (f && v && !m) {
      if (t && (a = !1), C = vt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: a && !m && it(c),
        immediateRender: a,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: x
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, b), oe && (C[z.prop] = oe), Dn(e._startAt = De.set(y, C)), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Be ? e._startAt.revert(Wi) : e._startAt.render(-1, !0)), e._zTime = t, !a)
        r(e._startAt, me, me);
      else if (!t)
        return;
    }
    for (e._pt = e._ptCache = 0, c = v && it(c) || c && !v, w = 0; w < y.length; w++) {
      if (j = y[w], B = j._gsap || po(y)[w]._gsap, e._ptLookup[w] = I = {}, Bs[B.id] && On.length && Gi(), X = k === y ? w : k.indexOf(j), z && (P = new z()).init(j, oe || b, e, X, k) !== !1 && (e._pt = N = new ot(e._pt, j, P.name, 0, 1, P.render, P, 0, P.priority), P._props.forEach(function(pe) {
        I[pe] = N;
      }), P.priority && (A = 1)), !z || oe)
        for (C in b)
          ht[C] && (P = Ql(C, b, e, X, j, k)) ? P.priority && (A = 1) : I[C] = N = _o.call(e, j, C, "get", b[C], X, k, 0, i.stringFilter);
      e._op && e._op[w] && e.kill(j, e._op[w]), E && e._pt && (En = e, ke.killTweensOf(j, I, e.globalTime(t)), Oe = !e.parent, En = 0), e._pt && c && (Bs[B.id] = 1);
    }
    A && rc(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = u, e._initted = (!e._op || e._pt) && !Oe, p && t <= 0 && O.render(Ot, !0, !0);
}, Df = function(e, t, n, i, s, o, a, c) {
  var u = (e._pt && e._ptCache || (e._ptCache = {}))[t], f, d, p, _;
  if (!u)
    for (u = e._ptCache[t] = [], p = e._ptLookup, _ = e._targets.length; _--; ) {
      if (f = p[_][t], f && f.d && f.d._pt)
        for (f = f.d._pt; f && f.p !== t && f.fp !== t; )
          f = f._next;
      if (!f)
        return $s = 1, e.vars[t] = "+=0", yo(e, a), $s = 0, c ? ai(t + " not eligible for reset. Try splitting into individual properties") : 1;
      u.push(f);
    }
  for (_ = u.length; _--; )
    d = u[_], f = d._pt || d, f.s = (i || i === 0) && !s ? i : f.s + (i || 0) + o * f.c, f.c = n - f.s, d.e && (d.e = je(n) + Xe(d.e)), d.b && (d.b = f.s + Xe(d.b));
}, Mf = function(e, t) {
  var n = e[0] ? er(e[0]).harness : 0, i = n && n.aliases, s, o, a, c;
  if (!i)
    return t;
  s = Er({}, t);
  for (o in i)
    if (o in s)
      for (c = i[o].split(","), a = c.length; a--; )
        s[c[a]] = s[o];
  return s;
}, Af = function(e, t, n, i) {
  var s = t.ease || i || "power1.inOut", o, a;
  if (Qe(t))
    a = n[e] || (n[e] = []), t.forEach(function(c, u) {
      return a.push({
        t: u / (t.length - 1) * 100,
        v: c,
        e: s
      });
    });
  else
    for (o in t)
      a = n[o] || (n[o] = []), o === "ease" || a.push({
        t: parseFloat(e),
        v: t[o],
        e: s
      });
}, si = function(e, t, n, i, s) {
  return Ne(e) ? e.call(t, n, i, s) : Ie(e) && ~e.indexOf("random(") ? ci(e) : e;
}, Zl = mo + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", Jl = {};
st(Zl + ",id,stagger,delay,duration,paused,scrollTrigger", function(r) {
  return Jl[r] = 1;
});
var De = /* @__PURE__ */ (function(r) {
  vl(e, r);
  function e(n, i, s, o) {
    var a;
    typeof i == "number" && (s.duration = i, i = s, s = null), a = r.call(this, o ? i : ri(i)) || this;
    var c = a.vars, u = c.duration, f = c.delay, d = c.immediateRender, p = c.stagger, _ = c.overwrite, v = c.keyframes, m = c.defaults, y = c.scrollTrigger, x = i.parent || ke, k = (Qe(n) || wl(n) ? an(n[0]) : "length" in i) ? [n] : Ct(n), E, O, h, b, w, C, N, j;
    if (a._targets = k.length ? po(k) : ai("GSAP target " + n + " not found. https://gsap.com", !yt.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = _, v || p || ji(u) || ji(f)) {
      i = a.vars;
      var A = i.easeReverse || i.yoyoEase;
      if (E = a.timeline = new rt({
        data: "nested",
        defaults: m || {},
        targets: x && x.data === "nested" ? x.vars.targets : k
      }), E.kill(), E.parent = E._dp = en(a), E._start = 0, p || ji(u) || ji(f)) {
        if (b = k.length, N = p && Wl(p), qt(p))
          for (w in p)
            ~Zl.indexOf(w) && (j || (j = {}), j[w] = p[w]);
        for (O = 0; O < b; O++)
          h = qi(i, Jl), h.stagger = 0, A && (h.easeReverse = A), j && Er(h, j), C = k[O], h.duration = +si(u, en(a), O, C, k), h.delay = (+si(f, en(a), O, C, k) || 0) - a._delay, !p && b === 1 && h.delay && (a._delay = f = h.delay, a._start += f, h.delay = 0), E.to(C, h, N ? N(O, C, k) : 0), E._ease = ie.none;
        E.duration() ? u = f = 0 : a.timeline = 0;
      } else if (v) {
        ri(vt(E.vars.defaults, {
          ease: "none"
        })), E._ease = nr(v.ease || i.ease || "none");
        var B = 0, z, P, I;
        if (Qe(v))
          v.forEach(function(X) {
            return E.to(k, X, ">");
          }), E.duration();
        else {
          h = {};
          for (w in v)
            w === "ease" || w === "easeEach" || Af(w, v[w], h, v.easeEach);
          for (w in h)
            for (z = h[w].sort(function(X, oe) {
              return X.t - oe.t;
            }), B = 0, O = 0; O < z.length; O++)
              P = z[O], I = {
                ease: P.e,
                duration: (P.t - (O ? z[O - 1].t : 0)) / 100 * u
              }, I[w] = P.v, E.to(k, I, B), B += I.duration;
          E.duration() < u && E.to({}, {
            duration: u - E.duration()
          });
        }
      }
      u || a.duration(u = E.duration());
    } else
      a.timeline = 0;
    return _ === !0 && !ao && (En = en(a), ke.killTweensOf(k), En = 0), zt(x, en(a), s), i.reversed && a.reverse(), i.paused && a.paused(!0), (d || !u && !v && a._start === Te(x._time) && it(d) && cf(en(a)) && x.data !== "nested") && (a._tTime = -me, a.render(Math.max(0, -f) || 0)), y && Pl(en(a), y), a;
  }
  var t = e.prototype;
  return t.render = function(i, s, o) {
    var a = this._time, c = this._tDur, u = this._dur, f = i < 0, d = i > c - me && !f ? c : i < me ? 0 : i, p, _, v, m, y, x, k, E;
    if (!u)
      ff(this, i, s, o);
    else if (d !== this._tTime || !i || o || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== f || this._lazy) {
      if (p = d, E = this.timeline, this._repeat) {
        if (m = u + this._rDelay, this._repeat < -1 && f)
          return this.totalTime(m * 100 + i, s, o);
        if (p = Te(d % m), d === c ? (v = this._repeat, p = u) : (y = Te(d / m), v = ~~y, v && v === y ? (p = u, v--) : p > u && (p = u)), x = this._yoyo && v & 1, x && (p = u - p), y = Sr(this._tTime, m), p === a && !o && this._initted && v === y)
          return this._tTime = d, this;
        v !== y && this.vars.repeatRefresh && !x && !this._lock && p !== m && this._initted && (this._lock = o = 1, this.render(Te(m * v), !0).invalidate()._lock = 0);
      }
      if (!this._initted) {
        if (Il(this, f ? i : p, o, s, d))
          return this._tTime = 0, this;
        if (a !== this._time && !(o && this.vars.repeatRefresh && v !== y))
          return this;
        if (u !== this._dur)
          return this.render(i, s, o);
      }
      if (this._rEase) {
        var O = p < a;
        if (O !== this._inv) {
          var h = O ? a : u - a;
          this._inv = O, this._from && (this.ratio = 1 - this.ratio), this._invRatio = this.ratio, this._invTime = a, this._invRecip = h ? (O ? -1 : 1) / h : 0, this._invScale = O ? -this.ratio : 1 - this.ratio, this._invEase = O ? this._rEase : this._ease;
        }
        this.ratio = k = this._invRatio + this._invScale * this._invEase((p - this._invTime) * this._invRecip);
      } else
        this.ratio = k = this._ease(p / u);
      if (this._from && (this.ratio = k = 1 - k), this._tTime = d, this._time = p, !this._act && this._ts && (this._act = 1, this._lazy = 0), !a && d && !s && !y && (pt(this, "onStart"), this._tTime !== d))
        return this;
      for (_ = this._pt; _; )
        _.r(k, _.d), _ = _._next;
      E && E.render(i < 0 ? i : E._dur * E._ease(p / this._dur), s, o) || this._startAt && (this._zTime = i), this._onUpdate && !s && (f && zs(this, i, s, o), pt(this, "onUpdate")), this._repeat && v !== y && this.vars.onRepeat && !s && this.parent && pt(this, "onRepeat"), (d === this._tDur || !d) && this._tTime === d && (f && !this._onUpdate && zs(this, i, !0, !0), (i || !u) && (d === this._tDur && this._ts > 0 || !d && this._ts < 0) && Dn(this, 1), !s && !(f && !a) && (d || a || x) && (pt(this, d === c ? "onComplete" : "onReverseComplete", !0), this._prom && !(d < c && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, t.targets = function() {
    return this._targets;
  }, t.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), r.prototype.invalidate.call(this, i);
  }, t.resetTo = function(i, s, o, a, c) {
    ui || mt.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), f;
    return this._initted || yo(this, u), f = this._ease(u / this._dur), Df(this, i, s, o, a, f, u, c) ? this.resetTo(i, s, o, a, 1) : (as(this, 0), this.parent || Al(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, t.kill = function(i, s) {
    if (s === void 0 && (s = "all"), !i && (!s || s === "all"))
      return this._lazy = this._pt = 0, this.parent ? Zr(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Be), this;
    if (this.timeline) {
      var o = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, s, En && En.vars.overwrite !== !0)._first || Zr(this), this.parent && o !== this.timeline.totalDuration() && Nr(this, this._dur * this.timeline._tDur / o, 0, 1), this;
    }
    var a = this._targets, c = i ? Ct(i) : a, u = this._ptLookup, f = this._pt, d, p, _, v, m, y, x;
    if ((!s || s === "all") && af(a, c))
      return s === "all" && (this._pt = 0), Zr(this);
    for (d = this._op = this._op || [], s !== "all" && (Ie(s) && (m = {}, st(s, function(k) {
      return m[k] = 1;
    }), s = m), s = Mf(a, s)), x = a.length; x--; )
      if (~c.indexOf(a[x])) {
        p = u[x], s === "all" ? (d[x] = s, v = p, _ = {}) : (_ = d[x] = d[x] || {}, v = s);
        for (m in v)
          y = p && p[m], y && ((!("kill" in y.d) || y.d.kill(m) === !0) && ss(this, y, "_pt"), delete p[m]), _ !== "all" && (_[m] = 1);
      }
    return this._initted && !this._pt && f && Zr(this), this;
  }, e.to = function(i, s) {
    return new e(i, s, arguments[2]);
  }, e.from = function(i, s) {
    return ii(1, arguments);
  }, e.delayedCall = function(i, s, o, a) {
    return new e(s, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: s,
      onReverseComplete: s,
      onCompleteParams: o,
      onReverseCompleteParams: o,
      callbackScope: a
    });
  }, e.fromTo = function(i, s, o) {
    return ii(2, arguments);
  }, e.set = function(i, s) {
    return s.duration = 0, s.repeatDelay || (s.repeat = 0), new e(i, s);
  }, e.killTweensOf = function(i, s, o) {
    return ke.killTweensOf(i, s, o);
  }, e;
})(fi);
vt(De.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
st("staggerTo,staggerFrom,staggerFromTo", function(r) {
  De[r] = function() {
    var e = new rt(), t = Hs.call(arguments, 0);
    return t.splice(r === "staggerFromTo" ? 5 : 4, 0, 0), e[r].apply(e, t);
  };
});
var bo = function(e, t, n) {
  return e[t] = n;
}, ec = function(e, t, n) {
  return e[t](n);
}, Rf = function(e, t, n, i) {
  return e[t](i.fp, n);
}, Pf = function(e, t, n) {
  return e.setAttribute(t, n);
}, vo = function(e, t) {
  return Ne(e[t]) ? ec : lo(e[t]) && e.setAttribute ? Pf : bo;
}, tc = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
}, If = function(e, t) {
  return t.set(t.t, t.p, !!(t.s + t.c * e), t);
}, nc = function(e, t) {
  var n = t._pt, i = "";
  if (!e && t.b)
    i = t.b;
  else if (e === 1 && t.e)
    i = t.e;
  else {
    for (; n; )
      i = n.p + (n.m ? n.m(n.s + n.c * e) : Math.round((n.s + n.c * e) * 1e4) / 1e4) + i, n = n._next;
    i += t.c;
  }
  t.set(t.t, t.p, i, t);
}, xo = function(e, t) {
  for (var n = t._pt; n; )
    n.r(e, n.d), n = n._next;
}, Lf = function(e, t, n, i) {
  for (var s = this._pt, o; s; )
    o = s._next, s.p === i && s.modifier(e, t, n), s = o;
}, Ff = function(e) {
  for (var t = this._pt, n, i; t; )
    i = t._next, t.p === e && !t.op || t.op === e ? ss(this, t, "_pt") : t.dep || (n = 1), t = i;
  return !n;
}, Wf = function(e, t, n, i) {
  i.mSet(e, t, i.m.call(i.tween, n, i.mt), i);
}, rc = function(e) {
  for (var t = e._pt, n, i, s, o; t; ) {
    for (n = t._next, i = s; i && i.pr > t.pr; )
      i = i._next;
    (t._prev = i ? i._prev : o) ? t._prev._next = t : s = t, (t._next = i) ? i._prev = t : o = t, t = n;
  }
  e._pt = s;
}, ot = /* @__PURE__ */ (function() {
  function r(t, n, i, s, o, a, c, u, f) {
    this.t = n, this.s = s, this.c = o, this.p = i, this.r = a || tc, this.d = c || this, this.set = u || bo, this.pr = f || 0, this._next = t, t && (t._prev = this);
  }
  var e = r.prototype;
  return e.modifier = function(n, i, s) {
    this.mSet = this.mSet || this.set, this.set = Wf, this.m = n, this.mt = s, this.tween = i;
  }, r;
})();
st(mo + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(r) {
  return ho[r] = 1;
});
bt.TweenMax = bt.TweenLite = De;
bt.TimelineLite = bt.TimelineMax = rt;
ke = new rt({
  sortChildren: !1,
  defaults: oi,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
yt.stringFilter = Vl;
var rr = [], Bi = {}, Yf = [], ta = 0, Bf = 0, ws = function(e) {
  return (Bi[e] || Yf).map(function(t) {
    return t();
  });
}, Vs = function() {
  var e = Date.now(), t = [];
  e - ta > 2 && (ws("matchMediaInit"), rr.forEach(function(n) {
    var i = n.queries, s = n.conditions, o, a, c, u;
    for (a in i)
      o = Bt.matchMedia(i[a]).matches, o && (c = 1), o !== s[a] && (s[a] = o, u = 1);
    u && (n.revert(), c && t.push(n));
  }), ws("matchMediaRevert"), t.forEach(function(n) {
    return n.onMatch(n, function(i) {
      return n.add(null, i);
    });
  }), ta = e, ws("matchMedia"));
}, ic = /* @__PURE__ */ (function() {
  function r(t, n) {
    this.selector = n && Gs(n), this.data = [], this._r = [], this.isReverted = !1, this.id = Bf++, t && this.add(t);
  }
  var e = r.prototype;
  return e.add = function(n, i, s) {
    Ne(n) && (s = i, i = n, n = Ne);
    var o = this, a = function() {
      var u = ye, f = o.selector, d;
      return u && u !== o && u.data.push(o), s && (o.selector = Gs(s)), ye = o, d = i.apply(o, arguments), Ne(d) && o._r.push(d), ye = u, o.selector = f, o.isReverted = !1, d;
    };
    return o.last = a, n === Ne ? a(o, function(c) {
      return o.add(null, c);
    }) : n ? o[n] = a : a;
  }, e.ignore = function(n) {
    var i = ye;
    ye = null, n(this), ye = i;
  }, e.getTweens = function() {
    var n = [];
    return this.data.forEach(function(i) {
      return i instanceof r ? n.push.apply(n, i.getTweens()) : i instanceof De && !(i.parent && i.parent.data === "nested") && n.push(i);
    }), n;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(n, i) {
    var s = this;
    if (n ? (function() {
      for (var a = s.getTweens(), c = s.data.length, u; c--; )
        u = s.data[c], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(f) {
          return a.splice(a.indexOf(f), 1);
        }));
      for (a.map(function(f) {
        return {
          g: f._dur || f._delay || f._sat && !f._sat.vars.immediateRender ? f.globalTime(0) : -1 / 0,
          t: f
        };
      }).sort(function(f, d) {
        return d.g - f.g || -1 / 0;
      }).forEach(function(f) {
        return f.t.revert(n);
      }), c = s.data.length; c--; )
        u = s.data[c], u instanceof rt ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof De) && u.revert && u.revert(n);
      s._r.forEach(function(f) {
        return f(n, s);
      }), s.isReverted = !0;
    })() : this.data.forEach(function(a) {
      return a.kill && a.kill();
    }), this.clear(), i)
      for (var o = rr.length; o--; )
        rr[o].id === this.id && rr.splice(o, 1);
  }, e.revert = function(n) {
    this.kill(n || {});
  }, r;
})(), zf = /* @__PURE__ */ (function() {
  function r(t) {
    this.contexts = [], this.scope = t, ye && ye.data.push(this);
  }
  var e = r.prototype;
  return e.add = function(n, i, s) {
    qt(n) || (n = {
      matches: n
    });
    var o = new ic(0, s || this.scope), a = o.conditions = {}, c, u, f;
    ye && !o.selector && (o.selector = ye.selector), this.contexts.push(o), i = o.add("onMatch", i), o.queries = n;
    for (u in n)
      u === "all" ? f = 1 : (c = Bt.matchMedia(n[u]), c && (rr.indexOf(o) < 0 && rr.push(o), (a[u] = c.matches) && (f = 1), c.addListener ? c.addListener(Vs) : c.addEventListener("change", Vs)));
    return f && i(o, function(d) {
      return o.add(null, d);
    }), this;
  }, e.revert = function(n) {
    this.kill(n || {});
  }, e.kill = function(n) {
    this.contexts.forEach(function(i) {
      return i.kill(n, !0);
    });
  }, r;
})(), Vi = {
  registerPlugin: function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    t.forEach(function(i) {
      return Gl(i);
    });
  },
  timeline: function(e) {
    return new rt(e);
  },
  getTweensOf: function(e, t) {
    return ke.getTweensOf(e, t);
  },
  getProperty: function(e, t, n, i) {
    Ie(e) && (e = Ct(e)[0]);
    var s = er(e || {}).get, o = n ? Ml : Dl;
    return n === "native" && (n = ""), e && (t ? o((ht[t] && ht[t].get || s)(e, t, n, i)) : function(a, c, u) {
      return o((ht[a] && ht[a].get || s)(e, a, c, u));
    });
  },
  quickSetter: function(e, t, n) {
    if (e = Ct(e), e.length > 1) {
      var i = e.map(function(f) {
        return lt.quickSetter(f, t, n);
      }), s = i.length;
      return function(f) {
        for (var d = s; d--; )
          i[d](f);
      };
    }
    e = e[0] || {};
    var o = ht[t], a = er(e), c = a.harness && (a.harness.aliases || {})[t] || t, u = o ? function(f) {
      var d = new o();
      br._pt = 0, d.init(e, n ? f + n : f, br, 0, [e]), d.render(1, d), br._pt && xo(1, br);
    } : a.set(e, c);
    return o ? u : function(f) {
      return u(e, c, n ? f + n : f, a, 1);
    };
  },
  quickTo: function(e, t, n) {
    var i, s = lt.to(e, vt((i = {}, i[t] = "+=0.1", i.paused = !0, i.stagger = 0, i), n || {})), o = function(c, u, f) {
      return s.resetTo(t, c, u, f);
    };
    return o.tween = s, o;
  },
  isTweening: function(e) {
    return ke.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = nr(e.ease, oi.ease)), Ko(oi, e || {});
  },
  config: function(e) {
    return Ko(yt, e || {});
  },
  registerEffect: function(e) {
    var t = e.name, n = e.effect, i = e.plugins, s = e.defaults, o = e.extendTimeline;
    (i || "").split(",").forEach(function(a) {
      return a && !ht[a] && !bt[a] && ai(t + " effect requires " + a + " plugin.");
    }), ys[t] = function(a, c, u) {
      return n(Ct(a), vt(c || {}, s), u);
    }, o && (rt.prototype[t] = function(a, c, u) {
      return this.add(ys[t](a, qt(c) ? c : (u = c) && {}, this), u);
    });
  },
  registerEase: function(e, t) {
    ie[e] = nr(t);
  },
  parseEase: function(e, t) {
    return arguments.length ? nr(e, t) : ie;
  },
  getById: function(e) {
    return ke.getById(e);
  },
  exportRoot: function(e, t) {
    e === void 0 && (e = {});
    var n = new rt(e), i, s;
    for (n.smoothChildTiming = it(e.smoothChildTiming), ke.remove(n), n._dp = 0, n._time = n._tTime = ke._time, i = ke._first; i; )
      s = i._next, (t || !(!i._dur && i instanceof De && i.vars.onComplete === i._targets[0])) && zt(n, i, i._start - i._delay), i = s;
    return zt(ke, n, 0), n;
  },
  context: function(e, t) {
    return e ? new ic(e, t) : ye;
  },
  matchMedia: function(e) {
    return new zf(e);
  },
  matchMediaRefresh: function() {
    return rr.forEach(function(e) {
      var t = e.conditions, n, i;
      for (i in t)
        t[i] && (t[i] = !1, n = 1);
      n && e.revert();
    }) || Vs();
  },
  addEventListener: function(e, t) {
    var n = Bi[e] || (Bi[e] = []);
    ~n.indexOf(t) || n.push(t);
  },
  removeEventListener: function(e, t) {
    var n = Bi[e], i = n && n.indexOf(t);
    i >= 0 && n.splice(i, 1);
  },
  utils: {
    wrap: bf,
    wrapYoyo: vf,
    distribute: Wl,
    random: Bl,
    snap: Yl,
    normalize: yf,
    getUnit: Xe,
    clamp: mf,
    splitColor: ql,
    toArray: Ct,
    selector: Gs,
    mapRange: Ul,
    pipe: gf,
    unitize: _f,
    interpolate: xf,
    shuffle: Fl
  },
  install: Sl,
  effects: ys,
  ticker: mt,
  updateRoot: rt.updateRoot,
  plugins: ht,
  globalTimeline: ke,
  core: {
    PropTween: ot,
    globals: Nl,
    Tween: De,
    Timeline: rt,
    Animation: fi,
    getCache: er,
    _removeLinkedListItem: ss,
    reverting: function() {
      return Be;
    },
    context: function(e) {
      return e && ye && (ye.data.push(e), e._ctx = ye), ye;
    },
    suppressOverwrites: function(e) {
      return ao = e;
    }
  }
};
st("to,from,fromTo,delayedCall,set,killTweensOf", function(r) {
  return Vi[r] = De[r];
});
mt.add(rt.updateRoot);
br = Vi.to({}, {
  duration: 0
});
var Uf = function(e, t) {
  for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
    n = n._next;
  return n;
}, Hf = function(e, t) {
  var n = e._targets, i, s, o;
  for (i in t)
    for (s = n.length; s--; )
      o = e._ptLookup[s][i], o && (o = o.d) && (o._pt && (o = Uf(o, i)), o && o.modifier && o.modifier(t[i], e, n[s], i));
}, Ts = function(e, t) {
  return {
    name: e,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, s, o) {
      o._onInit = function(a) {
        var c, u;
        if (Ie(s) && (c = {}, st(s, function(f) {
          return c[f] = 1;
        }), s = c), t) {
          c = {};
          for (u in s)
            c[u] = t(s[u]);
          s = c;
        }
        Hf(a, s);
      };
    }
  };
}, lt = Vi.registerPlugin({
  name: "attr",
  init: function(e, t, n, i, s) {
    var o, a, c;
    this.tween = n;
    for (o in t)
      c = e.getAttribute(o) || "", a = this.add(e, "setAttribute", (c || 0) + "", t[o], i, s, 0, 0, o), a.op = o, a.b = c, this._props.push(o);
  },
  render: function(e, t) {
    for (var n = t._pt; n; )
      Be ? n.set(n.t, n.p, n.b, n) : n.r(e, n.d), n = n._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(e, t) {
    for (var n = t.length; n--; )
      this.add(e, n, e[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
  }
}, Ts("roundProps", qs), Ts("modifiers"), Ts("snap", Yl)) || Vi;
De.version = rt.version = lt.version = "3.15.0";
El = 1;
co() && Or();
ie.Power0;
ie.Power1;
ie.Power2;
ie.Power3;
ie.Power4;
ie.Linear;
ie.Quad;
ie.Cubic;
ie.Quart;
ie.Quint;
ie.Strong;
ie.Elastic;
ie.Back;
ie.SteppedEase;
ie.Bounce;
ie.Sine;
ie.Expo;
ie.Circ;
var na, Sn, xr, wo, Jn, ra, To, Gf = function() {
  return typeof window < "u";
}, ln = {}, Vn = 180 / Math.PI, wr = Math.PI / 180, ur = Math.atan2, ia = 1e8, ko = /([A-Z])/g, qf = /(left|right|width|margin|padding|x)/i, $f = /[\s,\(]\S/, Ut = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, Xs = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, Vf = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, Xf = function(e, t) {
  return t.set(t.t, t.p, e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, Kf = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, Qf = function(e, t) {
  var n = t.s + t.c * e;
  t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
}, sc = function(e, t) {
  return t.set(t.t, t.p, e ? t.e : t.b, t);
}, oc = function(e, t) {
  return t.set(t.t, t.p, e !== 1 ? t.b : t.e, t);
}, Zf = function(e, t, n) {
  return e.style[t] = n;
}, Jf = function(e, t, n) {
  return e.style.setProperty(t, n);
}, ed = function(e, t, n) {
  return e._gsap[t] = n;
}, td = function(e, t, n) {
  return e._gsap.scaleX = e._gsap.scaleY = n;
}, nd = function(e, t, n, i, s) {
  var o = e._gsap;
  o.scaleX = o.scaleY = n, o.renderTransform(s, o);
}, rd = function(e, t, n, i, s) {
  var o = e._gsap;
  o[t] = n, o.renderTransform(s, o);
}, Ee = "transform", at = Ee + "Origin", id = function r(e, t) {
  var n = this, i = this.target, s = i.style, o = i._gsap;
  if (e in ln && s) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = Ut[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(a) {
        return n.tfm[a] = tn(i, a);
      }) : this.tfm[e] = o.x ? o[e] : tn(i, e), e === at && (this.tfm.zOrigin = o.zOrigin);
    else
      return Ut.transform.split(",").forEach(function(a) {
        return r.call(n, a, t);
      });
    if (this.props.indexOf(Ee) >= 0)
      return;
    o.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(at, t, "")), e = Ee;
  }
  (s || t) && this.props.push(e, t, s[e]);
}, ac = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, sd = function() {
  var e = this.props, t = this.target, n = t.style, i = t._gsap, s, o;
  for (s = 0; s < e.length; s += 3)
    e[s + 1] ? e[s + 1] === 2 ? t[e[s]](e[s + 2]) : t[e[s]] = e[s + 2] : e[s + 2] ? n[e[s]] = e[s + 2] : n.removeProperty(e[s].substr(0, 2) === "--" ? e[s] : e[s].replace(ko, "-$1").toLowerCase());
  if (this.tfm) {
    for (o in this.tfm)
      i[o] = this.tfm[o];
    i.svg && (i.renderTransform(), t.setAttribute("data-svg-origin", this.svgo || "")), s = To(), (!s || !s.isStart) && !n[Ee] && (ac(n), i.zOrigin && n[at] && (n[at] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, lc = function(e, t) {
  var n = {
    target: e,
    props: [],
    revert: sd,
    save: id
  };
  return e._gsap || lt.core.getCache(e), t && e.style && e.nodeType && t.split(",").forEach(function(i) {
    return n.save(i);
  }), n;
}, cc, Ks = function(e, t) {
  var n = Sn.createElementNS ? Sn.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Sn.createElement(e);
  return n && n.style ? n : Sn.createElement(e);
}, gt = function r(e, t, n) {
  var i = getComputedStyle(e);
  return i[t] || i.getPropertyValue(t.replace(ko, "-$1").toLowerCase()) || i.getPropertyValue(t) || !n && r(e, Cr(t) || t, 1) || "";
}, sa = "O,Moz,ms,Ms,Webkit".split(","), Cr = function(e, t, n) {
  var i = t || Jn, s = i.style, o = 5;
  if (e in s && !n)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); o-- && !(sa[o] + e in s); )
    ;
  return o < 0 ? null : (o === 3 ? "ms" : o >= 0 ? sa[o] : "") + e;
}, Qs = function() {
  Gf() && window.document && (na = window, Sn = na.document, xr = Sn.documentElement, Jn = Ks("div") || {
    style: {}
  }, Ks("div"), Ee = Cr(Ee), at = Ee + "Origin", Jn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", cc = !!Cr("perspective"), To = lt.core.reverting, wo = 1);
}, oa = function(e) {
  var t = e.ownerSVGElement, n = Ks("svg", t && t.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = e.cloneNode(!0), s;
  i.style.display = "block", n.appendChild(i), xr.appendChild(n);
  try {
    s = i.getBBox();
  } catch {
  }
  return n.removeChild(i), xr.removeChild(n), s;
}, aa = function(e, t) {
  for (var n = t.length; n--; )
    if (e.hasAttribute(t[n]))
      return e.getAttribute(t[n]);
}, uc = function(e) {
  var t, n;
  try {
    t = e.getBBox();
  } catch {
    t = oa(e), n = 1;
  }
  return t && (t.width || t.height) || n || (t = oa(e)), t && !t.width && !t.x && !t.y ? {
    x: +aa(e, ["x", "cx", "x1"]) || 0,
    y: +aa(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : t;
}, fc = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && uc(e));
}, Mn = function(e, t) {
  if (t) {
    var n = e.style, i;
    t in ln && t !== at && (t = Ee), n.removeProperty ? (i = t.substr(0, 2), (i === "ms" || t.substr(0, 6) === "webkit") && (t = "-" + t), n.removeProperty(i === "--" ? t : t.replace(ko, "-$1").toLowerCase())) : n.removeAttribute(t);
  }
}, Nn = function(e, t, n, i, s, o) {
  var a = new ot(e._pt, t, n, 0, 1, o ? oc : sc);
  return e._pt = a, a.b = i, a.e = s, e._props.push(n), a;
}, la = {
  deg: 1,
  rad: 1,
  turn: 1
}, od = {
  grid: 1,
  flex: 1
}, An = function r(e, t, n, i) {
  var s = parseFloat(n) || 0, o = (n + "").trim().substr((s + "").length) || "px", a = Jn.style, c = qf.test(t), u = e.tagName.toLowerCase() === "svg", f = (u ? "client" : "offset") + (c ? "Width" : "Height"), d = 100, p = i === "px", _ = i === "%", v, m, y, x;
  if (i === o || !s || la[i] || la[o])
    return s;
  if (o !== "px" && !p && (s = r(e, t, n, "px")), x = e.getCTM && fc(e), (_ || o === "%") && (ln[t] || ~t.indexOf("adius")))
    return v = x ? e.getBBox()[c ? "width" : "height"] : e[f], je(_ ? s / v * d : s / 100 * v);
  if (a[c ? "width" : "height"] = d + (p ? o : i), m = i !== "rem" && ~t.indexOf("adius") || i === "em" && e.appendChild && !u ? e : e.parentNode, x && (m = (e.ownerSVGElement || {}).parentNode), (!m || m === Sn || !m.appendChild) && (m = Sn.body), y = m._gsap, y && _ && y.width && c && y.time === mt.time && !y.uncache)
    return je(s / y.width * d);
  if (_ && (t === "height" || t === "width")) {
    var k = e.style[t];
    e.style[t] = d + i, v = e[f], k ? e.style[t] = k : Mn(e, t);
  } else
    (_ || o === "%") && !od[gt(m, "display")] && (a.position = gt(e, "position")), m === e && (a.position = "static"), m.appendChild(Jn), v = Jn[f], m.removeChild(Jn), a.position = "absolute";
  return c && _ && (y = er(m), y.time = mt.time, y.width = m[f]), je(p ? v * s / d : v && s ? d / v * s : 0);
}, tn = function(e, t, n, i) {
  var s;
  return wo || Qs(), t in Ut && t !== "transform" && (t = Ut[t], ~t.indexOf(",") && (t = t.split(",")[0])), ln[t] && t !== "transform" ? (s = hi(e, i), s = t !== "transformOrigin" ? s[t] : s.svg ? s.origin : Ki(gt(e, at)) + " " + s.zOrigin + "px") : (s = e.style[t], (!s || s === "auto" || i || ~(s + "").indexOf("calc(")) && (s = Xi[t] && Xi[t](e, t, n) || gt(e, t) || Cl(e, t) || (t === "opacity" ? 1 : 0))), n && !~(s + "").trim().indexOf(" ") ? An(e, t, s, n) + n : s;
}, ad = function(e, t, n, i) {
  if (!n || n === "none") {
    var s = Cr(t, e, 1), o = s && gt(e, s, 1);
    o && o !== n ? (t = s, n = o) : t === "borderColor" && (n = gt(e, "borderTopColor"));
  }
  var a = new ot(this._pt, e.style, t, 0, 1, nc), c = 0, u = 0, f, d, p, _, v, m, y, x, k, E, O, h;
  if (a.b = n, a.e = i, n += "", i += "", i.substring(0, 6) === "var(--" && (i = gt(e, i.substring(4, i.indexOf(")")))), i === "auto" && (m = e.style[t], e.style[t] = i, i = gt(e, t) || i, m ? e.style[t] = m : Mn(e, t)), f = [n, i], Vl(f), n = f[0], i = f[1], p = n.match(yr) || [], h = i.match(yr) || [], h.length) {
    for (; d = yr.exec(i); )
      y = d[0], k = i.substring(c, d.index), v ? v = (v + 1) % 5 : (k.substr(-5) === "rgba(" || k.substr(-5) === "hsla(") && (v = 1), y !== (m = p[u++] || "") && (_ = parseFloat(m) || 0, O = m.substr((_ + "").length), y.charAt(1) === "=" && (y = vr(_, y) + O), x = parseFloat(y), E = y.substr((x + "").length), c = yr.lastIndex - E.length, E || (E = E || yt.units[t] || O, c === i.length && (i += E, a.e += E)), O !== E && (_ = An(e, t, m, E) || 0), a._pt = {
        _next: a._pt,
        p: k || u === 1 ? k : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: _,
        c: x - _,
        m: v && v < 4 || t === "zIndex" ? Math.round : 0
      });
    a.c = c < i.length ? i.substring(c, i.length) : "";
  } else
    a.r = t === "display" && i === "none" ? oc : sc;
  return kl.test(i) && (a.e = 0), this._pt = a, a;
}, ca = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, ld = function(e) {
  var t = e.split(" "), n = t[0], i = t[1] || "50%";
  return (n === "top" || n === "bottom" || i === "left" || i === "right") && (e = n, n = i, i = e), t[0] = ca[n] || n, t[1] = ca[i] || i, t.join(" ");
}, cd = function(e, t) {
  if (t.tween && t.tween._time === t.tween._dur) {
    var n = t.t, i = n.style, s = t.u, o = n._gsap, a, c, u;
    if (s === "all" || s === !0)
      i.cssText = "", c = 1;
    else
      for (s = s.split(","), u = s.length; --u > -1; )
        a = s[u], ln[a] && (c = 1, a = a === "transformOrigin" ? at : Ee), Mn(n, a);
    c && (Mn(n, Ee), o && (o.svg && n.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", hi(n, 1), o.uncache = 1, ac(i)));
  }
}, Xi = {
  clearProps: function(e, t, n, i, s) {
    if (s.data !== "isFromStart") {
      var o = e._pt = new ot(e._pt, t, n, 0, 0, cd);
      return o.u = i, o.pr = -10, o.tween = s, e._props.push(n), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, di = [1, 0, 0, 1, 0, 0], dc = {}, hc = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, ua = function(e) {
  var t = gt(e, Ee);
  return hc(t) ? di : t.substr(7).match(Tl).map(je);
}, Eo = function(e, t) {
  var n = e._gsap || er(e), i = e.style, s = ua(e), o, a, c, u;
  return n.svg && e.getAttribute("transform") ? (c = e.transform.baseVal.consolidate().matrix, s = [c.a, c.b, c.c, c.d, c.e, c.f], s.join(",") === "1,0,0,1,0,0" ? di : s) : (s === di && !e.offsetParent && e !== xr && !n.svg && (c = i.display, i.display = "block", o = e.parentNode, (!o || !e.offsetParent && !e.getBoundingClientRect().width) && (u = 1, a = e.nextElementSibling, xr.appendChild(e)), s = ua(e), c ? i.display = c : Mn(e, "display"), u && (a ? o.insertBefore(e, a) : o ? o.appendChild(e) : xr.removeChild(e))), t && s.length > 6 ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s);
}, Zs = function(e, t, n, i, s, o) {
  var a = e._gsap, c = s || Eo(e, !0), u = a.xOrigin || 0, f = a.yOrigin || 0, d = a.xOffset || 0, p = a.yOffset || 0, _ = c[0], v = c[1], m = c[2], y = c[3], x = c[4], k = c[5], E = t.split(" "), O = parseFloat(E[0]) || 0, h = parseFloat(E[1]) || 0, b, w, C, N;
  n ? c !== di && (w = _ * y - v * m) && (C = O * (y / w) + h * (-m / w) + (m * k - y * x) / w, N = O * (-v / w) + h * (_ / w) - (_ * k - v * x) / w, O = C, h = N) : (b = uc(e), O = b.x + (~E[0].indexOf("%") ? O / 100 * b.width : O), h = b.y + (~(E[1] || E[0]).indexOf("%") ? h / 100 * b.height : h)), i || i !== !1 && a.smooth ? (x = O - u, k = h - f, a.xOffset = d + (x * _ + k * m) - x, a.yOffset = p + (x * v + k * y) - k) : a.xOffset = a.yOffset = 0, a.xOrigin = O, a.yOrigin = h, a.smooth = !!i, a.origin = t, a.originIsAbsolute = !!n, e.style[at] = "0px 0px", o && (Nn(o, a, "xOrigin", u, O), Nn(o, a, "yOrigin", f, h), Nn(o, a, "xOffset", d, a.xOffset), Nn(o, a, "yOffset", p, a.yOffset)), e.setAttribute("data-svg-origin", O + " " + h);
}, hi = function(e, t) {
  var n = e._gsap || new Kl(e);
  if ("x" in n && !t && !n.uncache)
    return n;
  var i = e.style, s = n.scaleX < 0, o = "px", a = "deg", c = getComputedStyle(e), u = gt(e, at) || "0", f, d, p, _, v, m, y, x, k, E, O, h, b, w, C, N, j, A, B, z, P, I, X, oe, Oe, pe, _e, Ce, ze, jt, Fe, J;
  return f = d = p = m = y = x = k = E = O = 0, _ = v = 1, n.svg = !!(e.getCTM && fc(e)), c.translate && ((c.translate !== "none" || c.scale !== "none" || c.rotate !== "none") && (i[Ee] = (c.translate !== "none" ? "translate3d(" + (c.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (c.rotate !== "none" ? "rotate(" + c.rotate + ") " : "") + (c.scale !== "none" ? "scale(" + c.scale.split(" ").join(",") + ") " : "") + (c[Ee] !== "none" ? c[Ee] : "")), i.scale = i.rotate = i.translate = "none"), w = Eo(e, n.svg), n.svg && (n.uncache ? (Oe = e.getBBox(), u = n.xOrigin - Oe.x + "px " + (n.yOrigin - Oe.y) + "px", oe = "") : oe = !t && e.getAttribute("data-svg-origin"), Zs(e, oe || u, !!oe || n.originIsAbsolute, n.smooth !== !1, w)), h = n.xOrigin || 0, b = n.yOrigin || 0, w !== di && (A = w[0], B = w[1], z = w[2], P = w[3], f = I = w[4], d = X = w[5], w.length === 6 ? (_ = Math.sqrt(A * A + B * B), v = Math.sqrt(P * P + z * z), m = A || B ? ur(B, A) * Vn : 0, k = z || P ? ur(z, P) * Vn + m : 0, k && (v *= Math.abs(Math.cos(k * wr))), n.svg && (f -= h - (h * A + b * z), d -= b - (h * B + b * P))) : (J = w[6], jt = w[7], _e = w[8], Ce = w[9], ze = w[10], Fe = w[11], f = w[12], d = w[13], p = w[14], C = ur(J, ze), y = C * Vn, C && (N = Math.cos(-C), j = Math.sin(-C), oe = I * N + _e * j, Oe = X * N + Ce * j, pe = J * N + ze * j, _e = I * -j + _e * N, Ce = X * -j + Ce * N, ze = J * -j + ze * N, Fe = jt * -j + Fe * N, I = oe, X = Oe, J = pe), C = ur(-z, ze), x = C * Vn, C && (N = Math.cos(-C), j = Math.sin(-C), oe = A * N - _e * j, Oe = B * N - Ce * j, pe = z * N - ze * j, Fe = P * j + Fe * N, A = oe, B = Oe, z = pe), C = ur(B, A), m = C * Vn, C && (N = Math.cos(C), j = Math.sin(C), oe = A * N + B * j, Oe = I * N + X * j, B = B * N - A * j, X = X * N - I * j, A = oe, I = Oe), y && Math.abs(y) + Math.abs(m) > 359.9 && (y = m = 0, x = 180 - x), _ = je(Math.sqrt(A * A + B * B + z * z)), v = je(Math.sqrt(X * X + J * J)), C = ur(I, X), k = Math.abs(C) > 2e-4 ? C * Vn : 0, O = Fe ? 1 / (Fe < 0 ? -Fe : Fe) : 0), n.svg && (oe = e.getAttribute("transform"), n.forceCSS = e.setAttribute("transform", "") || !hc(gt(e, Ee)), oe && e.setAttribute("transform", oe))), Math.abs(k) > 90 && Math.abs(k) < 270 && (s ? (_ *= -1, k += m <= 0 ? 180 : -180, m += m <= 0 ? 180 : -180) : (v *= -1, k += k <= 0 ? 180 : -180)), t = t || n.uncache, n.x = f - ((n.xPercent = f && (!t && n.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-f) ? -50 : 0))) ? e.offsetWidth * n.xPercent / 100 : 0) + o, n.y = d - ((n.yPercent = d && (!t && n.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-d) ? -50 : 0))) ? e.offsetHeight * n.yPercent / 100 : 0) + o, n.z = p + o, n.scaleX = je(_), n.scaleY = je(v), n.rotation = je(m) + a, n.rotationX = je(y) + a, n.rotationY = je(x) + a, n.skewX = k + a, n.skewY = E + a, n.transformPerspective = O + o, (n.zOrigin = parseFloat(u.split(" ")[2]) || !t && n.zOrigin || 0) && (i[at] = Ki(u)), n.xOffset = n.yOffset = 0, n.force3D = yt.force3D, n.renderTransform = n.svg ? fd : cc ? mc : ud, n.uncache = 0, n;
}, Ki = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, ks = function(e, t, n) {
  var i = Xe(t);
  return je(parseFloat(t) + parseFloat(An(e, "x", n + "px", i))) + i;
}, ud = function(e, t) {
  t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, mc(e, t);
}, Hn = "0deg", Br = "0px", Gn = ") ", mc = function(e, t) {
  var n = t || this, i = n.xPercent, s = n.yPercent, o = n.x, a = n.y, c = n.z, u = n.rotation, f = n.rotationY, d = n.rotationX, p = n.skewX, _ = n.skewY, v = n.scaleX, m = n.scaleY, y = n.transformPerspective, x = n.force3D, k = n.target, E = n.zOrigin, O = "", h = x === "auto" && e && e !== 1 || x === !0;
  if (E && (d !== Hn || f !== Hn)) {
    var b = parseFloat(f) * wr, w = Math.sin(b), C = Math.cos(b), N;
    b = parseFloat(d) * wr, N = Math.cos(b), o = ks(k, o, w * N * -E), a = ks(k, a, -Math.sin(b) * -E), c = ks(k, c, C * N * -E + E);
  }
  y !== Br && (O += "perspective(" + y + Gn), (i || s) && (O += "translate(" + i + "%, " + s + "%) "), (h || o !== Br || a !== Br || c !== Br) && (O += c !== Br || h ? "translate3d(" + o + ", " + a + ", " + c + ") " : "translate(" + o + ", " + a + Gn), u !== Hn && (O += "rotate(" + u + Gn), f !== Hn && (O += "rotateY(" + f + Gn), d !== Hn && (O += "rotateX(" + d + Gn), (p !== Hn || _ !== Hn) && (O += "skew(" + p + ", " + _ + Gn), (v !== 1 || m !== 1) && (O += "scale(" + v + ", " + m + Gn), k.style[Ee] = O || "translate(0, 0)";
}, fd = function(e, t) {
  var n = t || this, i = n.xPercent, s = n.yPercent, o = n.x, a = n.y, c = n.rotation, u = n.skewX, f = n.skewY, d = n.scaleX, p = n.scaleY, _ = n.target, v = n.xOrigin, m = n.yOrigin, y = n.xOffset, x = n.yOffset, k = n.forceCSS, E = parseFloat(o), O = parseFloat(a), h, b, w, C, N;
  c = parseFloat(c), u = parseFloat(u), f = parseFloat(f), f && (f = parseFloat(f), u += f, c += f), c || u ? (c *= wr, u *= wr, h = Math.cos(c) * d, b = Math.sin(c) * d, w = Math.sin(c - u) * -p, C = Math.cos(c - u) * p, u && (f *= wr, N = Math.tan(u - f), N = Math.sqrt(1 + N * N), w *= N, C *= N, f && (N = Math.tan(f), N = Math.sqrt(1 + N * N), h *= N, b *= N)), h = je(h), b = je(b), w = je(w), C = je(C)) : (h = d, C = p, b = w = 0), (E && !~(o + "").indexOf("px") || O && !~(a + "").indexOf("px")) && (E = An(_, "x", o, "px"), O = An(_, "y", a, "px")), (v || m || y || x) && (E = je(E + v - (v * h + m * w) + y), O = je(O + m - (v * b + m * C) + x)), (i || s) && (N = _.getBBox(), E = je(E + i / 100 * N.width), O = je(O + s / 100 * N.height)), N = "matrix(" + h + "," + b + "," + w + "," + C + "," + E + "," + O + ")", _.setAttribute("transform", N), k && (_.style[Ee] = N);
}, dd = function(e, t, n, i, s) {
  var o = 360, a = Ie(s), c = parseFloat(s) * (a && ~s.indexOf("rad") ? Vn : 1), u = c - i, f = i + u + "deg", d, p;
  return a && (d = s.split("_")[1], d === "short" && (u %= o, u !== u % (o / 2) && (u += u < 0 ? o : -o)), d === "cw" && u < 0 ? u = (u + o * ia) % o - ~~(u / o) * o : d === "ccw" && u > 0 && (u = (u - o * ia) % o - ~~(u / o) * o)), e._pt = p = new ot(e._pt, t, n, i, u, Vf), p.e = f, p.u = "deg", e._props.push(n), p;
}, fa = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, hd = function(e, t, n) {
  var i = fa({}, n._gsap), s = "perspective,force3D,transformOrigin,svgOrigin", o = n.style, a, c, u, f, d, p, _, v;
  i.svg ? (u = n.getAttribute("transform"), n.setAttribute("transform", ""), o[Ee] = t, a = hi(n, 1), Mn(n, Ee), n.setAttribute("transform", u)) : (u = getComputedStyle(n)[Ee], o[Ee] = t, a = hi(n, 1), o[Ee] = u);
  for (c in ln)
    u = i[c], f = a[c], u !== f && s.indexOf(c) < 0 && (_ = Xe(u), v = Xe(f), d = _ !== v ? An(n, c, u, v) : parseFloat(u), p = parseFloat(f), e._pt = new ot(e._pt, a, c, d, p - d, Xs), e._pt.u = v || 0, e._props.push(c));
  fa(a, i);
};
st("padding,margin,Width,Radius", function(r, e) {
  var t = "Top", n = "Right", i = "Bottom", s = "Left", o = (e < 3 ? [t, n, i, s] : [t + s, t + n, i + n, i + s]).map(function(a) {
    return e < 2 ? r + a : "border" + a + r;
  });
  Xi[e > 1 ? "border" + r : r] = function(a, c, u, f, d) {
    var p, _;
    if (arguments.length < 4)
      return p = o.map(function(v) {
        return tn(a, v, u);
      }), _ = p.join(" "), _.split(p[0]).length === 5 ? p[0] : _;
    p = (f + "").split(" "), _ = {}, o.forEach(function(v, m) {
      return _[v] = p[m] = p[m] || p[(m - 1) / 2 | 0];
    }), a.init(c, _, d);
  };
});
var pc = {
  name: "css",
  register: Qs,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, t, n, i, s) {
    var o = this._props, a = e.style, c = n.vars.startAt, u, f, d, p, _, v, m, y, x, k, E, O, h, b, w, C, N;
    wo || Qs(), this.styles = this.styles || lc(e), C = this.styles.props, this.tween = n;
    for (m in t)
      if (m !== "autoRound" && (f = t[m], !(ht[m] && Ql(m, t, n, i, e, s)))) {
        if (_ = typeof f, v = Xi[m], _ === "function" && (f = f.call(n, i, e, s), _ = typeof f), _ === "string" && ~f.indexOf("random(") && (f = ci(f)), v)
          v(this, e, m, f, n) && (w = 1);
        else if (m.substr(0, 2) === "--")
          u = (getComputedStyle(e).getPropertyValue(m) + "").trim(), f += "", Cn.lastIndex = 0, Cn.test(u) || (y = Xe(u), x = Xe(f), x ? y !== x && (u = An(e, m, u, x) + x) : y && (f += y)), this.add(a, "setProperty", u, f, i, s, 0, 0, m), o.push(m), C.push(m, 0, a[m]);
        else if (_ !== "undefined") {
          if (c && m in c ? (u = typeof c[m] == "function" ? c[m].call(n, i, e, s) : c[m], Ie(u) && ~u.indexOf("random(") && (u = ci(u)), Xe(u + "") || u === "auto" || (u += yt.units[m] || Xe(tn(e, m)) || ""), (u + "").charAt(1) === "=" && (u = tn(e, m))) : u = tn(e, m), p = parseFloat(u), k = _ === "string" && f.charAt(1) === "=" && f.substr(0, 2), k && (f = f.substr(2)), d = parseFloat(f), m in Ut && (m === "autoAlpha" && (p === 1 && tn(e, "visibility") === "hidden" && d && (p = 0), C.push("visibility", 0, a.visibility), Nn(this, a, "visibility", p ? "inherit" : "hidden", d ? "inherit" : "hidden", !d)), m !== "scale" && m !== "transform" && (m = Ut[m], ~m.indexOf(",") && (m = m.split(",")[0]))), E = m in ln, E) {
            if (this.styles.save(m), N = f, _ === "string" && f.substring(0, 6) === "var(--") {
              if (f = gt(e, f.substring(4, f.indexOf(")"))), f.substring(0, 5) === "calc(") {
                var j = e.style.perspective;
                e.style.perspective = f, f = gt(e, "perspective"), j ? e.style.perspective = j : Mn(e, "perspective");
              }
              d = parseFloat(f);
            }
            if (O || (h = e._gsap, h.renderTransform && !t.parseTransform || hi(e, t.parseTransform), b = t.smoothOrigin !== !1 && h.smooth, O = this._pt = new ot(this._pt, a, Ee, 0, 1, h.renderTransform, h, 0, -1), O.dep = 1), m === "scale")
              this._pt = new ot(this._pt, h, "scaleY", h.scaleY, (k ? vr(h.scaleY, k + d) : d) - h.scaleY || 0, Xs), this._pt.u = 0, o.push("scaleY", m), m += "X";
            else if (m === "transformOrigin") {
              C.push(at, 0, a[at]), f = ld(f), h.svg ? Zs(e, f, 0, b, 0, this) : (x = parseFloat(f.split(" ")[2]) || 0, x !== h.zOrigin && Nn(this, h, "zOrigin", h.zOrigin, x), Nn(this, a, m, Ki(u), Ki(f)));
              continue;
            } else if (m === "svgOrigin") {
              Zs(e, f, 1, b, 0, this);
              continue;
            } else if (m in dc) {
              dd(this, h, m, p, k ? vr(p, k + f) : f);
              continue;
            } else if (m === "smoothOrigin") {
              Nn(this, h, "smooth", h.smooth, f);
              continue;
            } else if (m === "force3D") {
              h[m] = f;
              continue;
            } else if (m === "transform") {
              hd(this, f, e);
              continue;
            }
          } else m in a || (m = Cr(m) || m);
          if (E || (d || d === 0) && (p || p === 0) && !$f.test(f) && m in a)
            y = (u + "").substr((p + "").length), d || (d = 0), x = Xe(f) || (m in yt.units ? yt.units[m] : y), y !== x && (p = An(e, m, u, x)), this._pt = new ot(this._pt, E ? h : a, m, p, (k ? vr(p, k + d) : d) - p, !E && (x === "px" || m === "zIndex") && t.autoRound !== !1 ? Qf : Xs), this._pt.u = x || 0, E && N !== f ? (this._pt.b = u, this._pt.e = N, this._pt.r = Kf) : y !== x && x !== "%" && (this._pt.b = u, this._pt.r = Xf);
          else if (m in a)
            ad.call(this, e, m, u, k ? k + f : f);
          else if (m in e)
            this.add(e, m, u || e[m], k ? k + f : f, i, s);
          else if (m !== "parseTransform") {
            fo(m, f);
            continue;
          }
          E || (m in a ? C.push(m, 0, a[m]) : typeof e[m] == "function" ? C.push(m, 2, e[m]()) : C.push(m, 1, u || e[m])), o.push(m);
        }
      }
    w && rc(this);
  },
  render: function(e, t) {
    if (t.tween._time || !To())
      for (var n = t._pt; n; )
        n.r(e, n.d), n = n._next;
    else
      t.styles.revert();
  },
  get: tn,
  aliases: Ut,
  getSetter: function(e, t, n) {
    var i = Ut[t];
    return i && i.indexOf(",") < 0 && (t = i), t in ln && t !== at && (e._gsap.x || tn(e, "x")) ? n && ra === n ? t === "scale" ? td : ed : (ra = n || {}) && (t === "scale" ? nd : rd) : e.style && !lo(e.style[t]) ? Zf : ~t.indexOf("-") ? Jf : vo(e, t);
  },
  core: {
    _removeProperty: Mn,
    _getMatrix: Eo
  }
};
lt.utils.checkPrefix = Cr;
lt.core.getStyleSaver = lc;
(function(r, e, t, n) {
  var i = st(r + "," + e + "," + t, function(s) {
    ln[s] = 1;
  });
  st(e, function(s) {
    yt.units[s] = "deg", dc[s] = 1;
  }), Ut[i[13]] = r + "," + e, st(n, function(s) {
    var o = s.split(":");
    Ut[o[1]] = i[o[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
st("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(r) {
  yt.units[r] = "px";
});
lt.registerPlugin(pc);
var Qi = lt.registerPlugin(pc) || lt;
Qi.core.Tween;
var Ke, gc, on, Ht, jn, _c, Tr, Di, yc = function() {
  return typeof window < "u";
}, bc = function() {
  return Ke || yc() && (Ke = window.gsap) && Ke.registerPlugin && Ke;
}, vc = function(e) {
  return typeof e == "string";
}, da = function(e) {
  return typeof e == "function";
}, mi = function(e, t) {
  var n = t === "x" ? "Width" : "Height", i = "scroll" + n, s = "client" + n;
  return e === on || e === Ht || e === jn ? Math.max(Ht[i], jn[i]) - (on["inner" + n] || Ht[s] || jn[s]) : e[i] - e["offset" + n];
}, pi = function(e, t) {
  var n = "scroll" + (t === "x" ? "Left" : "Top");
  return e === on && (e.pageXOffset != null ? n = "page" + t.toUpperCase() + "Offset" : e = Ht[n] != null ? Ht : jn), function() {
    return e[n];
  };
}, md = function(e, t, n, i) {
  if (da(e) && (e = e(t, n, i)), typeof e != "object")
    return vc(e) && e !== "max" && e.charAt(1) !== "=" ? {
      x: e,
      y: e
    } : {
      y: e
    };
  if (e.nodeType)
    return {
      y: e,
      x: e
    };
  var s = {}, o;
  for (o in e)
    s[o] = o !== "onAutoKill" && da(e[o]) ? e[o](t, n, i) : e[o];
  return s;
}, xc = function(e, t) {
  if (e = _c(e)[0], !e || !e.getBoundingClientRect)
    return console.warn("scrollTo target doesn't exist. Using 0") || {
      x: 0,
      y: 0
    };
  var n = e.getBoundingClientRect(), i = !t || t === on || t === jn, s = i ? {
    top: Ht.clientTop - (on.pageYOffset || Ht.scrollTop || jn.scrollTop || 0),
    left: Ht.clientLeft - (on.pageXOffset || Ht.scrollLeft || jn.scrollLeft || 0)
  } : t.getBoundingClientRect(), o = {
    x: n.left - s.left,
    y: n.top - s.top
  };
  return !i && t && (o.x += pi(t, "x")(), o.y += pi(t, "y")()), o;
}, ha = function(e, t, n, i, s) {
  return !isNaN(e) && typeof e != "object" ? parseFloat(e) - s : vc(e) && e.charAt(1) === "=" ? parseFloat(e.substr(2)) * (e.charAt(0) === "-" ? -1 : 1) + i - s : e === "max" ? mi(t, n) - s : Math.min(mi(t, n), xc(e, t)[n] - s);
}, Js = function() {
  Ke = bc(), yc() && Ke && typeof document < "u" && document.body && (on = window, jn = document.body, Ht = document.documentElement, _c = Ke.utils.toArray, Ke.config({
    autoKillThreshold: 7
  }), Tr = Ke.config(), gc = 1);
}, Dr = {
  version: "3.15.0",
  name: "scrollTo",
  rawVars: 1,
  register: function(e) {
    Ke = e, Js();
  },
  init: function(e, t, n, i, s) {
    gc || Js();
    var o = this, a = Ke.getProperty(e, "scrollSnapType");
    o.isWin = e === on, o.target = e, o.tween = n, t = md(t, i, e, s), o.vars = t, o.autoKill = !!("autoKill" in t ? t : Tr).autoKill, o.getX = pi(e, "x"), o.getY = pi(e, "y"), o.x = o.xPrev = o.getX(), o.y = o.yPrev = o.getY(), Di || (Di = Ke.core.globals().ScrollTrigger), Ke.getProperty(e, "scrollBehavior") === "smooth" && Ke.set(e, {
      scrollBehavior: "auto"
    }), a && a !== "none" && (o.snap = 1, o.snapInline = e.style.scrollSnapType, e.style.scrollSnapType = "none"), t.x != null ? (o.add(o, "x", o.x, ha(t.x, e, "x", o.x, t.offsetX || 0), i, s), o._props.push("scrollTo_x")) : o.skipX = 1, t.y != null ? (o.add(o, "y", o.y, ha(t.y, e, "y", o.y, t.offsetY || 0), i, s), o._props.push("scrollTo_y")) : o.skipY = 1;
  },
  render: function(e, t) {
    for (var n = t._pt, i = t.target, s = t.tween, o = t.autoKill, a = t.xPrev, c = t.yPrev, u = t.isWin, f = t.snap, d = t.snapInline, p, _, v, m, y; n; )
      n.r(e, n.d), n = n._next;
    p = u || !t.skipX ? t.getX() : a, _ = u || !t.skipY ? t.getY() : c, v = _ - c, m = p - a, y = Tr.autoKillThreshold, t.x < 0 && (t.x = 0), t.y < 0 && (t.y = 0), o && (!t.skipX && (m > y || m < -y) && p < mi(i, "x") && (t.skipX = 1), !t.skipY && (v > y || v < -y) && _ < mi(i, "y") && (t.skipY = 1), t.skipX && t.skipY && (s.kill(), t.vars.onAutoKill && t.vars.onAutoKill.apply(s, t.vars.onAutoKillParams || []))), u ? on.scrollTo(t.skipX ? p : t.x, t.skipY ? _ : t.y) : (t.skipY || (i.scrollTop = t.y), t.skipX || (i.scrollLeft = t.x)), f && (e === 1 || e === 0) && (_ = i.scrollTop, p = i.scrollLeft, d ? i.style.scrollSnapType = d : i.style.removeProperty("scroll-snap-type"), i.scrollTop = _ + 1, i.scrollLeft = p + 1, i.scrollTop = _, i.scrollLeft = p), t.xPrev = t.x, t.yPrev = t.y, Di && Di.update();
  },
  kill: function(e) {
    var t = e === "scrollTo", n = this._props.indexOf(e);
    return (t || e === "scrollTo_x") && (this.skipX = 1), (t || e === "scrollTo_y") && (this.skipY = 1), n > -1 && this._props.splice(n, 1), !this._props.length;
  }
};
Dr.max = mi;
Dr.getOffset = xc;
Dr.buildGetter = pi;
Dr.config = function(r) {
  Tr || Js() || (Tr = Ke.config());
  for (var e in r)
    Tr[e] = r[e];
};
bc() && Ke.registerPlugin(Dr);
let ma = typeof document < "u" ? pl : cn, pa = (r) => r && !Array.isArray(r) && typeof r == "object", Mi = [], pd = {}, wc = Qi;
const Zi = (r, e = Mi) => {
  let t = pd;
  pa(r) ? (t = r, r = null, e = "dependencies" in t ? t.dependencies : Mi) : pa(e) && (t = e, e = "dependencies" in t ? t.dependencies : Mi), r && typeof r != "function" && console.warn("First parameter must be a function or config object");
  const { scope: n, revertOnUpdate: i } = t, s = _t(!1), o = _t(wc.context(() => {
  }, n)), a = _t((u) => o.current.add(null, u)), c = e && e.length && !i;
  return c && ma(() => (s.current = !0, () => o.current.revert()), Mi), ma(() => {
    if (r && o.current.add(r, n), !c || !s.current)
      return () => o.current.revert();
  }, e), { context: o.current, contextSafe: a.current };
};
Zi.register = (r) => {
  wc = r;
};
Zi.headless = !0;
function gd({ heading: r, icon: e, open: t, className: n, onClick: i, children: s }) {
  Qi.registerPlugin(Zi, Dr);
  const o = _t(null), a = _t(null);
  return Zi(() => {
    o.current && t && Qi.fromTo(
      a.current,
      { height: 0 },
      { height: "auto", duration: 0.5, ease: "power2.out" }
    );
  }, { dependencies: [t] }), /* @__PURE__ */ l.jsxs(
    "details",
    {
      className: `accordion-panel${n ? ` ${n}` : ""}`,
      open: t,
      onClick: i,
      children: [
        /* @__PURE__ */ l.jsx(
          "summary",
          {
            className: "flex-row accordion-panel-heading",
            ref: o,
            children: /* @__PURE__ */ l.jsxs("div", { className: "flex-row", children: [
              e && e,
              r
            ] })
          }
        ),
        /* @__PURE__ */ l.jsx("div", { className: "accordion-panel-content", ref: a, children: s })
      ]
    }
  );
}
function Pg({ children: r, className: e, gap: t = 0 }) {
  return bu.forEach(r, (n) => {
    if (!vu(n) || n.type !== gd)
      throw new Error("The Accordion component only accepts AccordionPanel components as children.");
  }), /* @__PURE__ */ l.jsx("div", { className: `flex-col stretch accordion-container${e ? ` ${e}` : ""}`, style: { rowGap: `${t}px` }, children: r });
}
function Tc(r) {
  const { className: e, children: t, id: n, dismissedAlerts: i, setDismissedAlerts: s } = r;
  return /* @__PURE__ */ l.jsxs("div", { className: `alert-banner flex-row fill ${e}`, children: [
    /* @__PURE__ */ l.jsx("div", { className: "alert-banner-content flex-row center", children: t }),
    /* @__PURE__ */ l.jsx(
      "button",
      {
        className: "text-only",
        onClick: () => s([...i, n]),
        children: "dismiss"
      }
    )
  ] });
}
function G(r) {
  const { glyph: e, src: t = "", className: n = "", style: i = {}, onClick: s } = r, o = t ? {
    maskImage: `url("${t}")`,
    WebkitMaskImage: `url("${t}")`,
    MozMaskImage: `url("${t}")`,
    msMaskImage: `url("${t}")`,
    ...i
  } : i, a = [
    "icon",
    "bi",
    e && !t && "bi-" + e,
    // don't use glyph if a src is provided.
    t && "custom",
    n
  ];
  return /* @__PURE__ */ l.jsx(
    "i",
    {
      className: a.filter(Boolean).join(" "),
      style: o,
      onClick: s
    }
  );
}
function Zn(r) {
  const { type: e = "", className: t = "", children: n } = r;
  return /* @__PURE__ */ l.jsxs("div", { className: `alert-box ${e} ${t}`, children: [
    e === "info" && /* @__PURE__ */ l.jsx(G, { glyph: "info-circle-fill", className: "alert-icon" }),
    e === "warning" && /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-circle-fill", className: "alert-icon" }),
    e === "error" && /* @__PURE__ */ l.jsx(G, { glyph: "x-circle-fill", className: "alert-icon" }),
    e === "success" && /* @__PURE__ */ l.jsx(G, { glyph: "check-circle-fill", className: "alert-icon" }),
    /* @__PURE__ */ l.jsx("div", { className: "alert-message", children: n })
  ] });
}
function Xn(r) {
  const { type: e = "", className: t = "", children: n } = r;
  return /* @__PURE__ */ l.jsx("div", { className: `alert-message ${e} ${t}`, children: n });
}
function Ig(r) {
  const [e, t] = Pe({});
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(ku.Provider, { value: e, children: /* @__PURE__ */ l.jsx(Eu.Provider, { value: t, children: r.children }) }) });
}
function Lg() {
  const { instance: r } = gl(), e = no();
  return cn(() => {
    const t = r.addEventCallback((n) => {
      if (n.eventType === Cu.LOGIN_SUCCESS) {
        const i = n.payload;
        if (i?.state) {
          const { returnPath: s } = JSON.parse(i.state);
          e(s || "/", { replace: !0 });
        } else
          e("/", { replace: !0 });
      }
    });
    return () => {
      t && r.removeEventCallback(t);
    };
  }, [r]), /* @__PURE__ */ l.jsx(l.Fragment, {});
}
function Fg(r) {
  const { scopes: e = [], roles: t = [], groups: n = [] } = r, i = io(), [s] = sr(), { pathname: o, search: a } = ts(), c = ns({ scopes: e }), u = _l();
  if ((t.length || n.length) && !e.length)
    throw new Error("At least one scope must be provided to the AuthRouteGuard component if any roles/groups are required.");
  const { data: f, isLoading: d } = ir({
    enabled: !!c,
    queryKey: ["dealerAccessApiToken"],
    queryFn: () => c()
  }), p = rs(f?.accessTokenClaims), _ = d;
  function v() {
    if (n.length === 0 && t.length === 0) return !0;
    const y = n.length === 0 || n?.some((k) => p?.hasGroup(k)), x = t.length === 0 || t?.some((k) => p?.hasRole(k));
    return y || x ? !0 : (i.debug("User is not authorized to view this page.", {
      source: "AuthRouteGuard",
      action: "authorize",
      user: {
        groups: p?.get("groups"),
        roles: p?.get("roles"),
        id: p?.get("id")
      }
    }), !1);
  }
  if (!u)
    return /* @__PURE__ */ l.jsx(_d, { returnUri: o + a });
  const m = s === "gp" ? /* @__PURE__ */ l.jsx(kd, { overlay: !0 }) : /* @__PURE__ */ l.jsx(Od, {});
  return _ ? m : v() ? /* @__PURE__ */ l.jsx(ro, {}) : /* @__PURE__ */ l.jsx(Pd, {});
}
function Wg(r) {
  const [e, t] = Pe(!0), n = new ju(r.config);
  return n.initialize().catch((i) => console.error(i)).finally(() => t(!1)), e ? /* @__PURE__ */ l.jsx(l.Fragment, {}) : /* @__PURE__ */ l.jsx(Ou, { instance: n, children: r.children });
}
function _d(r) {
  const { returnUri: e } = r, t = _t(!1), { instance: n, accounts: i, inProgress: s } = gl(), o = no(), a = async () => {
    t.current = !0;
    const u = {
      scopes: [],
      state: JSON.stringify({
        returnUri: e || "/"
      }),
      responseMode: "query"
    };
    try {
      n.loginRedirect(u);
    } catch (f) {
      console.error(f);
    }
  };
  return cn(() => {
    s === Du.None && i.length < 1 && !t.current && a(), i.length && o(e);
  }, [i, s]), /* @__PURE__ */ l.jsx(l.Fragment, {});
}
function ga(r) {
  if (typeof r != "string")
    throw new Error("Please provide a valid string.");
  return r.trim().toLowerCase().split(" ").map((t) => t[0].toUpperCase() + t.slice(1)).join(" ");
}
function yd(r) {
  const { breadcrumbs: e, basePath: t } = r, { pathname: n } = ts();
  let i = {};
  return e ? i = e : n.split("/").filter((o) => o.length > 0).forEach((o) => {
    i[ga(o.replaceAll("-", " "))] = n.substring(0, n.lastIndexOf(o) + o.length);
  }), Object.keys(i).length === 0 && !t ? null : /* @__PURE__ */ l.jsx("nav", { className: "breadcrumbs", "aria-label": "breadcrumbs", children: /* @__PURE__ */ l.jsxs("ul", { className: "no-marker flex-row middle", children: [
    t ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "/", children: "Home" }) }),
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(Ve, { to: "/", children: ga(t.replaceAll("-", " ")) }) })
    ] }) : /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(Ve, { to: "/", children: "Home" }) }),
    Object.keys(i).map(
      (s) => /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(Ve, { to: i[s], children: s }) }, s)
    )
  ] }) });
}
function bd(r) {
  const { title: e, icon: t, children: n, className: i = "", collapsible: s = !1, disabled: o = !1 } = r;
  return s ? /* @__PURE__ */ l.jsxs(
    "details",
    {
      className: ["block border full stretch content-block", i, o ? "disabled" : null].filter(Boolean).join(" "),
      open: o ? !1 : void 0,
      children: [
        /* @__PURE__ */ l.jsxs(
          "summary",
          {
            className: "content-block-heading flex-row space middle noscroll",
            onClick: (a) => {
              o && a.preventDefault();
            },
            children: [
              /* @__PURE__ */ l.jsxs("div", { className: "flex-inline middle content-block-heading-text", children: [
                t,
                /* @__PURE__ */ l.jsx("h2", { children: e })
              ] }),
              /* @__PURE__ */ l.jsx(G, { glyph: "caret-right-fill" })
            ]
          }
        ),
        /* @__PURE__ */ l.jsx("div", { className: "content flex-col", children: n })
      ]
    }
  ) : /* @__PURE__ */ l.jsxs("section", { className: ["block border full stretch content-block", i].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ l.jsxs("div", { className: "content-block-heading flex-row middle noscroll", children: [
      t,
      /* @__PURE__ */ l.jsx("h2", { children: e })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "content flex-col", children: n })
  ] });
}
function Yg(r) {
  const { hasTitle: e, className: t = "" } = r;
  return /* @__PURE__ */ l.jsxs("section", { className: `block border full stretch content-block loading ${t}`, children: [
    e && /* @__PURE__ */ l.jsx("div", { className: "content-block-heading flex-row middle noscroll", children: /* @__PURE__ */ l.jsx("h2", { children: " " }) }),
    /* @__PURE__ */ l.jsx("div", { className: "content flex-col" })
  ] });
}
var zi = { exports: {} }, vd = zi.exports, _a;
function xd() {
  return _a || (_a = 1, (function(r) {
    (function(e, t) {
      r.exports ? r.exports = t() : e.log = t();
    })(vd, function() {
      var e = function() {
      }, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], s = {}, o = null;
      function a(m, y) {
        var x = m[y];
        if (typeof x.bind == "function")
          return x.bind(m);
        try {
          return Function.prototype.bind.call(x, m);
        } catch {
          return function() {
            return Function.prototype.apply.apply(x, [m, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function u(m) {
        return m === "debug" && (m = "log"), typeof console === t ? !1 : m === "trace" && n ? c : console[m] !== void 0 ? a(console, m) : console.log !== void 0 ? a(console, "log") : e;
      }
      function f() {
        for (var m = this.getLevel(), y = 0; y < i.length; y++) {
          var x = i[y];
          this[x] = y < m ? e : this.methodFactory(x, m, this.name);
        }
        if (this.log = this.debug, typeof console === t && m < this.levels.SILENT)
          return "No console available for logging";
      }
      function d(m) {
        return function() {
          typeof console !== t && (f.call(this), this[m].apply(this, arguments));
        };
      }
      function p(m, y, x) {
        return u(m) || d.apply(this, arguments);
      }
      function _(m, y) {
        var x = this, k, E, O, h = "loglevel";
        typeof m == "string" ? h += ":" + m : typeof m == "symbol" && (h = void 0);
        function b(A) {
          var B = (i[A] || "silent").toUpperCase();
          if (!(typeof window === t || !h)) {
            try {
              window.localStorage[h] = B;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(h) + "=" + B + ";";
            } catch {
            }
          }
        }
        function w() {
          var A;
          if (!(typeof window === t || !h)) {
            try {
              A = window.localStorage[h];
            } catch {
            }
            if (typeof A === t)
              try {
                var B = window.document.cookie, z = encodeURIComponent(h), P = B.indexOf(z + "=");
                P !== -1 && (A = /^([^;]+)/.exec(
                  B.slice(P + z.length + 1)
                )[1]);
              } catch {
              }
            return x.levels[A] === void 0 && (A = void 0), A;
          }
        }
        function C() {
          if (!(typeof window === t || !h)) {
            try {
              window.localStorage.removeItem(h);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(h) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function N(A) {
          var B = A;
          if (typeof B == "string" && x.levels[B.toUpperCase()] !== void 0 && (B = x.levels[B.toUpperCase()]), typeof B == "number" && B >= 0 && B <= x.levels.SILENT)
            return B;
          throw new TypeError("log.setLevel() called with invalid level: " + A);
        }
        x.name = m, x.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, x.methodFactory = y || p, x.getLevel = function() {
          return O ?? E ?? k;
        }, x.setLevel = function(A, B) {
          return O = N(A), B !== !1 && b(O), f.call(x);
        }, x.setDefaultLevel = function(A) {
          E = N(A), w() || x.setLevel(A, !1);
        }, x.resetLevel = function() {
          O = null, C(), f.call(x);
        }, x.enableAll = function(A) {
          x.setLevel(x.levels.TRACE, A);
        }, x.disableAll = function(A) {
          x.setLevel(x.levels.SILENT, A);
        }, x.rebuild = function() {
          if (o !== x && (k = N(o.getLevel())), f.call(x), o === x)
            for (var A in s)
              s[A].rebuild();
        }, k = N(
          o ? o.getLevel() : "WARN"
        );
        var j = w();
        j != null && (O = N(j)), f.call(x);
      }
      o = new _(), o.getLogger = function(y) {
        if (typeof y != "symbol" && typeof y != "string" || y === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var x = s[y];
        return x || (x = s[y] = new _(
          y,
          o.methodFactory
        )), x;
      };
      var v = typeof window !== t ? window.log : void 0;
      return o.noConflict = function() {
        return typeof window !== t && window.log === o && (window.log = v), o;
      }, o.getLoggers = function() {
        return s;
      }, o.default = o, o;
    });
  })(zi)), zi.exports;
}
var wd = xd();
const ya = /* @__PURE__ */ bl(wd);
class Td {
  loggedMessages = /* @__PURE__ */ new Set();
  instance;
  logHandlers = [];
  errorLogHandlers = [];
  constructor(e = "info") {
    ya.setLevel(e), this.instance = ya;
  }
  logMessage(e, t, n) {
    const i = `${t}:${JSON.stringify(n)}`;
    if (!this.loggedMessages.has(i)) {
      const s = {
        level: e,
        timestamp: (/* @__PURE__ */ new Date()).toLocaleString()
      }, o = {
        message: t,
        ...s,
        ...n
      };
      this.instance[e](o), this.loggedMessages.add(i), this.logHandlers.filter((a) => a.logLevels.includes(e)).forEach((a) => a.handle(t, n));
    }
  }
  logError(e, t = {}) {
    const n = `${e.message}:${JSON.stringify(t)}`;
    if (!this.loggedMessages.has(n)) {
      const i = {
        message: e.message,
        error: {
          type: e.name,
          stack: e.stack
        },
        level: "error",
        timestamp: (/* @__PURE__ */ new Date()).toLocaleString(),
        ...t
      };
      this.instance.error(i), this.loggedMessages.add(n), this.errorLogHandlers.forEach((s) => s(e, t));
    }
  }
  debug(e, t = {}) {
    this.logMessage("debug", e, t);
  }
  info(e, t = {}) {
    this.logMessage("info", e, t);
  }
  warn(e, t = {}) {
    this.logMessage("warn", e, t);
  }
  error(e, t = {}) {
    this.logError(e, t);
  }
  addLogHandler(e, t) {
    return this.logHandlers.push({ logLevels: e, handle: t }), this;
  }
  addErrorLogHandler(e) {
    return this.errorLogHandlers.push(e), this;
  }
}
class ba extends xu {
  logger;
  constructor(e) {
    super(e), this.state = {
      hasError: !1
    }, this.logger = e?.logger || new Td("info");
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(e, t) {
    this.logger.error(e, {
      alert: !0,
      errorInfo: t
    }), this.props.callback && this.props.callback();
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
function va() {
  const [r] = sr(), e = r === "gp" ? "Great Plains " : r === "lp" ? "Land Pride " : "";
  return /* @__PURE__ */ l.jsxs("div", { className: "error-display flex-col full center", children: [
    /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-octagon", style: { fontSize: "8rem" }, className: "danger" }),
    /* @__PURE__ */ l.jsx("h1", { children: "Something Isn't Right Here!" }),
    /* @__PURE__ */ l.jsxs("p", { children: [
      "The ",
      e,
      "developers have been made aware of this issue."
    ] }),
    /* @__PURE__ */ l.jsx("p", { children: "Please try refreshing the page." }),
    /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("button", { onClick: () => window.location.reload(), children: "Reload" }) })
  ] });
}
function Bg({ message: r = "An error occurred." }) {
  return /* @__PURE__ */ l.jsx("div", { className: "error-display component flex-row middle full center", children: /* @__PURE__ */ l.jsx("div", { className: "message-box flex-col center", children: /* @__PURE__ */ l.jsxs("div", { className: "headline flex-row middle", children: [
    /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-octagon", className: "danger xl" }),
    /* @__PURE__ */ l.jsx("strong", { children: "Error:" }),
    r
  ] }) }) });
}
function zg() {
  const [r] = sr(), e = (t) => {
    switch (t) {
      case "gp":
        return "Great Plains Ag";
      case "lp":
        return "Land Pride";
      default:
        return "";
    }
  };
  return /* @__PURE__ */ l.jsxs("footer", { className: "page-footer", children: [
    /* @__PURE__ */ l.jsx("section", { className: "footer-section primary", children: /* @__PURE__ */ l.jsxs("div", { className: "footer-wrapper", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "flex-row", children: [
        /* @__PURE__ */ l.jsx(gi, { type: r, height: "62px" }),
        /* @__PURE__ */ l.jsxs("div", { children: [
          /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("strong", { children: e(r).toUpperCase() }) }),
          /* @__PURE__ */ l.jsx("div", { children: "1525 E. NORTH STREET" }),
          /* @__PURE__ */ l.jsx("div", { children: "SALINA, KS 67401" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-row", children: [
        /* @__PURE__ */ l.jsx(Ve, { to: "/", children: "Privacy Policy" }),
        /* @__PURE__ */ l.jsx(Ve, { to: "/" }),
        /* @__PURE__ */ l.jsx(Ve, { to: "/" })
      ] })
    ] }) }),
    /* @__PURE__ */ l.jsx("section", { className: "footer-section secondary", children: /* @__PURE__ */ l.jsx("div", { className: "footer-wrapper", children: /* @__PURE__ */ l.jsx("div", { className: "caption", children: "Copyright © 2025, Great Plains Manufacturing, Inc. All Rights Reserved" }) }) })
  ] });
}
function Ug(r) {
  const { message: e, className: t } = r;
  return /* @__PURE__ */ l.jsxs("div", { className: `validation-error-tooltip ${t}`, children: [
    /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-triangle", className: "large" }),
    " ",
    e
  ] });
}
function Hg(r) {
  const {
    header: e = null,
    sidebar: t = null,
    footer: n = null
  } = r, i = io(), s = yl("1300px"), { pathname: o } = ts();
  return /* @__PURE__ */ l.jsx(ba, { fallback: /* @__PURE__ */ l.jsx(va, {}), logger: i, children: /* @__PURE__ */ l.jsxs("div", { className: "layout-container", children: [
    e,
    /* @__PURE__ */ l.jsxs("div", { className: "body-container", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "content-scroll-region", children: [
        /* @__PURE__ */ l.jsxs("div", { className: "content-layout", children: [
          /* @__PURE__ */ l.jsx("main", { className: "main-content", children: /* @__PURE__ */ l.jsx(ba, { fallback: /* @__PURE__ */ l.jsx(va, {}), logger: i, children: /* @__PURE__ */ l.jsx(ro, {}) }, o) }),
          !s && t && /* @__PURE__ */ l.jsx(Id, { children: t })
        ] }),
        n
      ] }),
      s && t && /* @__PURE__ */ l.jsx(Ld, { children: t })
    ] })
  ] }) }, o);
}
function Gg({ redirectPath: r }) {
  const e = io(), { dealerAccessApiScope: t, dealerAccessApiHost: n } = is(), { pathname: i, search: s } = ts(), [o] = sr(), a = ns({ scopes: [t] }), { data: c, loading: u } = so(), { data: f, isLoading: d } = ir({
    enabled: !!a,
    queryKey: ["dealerAccessApiToken"],
    queryFn: () => a()
  }), p = rs(f?.accessTokenClaims), { data: _, loading: v } = Au(), { data: m, isLoading: y } = ir({
    enabled: !!(_ && a),
    queryKey: ["dealerInfo", _, "divisions"],
    queryFn: () => a().then((k) => Wu(n, k.accessToken, _)).then((k) => k.json())
  }), x = !u && !d && !v && !y && !c && !!m && !i.includes(r);
  return x && e.warn("A user attempted to access the wrong division for this dealer.", {
    source: "Layout",
    user: {
      id: p?.get("id"),
      mask: _
    },
    path: i + s,
    theme: o
  }), x ? /* @__PURE__ */ l.jsx(Mu, { to: r, replace: !0 }) : /* @__PURE__ */ l.jsx(ro, {});
}
const kd = ({ overlay: r }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  r && /* @__PURE__ */ l.jsx("div", { className: "loading-backdrop" }),
  /* @__PURE__ */ l.jsx("div", { className: "loading-wrapper", children: /* @__PURE__ */ l.jsx("div", { className: "loading-bars" + (r ? " overlay" : "") }) })
] }), Ed = "data:image/svg+xml,%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%2016'%3e%3cpath%20d='M2.82,14.09c-1.8-1.53-2.82-3.75-2.82-6.09C0,3.59,3.59,0,8,0s8,3.59,8,8c0,2.35-1.03,4.57-2.82,6.09l-1.45-1.71c1.29-1.1,2.03-2.7,2.03-4.39,0-3.18-2.58-5.76-5.76-5.76s-5.76,2.58-5.76,5.76c0,1.69.74,3.29,2.03,4.39l-1.45,1.71Z'/%3e%3c/svg%3e";
function Ji({ overlay: r, className: e = "" }) {
  const t = ["loading-circle", e, r ? "overlay" : ""].join(" ").trim();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    r && /* @__PURE__ */ l.jsx("div", { className: "loading-backdrop" }),
    /* @__PURE__ */ l.jsx("div", { className: t, children: /* @__PURE__ */ l.jsx(G, { src: Ed }) })
  ] });
}
function Sd() {
  const [r, e] = Pe(1);
  return cn(() => {
    const t = setInterval(() => {
      e((n) => n >= 3 ? 1 : n + 1);
    }, 500);
    return () => clearInterval(t);
  }, []), /* @__PURE__ */ l.jsxs("span", { children: [
    /* @__PURE__ */ l.jsx("span", { children: "." }),
    /* @__PURE__ */ l.jsx("span", { style: { visibility: r >= 2 ? "visible" : "hidden" }, children: "." }),
    /* @__PURE__ */ l.jsx("span", { style: { visibility: r >= 3 ? "visible" : "hidden" }, children: "." })
  ] });
}
const Ai = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20512%20512'%3e%3c!--!%20Font%20Awesome%20Pro%206.0.0%20by%20@fontawesome%20-%20https://fontawesome.com%20License%20-%20https://fontawesome.com/license%20(Commercial%20License)%20Copyright%202022%20Fonticons,%20Inc.%20--%3e%3cpath%20d='M495.9%20166.6C499.2%20175.2%20496.4%20184.9%20489.6%20191.2L446.3%20230.6C447.4%20238.9%20448%20247.4%20448%20256C448%20264.6%20447.4%20273.1%20446.3%20281.4L489.6%20320.8C496.4%20327.1%20499.2%20336.8%20495.9%20345.4C491.5%20357.3%20486.2%20368.8%20480.2%20379.7L475.5%20387.8C468.9%20398.8%20461.5%20409.2%20453.4%20419.1C447.4%20426.2%20437.7%20428.7%20428.9%20425.9L373.2%20408.1C359.8%20418.4%20344.1%20427%20329.2%20433.6L316.7%20490.7C314.7%20499.7%20307.7%20506.1%20298.5%20508.5C284.7%20510.8%20270.5%20512%20255.1%20512C241.5%20512%20227.3%20510.8%20213.5%20508.5C204.3%20506.1%20197.3%20499.7%20195.3%20490.7L182.8%20433.6C167%20427%20152.2%20418.4%20138.8%20408.1L83.14%20425.9C74.3%20428.7%2064.55%20426.2%2058.63%20419.1C50.52%20409.2%2043.12%20398.8%2036.52%20387.8L31.84%20379.7C25.77%20368.8%2020.49%20357.3%2016.06%20345.4C12.82%20336.8%2015.55%20327.1%2022.41%20320.8L65.67%20281.4C64.57%20273.1%2064%20264.6%2064%20256C64%20247.4%2064.57%20238.9%2065.67%20230.6L22.41%20191.2C15.55%20184.9%2012.82%20175.3%2016.06%20166.6C20.49%20154.7%2025.78%20143.2%2031.84%20132.3L36.51%20124.2C43.12%20113.2%2050.52%20102.8%2058.63%2092.95C64.55%2085.8%2074.3%2083.32%2083.14%2086.14L138.8%20103.9C152.2%2093.56%20167%2084.96%20182.8%2078.43L195.3%2021.33C197.3%2012.25%20204.3%205.04%20213.5%203.51C227.3%201.201%20241.5%200%20256%200C270.5%200%20284.7%201.201%20298.5%203.51C307.7%205.04%20314.7%2012.25%20316.7%2021.33L329.2%2078.43C344.1%2084.96%20359.8%2093.56%20373.2%20103.9L428.9%2086.14C437.7%2083.32%20447.4%2085.8%20453.4%2092.95C461.5%20102.8%20468.9%20113.2%20475.5%20124.2L480.2%20132.3C486.2%20143.2%20491.5%20154.7%20495.9%20166.6V166.6zM256%20336C300.2%20336%20336%20300.2%20336%20255.1C336%20211.8%20300.2%20175.1%20256%20175.1C211.8%20175.1%20176%20211.8%20176%20255.1C176%20300.2%20211.8%20336%20256%20336z'/%3e%3c/svg%3e", Ri = {
  maxHeight: "4rem",
  width: "4rem",
  position: "fixed",
  top: "50%",
  textIndent: "-9999em",
  zIndex: 1,
  padding: 0,
  left: "99%"
}, Nd = {
  maxHeight: "7rem",
  width: "auto",
  position: "fixed",
  top: "45%",
  left: "48%",
  zIndex: 1
}, Od = () => /* @__PURE__ */ l.jsxs("div", { className: "loading-gears-wrapper", children: [
  /* @__PURE__ */ l.jsxs("h3", { style: Nd, className: "loading-text", children: [
    "Loading",
    /* @__PURE__ */ l.jsx("span", { className: "loading-gears-span-1", children: "∙" }),
    /* @__PURE__ */ l.jsx("span", { className: "loading-gears-span-2", children: "∙" }),
    /* @__PURE__ */ l.jsx("span", { className: "loading-gears-span-3", children: "∙" })
  ] }),
  /* @__PURE__ */ l.jsx("img", { style: Ri, className: "loading-gears-icon-4", src: Ai, alt: "Cog" }),
  /* @__PURE__ */ l.jsx("img", { style: Ri, className: "loading-gears-icon-3", src: Ai, alt: "Cog" }),
  /* @__PURE__ */ l.jsx("img", { style: Ri, className: "loading-gears-icon-2", src: Ai, alt: "Cog" }),
  /* @__PURE__ */ l.jsx("img", { style: Ri, className: "loading-gears-icon", src: Ai, alt: "Cog" })
] });
function gi(r) {
  const { type: e = "lp", className: t = "", height: n } = r, i = n ? { height: n } : {}, s = {
    lp: "https://cdn-assets.greatplainsmfg.com/shared_assets/landpride/images/logo-212.png",
    ag: "https://cdn-assets.greatplainsmfg.com/shared_assets/greatplainsag/images/ag-logo.png",
    gp: "https://cdn-assets.greatplainsmfg.com/shared_assets/greatplainsag/images/ag-logo.png",
    corp: "https://cdn-assets.greatplainsmfg.com/shared_assets/greatplainsag/images/ag-logo.png",
    ce: "https://cdn-assets.greatplainsmfg.com/shared_assets/greatplainsag/images/ag-logo.png",
    gpt: "https://cdn-assets.greatplainsmfg.com/shared_assets/gptrucking/images/gp-logo-trucking-215px.png"
  };
  return /* @__PURE__ */ l.jsx("div", { className: t.concat(" logo").trim(), style: i, children: /* @__PURE__ */ l.jsx("img", { src: s[e] }) });
}
function kc(r) {
  const { children: e, className: t = "", show: n = !1, showHandler: i = null } = r, s = _t(null);
  cn(() => {
    n ? s.current?.showModal() : s.current?.close();
  }, [n]);
  function o(a) {
    a.target === s.current && i && i(!1);
  }
  return /* @__PURE__ */ l.jsx("dialog", { ref: s, onClick: o, className: `modal ${t}`, children: e });
}
function Cd({ user: r, dealerInfo: e, loading: t = !1 }) {
  const [n] = sr(), i = _l(), [s, o] = Pe(!1), { data: a } = oo(), c = Ru(), u = () => o(!s);
  return /* @__PURE__ */ l.jsx("nav", { className: "primary", children: /* @__PURE__ */ l.jsxs("div", { className: "nav-wrapper", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "", children: [
      /* @__PURE__ */ l.jsx(Ve, { to: "/", children: /* @__PURE__ */ l.jsx(gi, { type: n, className: "" }) }),
      /* @__PURE__ */ l.jsxs("div", { className: "current-dealer flex-inline mobile-only ", children: [
        t && /* @__PURE__ */ l.jsx("span", { className: "text-loading" }),
        e && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(G, { glyph: "building-fill" }),
          /* @__PURE__ */ l.jsx("span", { children: e.dealer_name })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "menu-toggle mobile-only", onClick: u, children: /* @__PURE__ */ l.jsx(G, { glyph: s ? "x-lg" : "list" }) }),
    /* @__PURE__ */ l.jsxs("div", { className: "flex-col primary-menu right " + (!s && "desktop-only"), children: [
      /* @__PURE__ */ l.jsx("div", { className: "nav-link-wrapper primary-links", children: t ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx("span", { className: "nav-link", children: /* @__PURE__ */ l.jsx("span", { className: "text-loading" }) }),
        /* @__PURE__ */ l.jsx("span", { className: "nav-link", children: /* @__PURE__ */ l.jsx("span", { className: "text-loading" }) }),
        /* @__PURE__ */ l.jsx("span", { className: "nav-link", children: /* @__PURE__ */ l.jsx("span", { className: "text-loading" }) }),
        /* @__PURE__ */ l.jsx("span", { className: "nav-link", children: /* @__PURE__ */ l.jsx("span", { className: "text-loading" }) })
      ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, {
        // User can switch dealer if they are an admin, CS user, or a dealer employee user with a valid list
        // of associated dealers.
        children: [
          (a.length > 0 || r && (r.isAdmin() || r.isCsUser())) && /* @__PURE__ */ l.jsxs("button", { className: "nav-link text-only", onClick: c, children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "arrow-repeat" }),
            "Switch Dealer"
          ] }),
          /* @__PURE__ */ l.jsxs(Ve, { to: n === "lp" ? "/lp/forms/LP_Contacts.pdf" : "/gp/KeyContactPersonnel.pdf", className: "nav-link", reloadDocument: !0, children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "person-lines-fill" }),
            "Company Contacts"
          ] }),
          /* @__PURE__ */ l.jsxs(Ve, { to: "/", className: "nav-link", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "house-door-fill" }),
            "Home"
          ] }),
          i && /* @__PURE__ */ l.jsxs(Ve, { to: "/logout", className: "nav-link", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "door-open" }),
            "Log Out"
          ] }),
          !i && /* @__PURE__ */ l.jsxs(Ve, { to: "/login", className: "nav-link", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "box-arrow-right" }),
            "Log In"
          ] }),
          r && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
            /* @__PURE__ */ l.jsx("span", { className: "separator" }),
            /* @__PURE__ */ l.jsxs(Ve, { to: "/", className: "nav-link user-account", children: [
              /* @__PURE__ */ l.jsxs("span", { className: "flex-inline middle", children: [
                /* @__PURE__ */ l.jsx(G, { glyph: "person-circle" }),
                r.get("name")
              ] }),
              /* @__PURE__ */ l.jsxs("div", { className: "mobile-only flex-inline middle", children: [
                "My Account ",
                /* @__PURE__ */ l.jsx(G, { glyph: "caret-right-fill" })
              ] })
            ] })
          ] })
        ]
      }) }),
      /* @__PURE__ */ l.jsxs("div", { className: "current-dealer flex-inline desktop-only", children: [
        t && /* @__PURE__ */ l.jsx("span", { className: "text-loading" }),
        e && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(G, { glyph: "building-fill" }),
          /* @__PURE__ */ l.jsx("span", { children: e.dealer_name })
        ] })
      ] })
    ] })
  ] }) });
}
function jd({ user: r, dealerInfo: e }) {
  const [t] = sr(), n = is("environment"), [i, s] = Pe(!1);
  return /* @__PURE__ */ l.jsx("nav", { className: "secondary ", children: /* @__PURE__ */ l.jsx("div", { className: "nav-wrapper", children: /* @__PURE__ */ l.jsxs("div", { className: "nav-link-wrapper", children: [
    t === "lp" && (e?.divisions?.includes("01") || r?.isGpmUser()) && /* @__PURE__ */ l.jsxs(
      Ve,
      {
        to: n !== "production" ? "https://dev-dealers.greatplainsmfg.net" : "https://dealers.greatplainsmfg.com",
        target: "_blank",
        className: "nav-link",
        children: [
          /* @__PURE__ */ l.jsx(G, { glyph: "globe2" }),
          "Great Plains Dealer Access"
        ]
      }
    ),
    t === "gp" && (e?.divisions?.includes("02") || r?.isGpmUser()) && /* @__PURE__ */ l.jsxs(
      Ve,
      {
        to: n !== "production" ? "https://dev-dealers.landpride.net" : "https://dealers.landpride.com",
        target: "_blank",
        className: "nav-link",
        children: [
          /* @__PURE__ */ l.jsx(G, { glyph: "globe2" }),
          "Land Pride Dealer Access"
        ]
      }
    ),
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: "quick-links-wrapper",
        children: [
          /* @__PURE__ */ l.jsxs(
            "div",
            {
              id: "quick-links-menu-button",
              className: `nav-link ${i ? "active" : ""}`,
              onClick: () => s(!i),
              children: [
                /* @__PURE__ */ l.jsx(G, { glyph: "bookmarks-fill" }),
                "Quick Links"
              ]
            }
          ),
          /* @__PURE__ */ l.jsx(Dd, {})
        ]
      }
    )
  ] }) }) });
}
function qg() {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(So, { children: "Page Not Found" }),
    /* @__PURE__ */ l.jsx("p", { children: "Sorry, we could not find the page you're looking for." })
  ] });
}
function So(r) {
  const { className: e = "", children: t } = r;
  return /* @__PURE__ */ l.jsx("h1", { className: e.concat(" title").trim(), children: t });
}
function $g(r) {
  const {
    steps: e,
    currentStep: t,
    completedSteps: n = [],
    onStepChange: i,
    mobileLabels: s = "short",
    className: o = ""
  } = r, a = _t(null);
  function c(u) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(u.key)) return;
    const d = Array.from(
      a.current?.querySelectorAll("button:not([disabled])") ?? []
    );
    if (d.length === 0) return;
    u.preventDefault();
    const p = d.indexOf(document.activeElement);
    ({
      ArrowLeft: d[Math.max(p - 1, 0)],
      ArrowRight: d[Math.min(p + 1, d.length - 1)],
      Home: d[0],
      End: d[d.length - 1]
    })[u.key]?.focus();
  }
  return /* @__PURE__ */ l.jsx(
    "nav",
    {
      className: ["progress-bar", `mobile-labels-${s}`, o].filter(Boolean).join(" "),
      "aria-label": "progress",
      children: /* @__PURE__ */ l.jsx(
        "ol",
        {
          className: "progress-bar-steps no-marker",
          ref: a,
          onKeyDown: c,
          children: e.map((u, f) => {
            const d = f + 1, p = n.includes(d), v = (n.length > 0 ? Math.max(...n) : 0) + 1, m = d === t, y = p || d === v, x = !p && !m && d === v, k = !p && !m;
            function E() {
              return m ? p ? /* @__PURE__ */ l.jsx(G, { glyph: `${d}-circle` }) : u.icon || /* @__PURE__ */ l.jsx(G, { glyph: `${d}-circle` }) : p ? /* @__PURE__ */ l.jsx(G, { glyph: "check-circle-fill" }) : k ? u.icon || /* @__PURE__ */ l.jsx(G, { glyph: `${d}-circle` }) : u.icon || /* @__PURE__ */ l.jsx(G, { glyph: `${d}-circle` });
            }
            return /* @__PURE__ */ l.jsx(
              "li",
              {
                className: ["progress-bar-step", p && "completed", m && "active", x && "available", k && "inactive"].filter(Boolean).join(" "),
                "aria-current": m ? "step" : void 0,
                children: /* @__PURE__ */ l.jsxs(
                  "button",
                  {
                    type: "button",
                    className: "progress-bar-button",
                    disabled: !y,
                    "aria-label": u.label,
                    onClick: () => i?.(d, u),
                    children: [
                      /* @__PURE__ */ l.jsx("span", { className: "progress-bar-indicator", "aria-hidden": "true", children: E() }),
                      /* @__PURE__ */ l.jsx("span", { className: "progress-bar-label", "aria-hidden": "true", children: u.label }),
                      s === "short" && // Both labels are rendered so the stylesheet can swap them at
                      // the breakpoint; only one is ever visible.
                      /* @__PURE__ */ l.jsx("span", { className: "progress-bar-label mobile", "aria-hidden": "true", children: u.mobileLabel ?? u.label })
                    ]
                  }
                )
              },
              u.label
            );
          })
        }
      )
    }
  );
}
function Dd() {
  const { quickLinks: r, removeQuickLink: e, loading: t, inProgress: n } = Pu();
  return /* @__PURE__ */ l.jsxs("div", { className: "quick-links-menu flex-col border", children: [
    t && /* @__PURE__ */ l.jsx(Ji, { className: "large color" }),
    !t && r?.length < 1 && /* @__PURE__ */ l.jsxs("div", { className: "message", children: [
      "To add a quick link, click the ",
      /* @__PURE__ */ l.jsx(G, { glyph: "plus-square" }),
      " icon next to a resource link."
    ] }),
    r?.length > 0 && r.reduce((i, s) => (s.category.forEach((o) => {
      i.find((a) => a.id === o.parent.id) || (i = [...i, { id: o.parent.id, name: o.parent.name }]);
    }), i), []).map((i) => /* @__PURE__ */ l.jsxs("div", { className: "quick-links-group", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "flex-row category-heading", children: [
        /* @__PURE__ */ l.jsx(G, { glyph: Hu.categories[i.id].glyph }),
        i.name
      ] }),
      /* @__PURE__ */ l.jsx("ul", { className: "no-marker", children: r.filter((s) => s.category.map((o) => o.parent.id).includes(i.id)).map(
        (s) => /* @__PURE__ */ l.jsxs("li", { className: "flex-row", children: [
          /* @__PURE__ */ l.jsx(
            "button",
            {
              className: "icon-only",
              onClick: () => {
                n || e(s.id);
              },
              children: n === s.id ? /* @__PURE__ */ l.jsx(Ji, {}) : /* @__PURE__ */ l.jsx(G, { glyph: "dash-square" })
            }
          ),
          /* @__PURE__ */ l.jsx(Ve, { to: s.url, reloadDocument: !0, children: s.title })
        ] }, s.id + "ql")
      ) })
    ] }, i.id))
  ] });
}
function Vg(r) {
  const {
    columnWidth: e,
    minColumnWidth: t,
    gap: n = 0,
    className: i = "",
    children: s
  } = r;
  let o = "1fr";
  e && !t ? o = e : e && t ? o = `minmax(${t}, ${e})` : !e && t && (o = `minmax(${t}, 1fr)`);
  const a = {
    gridTemplateColumns: `repeat(auto-fill, ${o})`,
    gridGap: n
  };
  return /* @__PURE__ */ l.jsx("div", { className: `grid full responsive ${i}`, style: a, children: s });
}
function Xg() {
  const { data: r } = so(), { data: e } = oo();
  return r && e.length > 0 && /* @__PURE__ */ l.jsxs(Xn, { className: "flex-row middle", type: "info", children: [
    /* @__PURE__ */ l.jsx(G, { glyph: "building-fill xl" }),
    /* @__PURE__ */ l.jsxs("span", { children: [
      "You are currently acting as ",
      /* @__PURE__ */ l.jsx("strong", { children: r.dealer_name })
    ] })
  ] });
}
function Md(r) {
  const { status: e, dealers: t, searchQuery: n, updateMask: i } = r, [s, o] = Pe(null);
  return /* @__PURE__ */ l.jsx("div", { className: "dealer-block-wrapper flex-col full", children: t.filter(
    (a) => a.dealer_number.includes(n) || a.dealer_name.toLowerCase().includes(n)
  ).sort((a, c) => a.dealer_number.localeCompare(c.dealer_number)).map((a) => /* @__PURE__ */ l.jsx(
    "div",
    {
      className: "block shadow full dealer-block",
      children: /* @__PURE__ */ l.jsxs("div", { className: "flex-row full", children: [
        /* @__PURE__ */ l.jsx(G, { glyph: "building-fill", className: "xl color" }),
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row grow space middle wrap", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "flex-col dealer-info", children: [
            /* @__PURE__ */ l.jsx(
              "div",
              {
                className: "dealer-name",
                children: a.dealer_name
              }
            ),
            /* @__PURE__ */ l.jsx(
              "div",
              {
                className: "dealer-number",
                children: a.dealer_number
              }
            )
          ] }),
          /* @__PURE__ */ l.jsx(
            "button",
            {
              disabled: s === a.dealer_number && e === "pending",
              onClick: () => {
                i(a.dealer_number), o(a.dealer_number);
              },
              children: s === a.dealer_number && e === "pending" ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                "Switching ",
                /* @__PURE__ */ l.jsx(Sd, {})
              ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                "Switch ",
                /* @__PURE__ */ l.jsx(G, { glyph: "arrow-repeat" })
              ] })
            }
          )
        ] })
      ] })
    },
    `${a.dealer_number}`
  )) });
}
function Ad(r) {
  const { setSearchQuery: e } = r;
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs("div", { className: "flex-col full center dealer-search", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
      /* @__PURE__ */ l.jsx(G, { glyph: "search", className: "color" }),
      /* @__PURE__ */ l.jsx(
        "input",
        {
          type: "search",
          onChange: (t) => e(t.target.value.toLowerCase())
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "caption", children: "Search by dealer number or dealer name" })
  ] }) });
}
function Rd(r) {
  const { dealerInfo: e, show: t, setShow: n } = r, { dealerAccessApiScope: i, dealerAccessApiHost: s } = is(), o = ns({ scopes: [i] }), { data: a, loading: c, error: u } = oo(), [f, d] = Pe(""), [p, _] = Pe(!1), { data: v, isLoading: m } = ir({
    enabled: !!o,
    queryKey: ["dealerAccessApiToken"],
    queryFn: () => o()
  }), y = rs(v?.accessTokenClaims), { data: x } = ir({
    enabled: !!y && !y?.isDealer(),
    queryKey: ["userMask", y?.get("id")],
    queryFn: () => o().then((h) => Yu(s, h.accessToken, y?.get("id"))).then((h) => h.json()),
    select: (h) => h.data
  }), { mutate: k } = Ho({
    mutationFn: async (h) => v ? o().then((b) => Bu(s, b.accessToken, h)) : null,
    onMutate: () => _(!1),
    onSuccess: (h) => {
      h?.ok ? window.location.reload() : _(!0);
    },
    onError: (h) => {
      _(!0), console.error(h);
    }
  }), { status: E, mutate: O } = Ho({
    mutationFn: async (h) => v && y?.get("id") ? o().then((b) => zu(s, b.accessToken, y?.get("id"), h)) : null,
    onMutate: () => _(!1),
    onSuccess: (h) => {
      h.ok ? window.location.reload() : _(!0);
    },
    onError: (h) => {
      _(!0), console.error(h);
    }
  });
  return u && console.error(u), /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs(kc, { show: t, className: "switch-dealer-modal", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex-row space top heading full", children: [
      /* @__PURE__ */ l.jsx("div", { className: "flex-row middle", children: /* @__PURE__ */ l.jsx("h1", { children: "Switch Dealer" }) }),
      /* @__PURE__ */ l.jsx("button", { onClick: () => n(!1), className: "icon-only", children: /* @__PURE__ */ l.jsx(G, { glyph: "x-lg", className: "xl" }) })
    ] }),
    p && /* @__PURE__ */ l.jsx(Zn, { type: "error", children: "An error occurred while attempting to switch dealer. Please try again." }),
    c || m ? /* @__PURE__ */ l.jsx(Ji, {}) : /* @__PURE__ */ l.jsxs("div", { className: "flex-col full dealer-wrapper", children: [
      e && y && /* @__PURE__ */ l.jsxs("div", { className: "flex-col full", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block-heading", children: "Current Dealer:" }),
        /* @__PURE__ */ l.jsx("div", { className: "dealer-block-wrapper flex-col full", children: /* @__PURE__ */ l.jsx("div", { className: "block shadow full dealer-block", children: /* @__PURE__ */ l.jsxs("div", { className: "flex-row full", children: [
          /* @__PURE__ */ l.jsx(G, { glyph: "building-fill", className: "xl color" }),
          /* @__PURE__ */ l.jsxs("div", { className: "flex-row grow space middle wrap", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "flex-col dealer-info", children: [
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: "dealer-name",
                  children: e.dealer_name
                }
              ),
              /* @__PURE__ */ l.jsx(
                "div",
                {
                  className: "dealer-number",
                  children: e.dealer_number
                }
              )
            ] }),
            (y.isAdmin() || y.isCsUser() || y.isTm()) && /* @__PURE__ */ l.jsxs(
              "button",
              {
                className: "danger",
                onClick: () => k(y?.get("id") ?? ""),
                children: [
                  "Remove Mask ",
                  /* @__PURE__ */ l.jsx(G, { glyph: "trash" })
                ]
              }
            )
          ] })
        ] }) }) })
      ] }),
      !e && x && /* @__PURE__ */ l.jsxs(
        "button",
        {
          className: "danger",
          onClick: () => k(y?.get("id") ?? ""),
          children: [
            "Remove Mask ",
            /* @__PURE__ */ l.jsx(G, { glyph: "trash" })
          ]
        }
      ),
      a.length === 0 && /* @__PURE__ */ l.jsx(Zn, { type: "warning", className: "full", children: /* @__PURE__ */ l.jsxs("span", { children: [
        "There are no dealers available for you to switch to. ",
        /* @__PURE__ */ l.jsx("button", { className: "text-only bold", onClick: () => n(!1), children: "Close" })
      ] }) }),
      a.length > 0 && /* @__PURE__ */ l.jsxs("div", { className: "flex-col full", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block-heading", children: "Other Dealers:" }),
        a.length >= 20 && /* @__PURE__ */ l.jsx(Ad, { setSearchQuery: d }),
        /* @__PURE__ */ l.jsx(
          Md,
          {
            status: E,
            dealers: a,
            searchQuery: f,
            mask: e?.dealer_number,
            updateMask: O
          }
        )
      ] })
    ] })
  ] }) });
}
function Kg({ children: r, defaultTheme: e }) {
  const [t, n] = Pe(e ?? "lp");
  return cn(() => {
    document.querySelector("html")?.setAttribute("data-theme", t);
  }, [t]), /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(Su.Provider, { value: t, children: /* @__PURE__ */ l.jsx(Nu.Provider, { value: n, children: r }) }) });
}
function Pd() {
  const r = no();
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(So, { children: "Unauthorized" }),
    /* @__PURE__ */ l.jsx("p", { children: "Sorry, you are not authorized to view this page." }),
    /* @__PURE__ */ l.jsxs("button", { className: "text-only primary", onClick: () => r(-1), children: [
      /* @__PURE__ */ l.jsx(G, { glyph: "caret-left-fill" }),
      "Go back"
    ] })
  ] });
}
function Id({ children: r }) {
  return /* @__PURE__ */ l.jsx("aside", { className: "sidebar-container", children: /* @__PURE__ */ l.jsx("div", { className: "sidebar-wrapper", children: r }) });
}
function Ld({ children: r }) {
  const [e, t] = Pe(!1);
  return /* @__PURE__ */ l.jsxs("aside", { className: `side-drawer${e ? " show" : ""}`, "aria-hidden": !e, children: [
    /* @__PURE__ */ l.jsx(
      "button",
      {
        className: "icon-button side-drawer-toggle",
        onClick: () => t(!e),
        children: /* @__PURE__ */ l.jsx(G, { glyph: "chevron-left" })
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "side-drawer-scroll-region", children: r })
  ] });
}
function Qg() {
  const [r, e] = Pe(!1), [t, n] = Pe(null);
  return /* @__PURE__ */ l.jsxs("div", { className: "style-guide-container flex-col full", children: [
    /* @__PURE__ */ l.jsx("h1", { children: "Style Guide" }),
    /* @__PURE__ */ l.jsxs("ul", { children: [
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "#blocks_containers", children: "Blocks/Containers" }) }),
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "#buttons", children: "Buttons" }) }),
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "#tables", children: "Tables" }) }),
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "#forms", children: "Forms" }) }),
      /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx("a", { href: "#components", children: "Components" }) })
    ] }),
    /* @__PURE__ */ l.jsxs("section", { id: "blocks_containers", className: "flex-col full", children: [
      /* @__PURE__ */ l.jsx("h2", { children: "Blocks/Containers" }),
      /* @__PURE__ */ l.jsx("div", { className: "block", children: ".block" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block .border" }),
      /* @__PURE__ */ l.jsx("div", { className: "block shadow", children: ".block .shadow" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border shadow", children: ".block .border .shadow" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border full", children: ".block .full" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border full center", children: ".block .full .center" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border full right", children: ".block .full .right" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border full left", children: ".block .full .left" }),
      /* @__PURE__ */ l.jsx("div", { className: "block border transparent", children: ".block .transparent" }),
      /* @__PURE__ */ l.jsxs("div", { className: "block border", children: [
        ".block",
        /* @__PURE__ */ l.jsx("div", { className: "block flashcard", children: ".block .flashcard" }),
        /* @__PURE__ */ l.jsxs("div", { className: "block flashcard border", children: [
          ".block .flashcard .border",
          /* @__PURE__ */ l.jsx("div", { className: "block flashcard dark border", children: ".block .flashcard .dark" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "block border full stretch", children: [
        ".block .full .stretch",
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block (stretched to fill space)" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border compact", children: ".block .compact (don't stretch me)" })
      ] }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row", children: ".flex-row" }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row full", children: ".flex-row .full" }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row full right", children: ".flex-row .full .right" }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row full left", children: ".flex-row .full .left" }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row full center", children: ".flex-row .full .center" }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .stretch (100px height)",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full stretch", style: { height: "100px" }, children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border compact", children: ".block .compact (negate stretch)" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .fill",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full fill", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .distribute",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full distribute", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .space",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full space", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .middle (100px height)",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full middle", style: { height: "100px" }, children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .top (100px height)",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full top", style: { height: "100px" }, children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-row .full .bottom (100px height)",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row full bottom", style: { height: "100px" }, children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group", children: [
        ".flex-col",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-col .full",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col full", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-col .full .stretch",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col full stretch", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border compact", children: ".block .compact (negate stretch)" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-col .full .left",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col full left", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-col .full .right",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col full right", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "flex-group full", children: [
        ".flex-col .full .center",
        /* @__PURE__ */ l.jsxs("div", { className: "flex-col full center", children: [
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
          /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
        ] })
      ] }),
      /* @__PURE__ */ l.jsxs("p", { children: [
        "Lorem ipsum ",
        /* @__PURE__ */ l.jsx("div", { className: "flex-inline", children: ".flex-inline" }),
        " dolor sit amet, consectetur adipisicing elit."
      ] }),
      ".grid",
      /* @__PURE__ */ l.jsxs("div", { className: "grid", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .col-",
      "{n}",
      " (ex. .col-3 for 3 columns)",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .col-3 .no-gap",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3 no-gap", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .fill",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3 fill", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .start",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3 start", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .end",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3 end", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      ".grid .full .center",
      /* @__PURE__ */ l.jsxs("div", { className: "grid full col-3 center", children: [
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" }),
        /* @__PURE__ */ l.jsx("div", { className: "block border", children: ".block" })
      ] }),
      /* @__PURE__ */ l.jsx("br", {}),
      /* @__PURE__ */ l.jsxs("strong", { children: [
        "NOTE: See ",
        /* @__PURE__ */ l.jsx("code", { children: "DynamicGrid" }),
        " component for a grid layout with a changing number of columns."
      ] }),
      /* @__PURE__ */ l.jsx("br", {})
    ] }),
    /* @__PURE__ */ l.jsxs("section", { id: "buttons", className: "flex-col full", children: [
      /* @__PURE__ */ l.jsx("h2", { children: "Buttons" }),
      /* @__PURE__ */ l.jsxs("div", { className: "block border shadow full", children: [
        /* @__PURE__ */ l.jsx("button", { children: "button" }),
        /* @__PURE__ */ l.jsx("button", { className: "large", children: "button.large" }),
        /* @__PURE__ */ l.jsx("button", { className: "xl", children: "button.xl" }),
        /* @__PURE__ */ l.jsx("button", { className: "full", children: "button.full" }),
        /* @__PURE__ */ l.jsx("a", { href: "#", className: "button", children: "a.button" }),
        /* @__PURE__ */ l.jsx("button", { className: "primary", children: "button .primary" }),
        /* @__PURE__ */ l.jsx("button", { className: "secondary", children: "button .secondary" }),
        /* @__PURE__ */ l.jsx("button", { className: "cancel", children: "button .cancel" }),
        /* @__PURE__ */ l.jsx("button", { disabled: !0, children: "button [disabled]" }),
        /* @__PURE__ */ l.jsx("button", { className: "danger", children: "button .danger" }),
        /* @__PURE__ */ l.jsx("span", { children: "button.icon-button" }),
        /* @__PURE__ */ l.jsxs("div", { className: "flex-row", children: [
          /* @__PURE__ */ l.jsx("button", { className: "icon-button", children: /* @__PURE__ */ l.jsx(G, { glyph: "trash" }) }),
          /* @__PURE__ */ l.jsxs("button", { className: "icon-button", children: [
            "button .icon-button",
            /* @__PURE__ */ l.jsx(G, { glyph: "trash" })
          ] })
        ] }),
        /* @__PURE__ */ l.jsx("span", { children: "button.icon-only" }),
        /* @__PURE__ */ l.jsx("button", { className: "icon-only", children: /* @__PURE__ */ l.jsx(G, { glyph: "bell-fill" }) }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only", children: "button.text-only" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only bold", children: "button.text-only .bold" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only primary", children: "button.text-only .primary" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only info", children: "button.text-only .info" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only danger", children: "button.text-only .danger" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only success", children: "button.text-only .success" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only warning", children: "button.text-only .warning" }),
          " button."
        ] }),
        /* @__PURE__ */ l.jsxs("span", { children: [
          "This is a ",
          /* @__PURE__ */ l.jsx("button", { className: "text-only cancel", children: "button.text-only .cancel" }),
          " button."
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l.jsxs("section", { id: "tables", className: "flex-col full", children: [
      /* @__PURE__ */ l.jsx("h2", { children: "Tables" }),
      /* @__PURE__ */ l.jsx("div", { children: "table" }),
      /* @__PURE__ */ l.jsxs("table", { className: "sample-table", children: [
        /* @__PURE__ */ l.jsx("thead", { children: /* @__PURE__ */ l.jsxs("tr", { children: [
          /* @__PURE__ */ l.jsx("th", { children: "Header 1" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 2" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 3" })
        ] }) }),
        /* @__PURE__ */ l.jsxs("tbody", { children: [
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 3" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ l.jsx("div", { children: "table.full" }),
      /* @__PURE__ */ l.jsxs("table", { className: "full", children: [
        /* @__PURE__ */ l.jsx("thead", { children: /* @__PURE__ */ l.jsxs("tr", { children: [
          /* @__PURE__ */ l.jsx("th", { children: "Header 1" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 2" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 3" })
        ] }) }),
        /* @__PURE__ */ l.jsxs("tbody", { children: [
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 3" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ l.jsx("div", { children: "table.nostyle (customize how you want)" }),
      /* @__PURE__ */ l.jsxs("table", { className: "nostyle", children: [
        /* @__PURE__ */ l.jsx("thead", { children: /* @__PURE__ */ l.jsxs("tr", { children: [
          /* @__PURE__ */ l.jsx("th", { children: "Header 1" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 2" }),
          /* @__PURE__ */ l.jsx("th", { children: "Header 3" })
        ] }) }),
        /* @__PURE__ */ l.jsxs("tbody", { children: [
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 1 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 2 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 3 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 4 Col 3" })
          ] }),
          /* @__PURE__ */ l.jsxs("tr", { children: [
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 1" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 2" }),
            /* @__PURE__ */ l.jsx("td", { children: "Row 5 Col 3" })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l.jsxs("section", { id: "forms", className: "flex-col full", children: [
      /* @__PURE__ */ l.jsx("h2", { children: "Forms" }),
      /* @__PURE__ */ l.jsxs("form", { action: "/public", className: "block border full", children: [
        /* @__PURE__ */ l.jsx("div", { children: "form.block .border .full" }),
        /* @__PURE__ */ l.jsxs("fieldset", { children: [
          "fieldset",
          /* @__PURE__ */ l.jsx("legend", { children: "Legend" }),
          /* @__PURE__ */ l.jsxs("div", { className: "flex-col", children: [
            /* @__PURE__ */ l.jsxs("span", { children: [
              /* @__PURE__ */ l.jsx("strong", { children: "div.flex-col" }),
              " wraps the inputs to give default spacing between elements."
            ] }),
            /* @__PURE__ */ l.jsxs("label", { htmlFor: "radio", children: [
              /* @__PURE__ */ l.jsx("input", { type: "radio", id: "radio", value: "val1", name: "radio" }),
              "Label 1"
            ] }),
            /* @__PURE__ */ l.jsxs("label", { htmlFor: "radio2", children: [
              /* @__PURE__ */ l.jsx("input", { type: "radio", id: "radio2", mvalue: "val2", name: "radio" }),
              "Label 2"
            ] }),
            /* @__PURE__ */ l.jsxs("label", { htmlFor: "radio3", children: [
              /* @__PURE__ */ l.jsx("input", { type: "radio", id: "radio3", value: "val3", name: "radio" }),
              "Label 3"
            ] })
          ] })
        ] }),
        /* @__PURE__ */ l.jsxs("fieldset", { className: "stretch full", children: [
          "fieldset.stretch .full",
          /* @__PURE__ */ l.jsx("legend", { children: "Legend 2" }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "check", children: [
            /* @__PURE__ */ l.jsx("input", { type: "checkbox", id: "check", name: "check" }),
            "Label 1"
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "check2", children: [
            /* @__PURE__ */ l.jsx("input", { type: "checkbox", id: "check2", name: "check2" }),
            "Label 2"
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "check3", children: [
            /* @__PURE__ */ l.jsx("input", { type: "checkbox", id: "check3", name: "check3" }),
            "Label 3"
          ] })
        ] }),
        /* @__PURE__ */ l.jsxs("fieldset", { className: "block transparent", children: [
          "fieldset.block .transparent",
          /* @__PURE__ */ l.jsx("legend", { children: "Text Inputs" }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "text", className: "flex-col", children: [
            "label.flex-col (for block-style positioning)",
            /* @__PURE__ */ l.jsx("input", { id: "text", placeholder: "text input", type: "text" })
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "number", children: [
            "Number input",
            /* @__PURE__ */ l.jsx("input", { id: "number", type: "number" })
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "password", children: [
            "password",
            /* @__PURE__ */ l.jsx("input", { id: "password", type: "password" })
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "search", children: [
            "search",
            /* @__PURE__ */ l.jsx("input", { id: "search", type: "search" })
          ] }),
          /* @__PURE__ */ l.jsxs("label", { htmlFor: "textarea", children: [
            "textarea",
            /* @__PURE__ */ l.jsx("textarea", { id: "textarea" })
          ] }),
          ".input-wrapper",
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "search" }),
            " ",
            /* @__PURE__ */ l.jsx("input", { type: "text", placeholder: "text input" })
          ] }),
          ".input-wrapper > input[text], button",
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx("input", { type: "text", placeholder: "text input" }),
            /* @__PURE__ */ l.jsx("button", { children: "go!" })
          ] }),
          ".input-wrapper > input[text], .icon-button",
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx("input", { type: "text", placeholder: "text input" }),
            /* @__PURE__ */ l.jsxs("button", { className: "icon-button", children: [
              /* @__PURE__ */ l.jsx(G, { glyph: "search" }),
              "Search"
            ] })
          ] }),
          ".input-wrapper > input[text], button.icon-only",
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx("input", { type: "text", placeholder: "text input" }),
            /* @__PURE__ */ l.jsx("button", { className: "icon-only", children: /* @__PURE__ */ l.jsx(G, { glyph: "send" }) })
          ] }),
          ".input-wrapper > .icon, input[text]",
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "person" }),
            /* @__PURE__ */ l.jsx("input", { type: "text", placeholder: "Username" })
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "key" }),
            /* @__PURE__ */ l.jsx("input", { type: "password", placeholder: "Password" })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l.jsxs("section", { id: "components", className: "flex-col full", children: [
      /* @__PURE__ */ l.jsx("h2", { children: "Components" }),
      /* @__PURE__ */ l.jsx("div", { className: "flex-row full", children: /* @__PURE__ */ l.jsx(So, { children: "Page Title" }) }),
      /* @__PURE__ */ l.jsx(Zn, { children: "Alert Box (no type)" }),
      /* @__PURE__ */ l.jsx(Zn, { type: "info", children: "Alert Box (info)" }),
      /* @__PURE__ */ l.jsx(Zn, { type: "error", children: "Alert Box (error)" }),
      /* @__PURE__ */ l.jsx(Zn, { type: "warning", children: "Alert Box (warning)" }),
      /* @__PURE__ */ l.jsx(Zn, { type: "success", children: "Alert Box (success)" }),
      /* @__PURE__ */ l.jsx(
        Tc,
        {
          dismissedAlerts: [],
          setDismissedAlerts: () => null,
          className: "flex-row center middle",
          children: /* @__PURE__ */ l.jsxs("div", { className: "flex-row middle", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-circle", className: "xl" }),
            "This is an alert banner."
          ] })
        }
      ),
      /* @__PURE__ */ l.jsx(Xn, { children: "This is an alert message (no type)." }),
      /* @__PURE__ */ l.jsxs(Xn, { type: "success", children: [
        /* @__PURE__ */ l.jsx(G, { glyph: "check-circle", className: "xl" }),
        " This is an alert message (success)."
      ] }),
      /* @__PURE__ */ l.jsx(Xn, { type: "info", children: "This is an alert message (info)." }),
      /* @__PURE__ */ l.jsx(Xn, { type: "warning", children: "This is an alert message (warning)." }),
      /* @__PURE__ */ l.jsx(Xn, { type: "error", children: "This is an alert message (error)." }),
      /* @__PURE__ */ l.jsx(Xn, { type: "color", children: "This is an alert message (color)." }),
      /* @__PURE__ */ l.jsx("br", {}),
      /* @__PURE__ */ l.jsx("strong", { children: "Breadcrumbs" }),
      /* @__PURE__ */ l.jsx(yd, { breadcrumbs: { "Another Page": "/somepath" } }),
      /* @__PURE__ */ l.jsx("br", {}),
      /* @__PURE__ */ l.jsx(bd, { title: "Content Block", icon: /* @__PURE__ */ l.jsx(G, { glyph: "pin-angle" }), children: "Some content" }),
      /* @__PURE__ */ l.jsx("strong", { children: "Loading Circle" }),
      /* @__PURE__ */ l.jsx(Ji, {}),
      /* @__PURE__ */ l.jsx("strong", { children: "Logo" }),
      /* @__PURE__ */ l.jsx(gi, { type: "gp" }),
      /* @__PURE__ */ l.jsx(gi, { type: "lp" }),
      /* @__PURE__ */ l.jsx("strong", { children: "Modal" }),
      /* @__PURE__ */ l.jsx("br", {}),
      /* @__PURE__ */ l.jsx(kc, { show: r, children: /* @__PURE__ */ l.jsxs("div", { className: "flex-col", children: [
        /* @__PURE__ */ l.jsx("div", { className: "flex-row full right", children: /* @__PURE__ */ l.jsx("button", { className: "icon-only", onClick: () => e(!1), children: /* @__PURE__ */ l.jsx(G, { glyph: "x-lg" }) }) }),
        /* @__PURE__ */ l.jsx("p", { children: "This is a modal popup." })
      ] }) }),
      /* @__PURE__ */ l.jsx("button", { onClick: () => e(!0), className: "text-only", children: "Click to open modal" }),
      /* @__PURE__ */ l.jsx("br", {}),
      /* @__PURE__ */ l.jsxs("div", { className: "block border shadow full", children: [
        /* @__PURE__ */ l.jsx("strong", { children: "TabbedContent & Tabs" }),
        /* @__PURE__ */ l.jsx(
          Fd,
          {
            tabs: [
              /* @__PURE__ */ l.jsx(Ui, { onClick: () => n(1), selected: t === 1, children: "First" }),
              /* @__PURE__ */ l.jsx(Ui, { onClick: () => n(2), selected: t === 2, children: "Second" }),
              /* @__PURE__ */ l.jsx(Ui, { onClick: () => n(3), selected: t === 3, children: "Last" })
            ],
            children: /* @__PURE__ */ l.jsxs("div", { className: "flex-col", children: [
              /* @__PURE__ */ l.jsx("br", {}),
              /* @__PURE__ */ l.jsx("p", { children: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt, dolorum eos in minima mollitia numquam possimus provident repellat? Corporis, eveniet exercitationem ipsum magnam minus modi nam nisi numquam repellat totam!" }),
              /* @__PURE__ */ l.jsx("p", { children: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt, dolorum eos in minima mollitia numquam possimus provident repellat? Corporis, eveniet exercitationem ipsum magnam minus modi nam nisi numquam repellat totam!" }),
              /* @__PURE__ */ l.jsx("br", {})
            ] })
          }
        )
      ] })
    ] })
  ] });
}
function Ui({ children: r, selected: e, onClick: t }) {
  return /* @__PURE__ */ l.jsx("button", { className: `${["tab", e ? "selected" : ""].join(" ").trim()}`, onClick: t, children: r });
}
function Fd({ tabs: r, activeTab: e, onTabChange: t, children: n, type: i = "classic" }) {
  return /* @__PURE__ */ l.jsxs("div", { className: `${["flex-col", "full", "tabbed-content-container", i].join(" ").trim()}`, children: [
    /* @__PURE__ */ l.jsx("div", { className: "tabs-container", children: /* @__PURE__ */ l.jsx("div", { className: "flex-row tabs-wrapper", children: r.map((s, o) => /* @__PURE__ */ l.jsxs(Ui, { selected: e === s.id, onClick: () => t(s.id), children: [
      s?.icon ?? "",
      s.label
    ] }, o)) }) }),
    /* @__PURE__ */ l.jsx("div", { className: "tab-content-container", children: n })
  ] });
}
function xa(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function Wd(r) {
  if (Array.isArray(r)) return r;
}
function Yd(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var n, i, s, o, a = [], c = !0, u = !1;
    try {
      if (s = (t = t.call(r)).next, e !== 0) for (; !(c = (n = s.call(t)).done) && (a.push(n.value), a.length !== e); c = !0) ;
    } catch (f) {
      u = !0, i = f;
    } finally {
      try {
        if (!c && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (u) throw i;
      }
    }
    return a;
  }
}
function Bd() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zd(r, e) {
  return Wd(r) || Yd(r, e) || Ud(r, e) || Bd();
}
function Ud(r, e) {
  if (r) {
    if (typeof r == "string") return xa(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? xa(r, e) : void 0;
  }
}
const Ec = Object.entries, wa = Object.setPrototypeOf, Hd = Object.isFrozen, Gd = Object.getPrototypeOf, qd = Object.getOwnPropertyDescriptor;
let Re = Object.freeze, Le = Object.seal, gr = Object.create, Sc = typeof Reflect < "u" && Reflect, eo = Sc.apply, to = Sc.construct;
Re || (Re = function(e) {
  return e;
});
Le || (Le = function(e) {
  return e;
});
eo || (eo = function(e, t) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    i[s - 2] = arguments[s];
  return e.apply(t, i);
});
to || (to = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return new e(...n);
});
const Kn = Me(Array.prototype.forEach), $d = Me(Array.prototype.lastIndexOf), Ta = Me(Array.prototype.pop), zr = Me(Array.prototype.push), Vd = Me(Array.prototype.splice), kr = Array.isArray, ei = Me(String.prototype.toLowerCase), Es = Me(String.prototype.toString), ka = Me(String.prototype.match), Ur = Me(String.prototype.replace), Ea = Me(String.prototype.indexOf), Xd = Me(String.prototype.trim), Kd = Me(Number.prototype.toString), Qd = Me(Boolean.prototype.toString), Sa = typeof BigInt > "u" ? null : Me(BigInt.prototype.toString), Na = typeof Symbol > "u" ? null : Me(Symbol.prototype.toString), nt = Me(Object.prototype.hasOwnProperty), Hr = Me(Object.prototype.toString), qe = Me(RegExp.prototype.test), qn = Zd(TypeError);
function Me(r) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      n[i - 1] = arguments[i];
    return eo(r, e, n);
  };
}
function Zd(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return to(r, t);
  };
}
function se(r, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ei;
  if (wa && wa(r, null), !kr(e))
    return r;
  let n = e.length;
  for (; n--; ) {
    let i = e[n];
    if (typeof i == "string") {
      const s = t(i);
      s !== i && (Hd(e) || (e[n] = s), i = s);
    }
    r[i] = !0;
  }
  return r;
}
function Jd(r) {
  for (let e = 0; e < r.length; e++)
    nt(r, e) || (r[e] = null);
  return r;
}
function ft(r) {
  const e = gr(null);
  for (const n of Ec(r)) {
    var t = zd(n, 2);
    const i = t[0], s = t[1];
    nt(r, i) && (kr(s) ? e[i] = Jd(s) : s && typeof s == "object" && s.constructor === Object ? e[i] = ft(s) : e[i] = s);
  }
  return e;
}
function eh(r) {
  switch (typeof r) {
    case "string":
      return r;
    case "number":
      return Kd(r);
    case "boolean":
      return Qd(r);
    case "bigint":
      return Sa ? Sa(r) : "0";
    case "symbol":
      return Na ? Na(r) : "Symbol()";
    case "undefined":
      return Hr(r);
    case "function":
    case "object": {
      if (r === null)
        return Hr(r);
      const e = r, t = kt(e, "toString");
      if (typeof t == "function") {
        const n = t(e);
        return typeof n == "string" ? n : Hr(n);
      }
      return Hr(r);
    }
    default:
      return Hr(r);
  }
}
function kt(r, e) {
  for (; r !== null; ) {
    const n = qd(r, e);
    if (n) {
      if (n.get)
        return Me(n.get);
      if (typeof n.value == "function")
        return Me(n.value);
    }
    r = Gd(r);
  }
  function t() {
    return null;
  }
  return t;
}
function th(r) {
  try {
    return qe(r, ""), !0;
  } catch {
    return !1;
  }
}
const Oa = Re(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ss = Re(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ns = Re(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), nh = Re(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Os = Re(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), rh = Re(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Ca = Re(["#text"]), ja = Re(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Cs = Re(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dominant-baseline", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "pointer-events", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-orientation", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "vector-effect", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Da = Re(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Pi = Re(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ih = Le(/{{[\w\W]*|^[\w\W]*}}/g), sh = Le(/<%[\w\W]*|^[\w\W]*%>/g), oh = Le(/\${[\w\W]*/g), ah = Le(/^data-[\-\w.\u00B7-\uFFFF]+$/), lh = Le(/^aria-[\-\w]+$/), Ma = Le(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), ch = Le(/^(?:\w+script|data):/i), uh = Le(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fh = Le(/^html$/i), dh = Le(/^[a-z][.\w]*(-[.\w]+)+$/i), Aa = Le(/<[/\w!]/g), Ra = Le(/<[/\w]/g), hh = Le(/<\/no(script|embed|frames)/i), mh = Le(/\/>/i), ut = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, Nc = ["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"], ph = Re(se({}, Nc)), gh = (function() {
  const r = {};
  return Kn(Nc, (e) => {
    r[e] = Le(new RegExp("</" + e + "(?=[\\t\\n\\f\\r />])", "i"));
  }), Re(r);
})(), _h = function() {
  return typeof window > "u" ? null : window;
}, yh = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const i = "data-tt-policy-suffix";
  t && t.hasAttribute(i) && (n = t.getAttribute(i));
  const s = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, Pa = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, wn = function(e, t, n, i) {
  return nt(e, t) && kr(e[t]) ? se(i.base ? ft(i.base) : {}, e[t], i.transform) : n;
}, js = function(e, t, n) {
  const i = nt(e, t) ? e[t] : void 0;
  return i && typeof i == "object" ? ft(i) : n();
};
function Oc() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _h();
  const e = (R) => Oc(R);
  if (e.version = "3.4.15", e.removed = [], !r || !r.document || r.document.nodeType !== ut.document || !r.Element)
    return e.isSupported = !1, e;
  let t = r.document;
  const n = t, i = n.currentScript;
  r.DocumentFragment;
  const s = r.HTMLTemplateElement, o = r.Node, a = r.Element, c = r.NodeFilter, u = r.NamedNodeMap;
  u === void 0 && (r.NamedNodeMap || r.MozNamedAttrMap), r.HTMLFormElement;
  const f = r.DOMParser, d = r.trustedTypes, p = a.prototype, _ = kt(p, "cloneNode"), v = kt(p, "remove"), m = kt(p, "removeAttributeNode"), y = kt(p, "nextSibling"), x = kt(p, "childNodes"), k = kt(p, "parentNode"), E = kt(p, "shadowRoot"), O = kt(p, "attributes"), h = o && o.prototype ? kt(o.prototype, "nodeType") : null, b = o && o.prototype ? kt(o.prototype, "nodeName") : null, w = o && o.prototype ? kt(o.prototype, "ownerDocument") : null, C = function(g) {
    return h ? h(g) : g.nodeType;
  }, N = function(g) {
    return b ? b(g) : g.nodeName;
  };
  if (typeof s == "function") {
    const R = t.createElement("template");
    R.content && R.content.ownerDocument && (t = R.content.ownerDocument);
  }
  let j, A = "", B, z = !1, P = 0;
  const I = function() {
    if (P > 0)
      throw qn('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, X = function(g) {
    I(), P++;
    try {
      return j.createHTML(g);
    } finally {
      P--;
    }
  }, oe = function(g) {
    I(), P++;
    try {
      return j.createScriptURL(g);
    } finally {
      P--;
    }
  }, Oe = function() {
    return z || (B = yh(d, i), z = !0), B;
  }, pe = t, _e = pe.implementation, Ce = pe.createNodeIterator, ze = pe.createDocumentFragment, jt = pe.getElementsByTagName, Fe = n.importNode;
  let J = Pa();
  e.isSupported = typeof Ec == "function" && typeof k == "function" && _e && _e.createHTMLDocument !== void 0;
  const un = ih, fn = sh, dn = oh, hn = ah, Dt = lh, Ar = ch, Pn = uh, Rr = dh;
  let ar = Ma, ae = null;
  const Mt = se({}, [...Oa, ...Ss, ...Ns, ...Os, ...Ca]);
  let ce = null;
  const mn = se({}, [...ja, ...Cs, ...Da, ...Pi]);
  let We = Object.seal(gr(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Vt = null, lr = null;
  const Je = Object.seal(gr(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let In = !0, Xt = !0, Kt = !1, Ln = !0, ct = !1, At = !0, wt = !1, pn = !1, gn = null, _n = null, Fn = !1, It = !1, yn = !1, bn = !1, Wn = !0, Qt = !1;
  const Yn = "user-content-";
  let q = !0, Q = !1, $ = {}, le = null;
  const te = se({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let Ue = null;
  const ee = se({}, ["audio", "video", "img", "source", "image", "track"]);
  let Bn = null;
  const zn = se({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), vn = "http://www.w3.org/1998/Math/MathML", Lt = "http://www.w3.org/2000/svg", Ye = "http://www.w3.org/1999/xhtml";
  let Zt = Ye, Pr = !1, Ir = null;
  const fs = se({}, [vn, Lt, Ye], Es), wi = Re(["mi", "mo", "mn", "ms", "mtext"]);
  let T = se({}, wi);
  const M = Re(["annotation-xml"]);
  let L = se({}, M);
  const V = se({}, ["title", "style", "font", "a", "script"]);
  let ne = null;
  const ue = ["application/xhtml+xml", "text/html"], re = "text/html";
  let U = null, Se = null;
  const be = t.createElement("form"), ve = function(g) {
    return g instanceof RegExp || g instanceof Function;
  }, He = function() {
    let g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Se && Se === g)
      return;
    (!g || typeof g != "object") && (g = {}), g = ft(g), ne = // eslint-disable-next-line unicorn/prefer-includes
    ue.indexOf(g.PARSER_MEDIA_TYPE) === -1 ? re : g.PARSER_MEDIA_TYPE, U = ne === "application/xhtml+xml" ? Es : ei, ae = wn(g, "ALLOWED_TAGS", Mt, {
      transform: U
    }), ce = wn(g, "ALLOWED_ATTR", mn, {
      transform: U
    }), Ir = wn(g, "ALLOWED_NAMESPACES", fs, {
      transform: Es
    }), Bn = wn(g, "ADD_URI_SAFE_ATTR", zn, {
      transform: U,
      base: zn
    }), Ue = wn(g, "ADD_DATA_URI_TAGS", ee, {
      transform: U,
      base: ee
    }), le = wn(g, "FORBID_CONTENTS", te, {
      transform: U
    }), Vt = wn(g, "FORBID_TAGS", ft({}), {
      transform: U
    }), lr = wn(g, "FORBID_ATTR", ft({}), {
      transform: U
    }), $ = nt(g, "USE_PROFILES") ? g.USE_PROFILES && typeof g.USE_PROFILES == "object" ? ft(g.USE_PROFILES) : g.USE_PROFILES : !1, In = g.ALLOW_ARIA_ATTR !== !1, Xt = g.ALLOW_DATA_ATTR !== !1, Kt = g.ALLOW_UNKNOWN_PROTOCOLS || !1, Ln = g.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ct = g.SAFE_FOR_TEMPLATES || !1, At = g.SAFE_FOR_XML !== !1, wt = g.WHOLE_DOCUMENT || !1, It = g.RETURN_DOM || !1, yn = g.RETURN_DOM_FRAGMENT || !1, bn = g.RETURN_TRUSTED_TYPE || !1, Fn = g.FORCE_BODY || !1, Wn = g.SANITIZE_DOM !== !1, Qt = g.SANITIZE_NAMED_PROPS || !1, q = g.KEEP_CONTENT !== !1, Q = g.IN_PLACE || !1, ar = th(g.ALLOWED_URI_REGEXP) ? g.ALLOWED_URI_REGEXP : Ma, Zt = typeof g.NAMESPACE == "string" ? g.NAMESPACE : Ye, T = js(
      g,
      "MATHML_TEXT_INTEGRATION_POINTS",
      () => se({}, wi)
      // Default built-in map
    ), L = js(
      g,
      "HTML_INTEGRATION_POINTS",
      () => se({}, M)
      // Default built-in map
    );
    const S = js(g, "CUSTOM_ELEMENT_HANDLING", () => gr(null));
    if (We = gr(null), nt(S, "tagNameCheck") && ve(S.tagNameCheck) && (We.tagNameCheck = S.tagNameCheck), nt(S, "attributeNameCheck") && ve(S.attributeNameCheck) && (We.attributeNameCheck = S.attributeNameCheck), nt(S, "allowCustomizedBuiltInElements") && typeof S.allowCustomizedBuiltInElements == "boolean" && (We.allowCustomizedBuiltInElements = S.allowCustomizedBuiltInElements), Le(We), ct && (Xt = !1), yn && (It = !0), $ && (ae = se({}, Ca), ce = gr(null), $.html === !0 && (se(ae, Oa), se(ce, ja)), $.svg === !0 && (se(ae, Ss), se(ce, Cs), se(ce, Pi)), $.svgFilters === !0 && (se(ae, Ns), se(ce, Cs), se(ce, Pi)), $.mathMl === !0 && (se(ae, Os), se(ce, Da), se(ce, Pi))), Je.tagCheck = null, Je.attributeCheck = null, nt(g, "ADD_TAGS") && (typeof g.ADD_TAGS == "function" ? Je.tagCheck = g.ADD_TAGS : kr(g.ADD_TAGS) && (ae === Mt && (ae = ft(ae)), se(ae, g.ADD_TAGS, U))), nt(g, "ADD_ATTR") && (typeof g.ADD_ATTR == "function" ? Je.attributeCheck = g.ADD_ATTR : kr(g.ADD_ATTR) && (ce === mn && (ce = ft(ce)), se(ce, g.ADD_ATTR, U))), nt(g, "ADD_FORBID_CONTENTS") && kr(g.ADD_FORBID_CONTENTS) && (le === te && (le = ft(le)), se(le, g.ADD_FORBID_CONTENTS, U)), q && (ae["#text"] = !0), wt && se(ae, ["html", "head", "body"]), ae.table && (se(ae, ["tbody"]), delete Vt.tbody), g.TRUSTED_TYPES_POLICY) {
      if (typeof g.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw qn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof g.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw qn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const D = j;
      j = g.TRUSTED_TYPES_POLICY;
      try {
        A = X("");
      } catch (W) {
        throw j = D, W;
      }
    } else g.TRUSTED_TYPES_POLICY === null ? (j = void 0, A = "") : (j === void 0 && (j = Oe()), j && typeof A == "string" && (A = X("")));
    Re && Re(g), Se = g;
  }, Jt = se({}, [...Ss, ...Ns, ...nh]), Ft = se({}, [...Os, ...rh]), Ge = function(g, S, D) {
    return S.namespaceURI === Ye ? g === "svg" : S.namespaceURI === vn ? g === "svg" && (D === "annotation-xml" || T[D]) : !!Jt[g];
  }, Lr = function(g, S, D) {
    return S.namespaceURI === Ye ? g === "math" : S.namespaceURI === Lt ? g === "math" && L[D] : !!Ft[g];
  }, ds = function(g, S, D) {
    return S.namespaceURI === Lt && !L[D] || S.namespaceURI === vn && !T[D] ? !1 : !Ft[g] && (V[g] || !Jt[g]);
  }, hs = function(g) {
    let S = k(g);
    (!S || !S.tagName) && (S = {
      namespaceURI: Zt,
      tagName: "template"
    });
    const D = ei(g.tagName), W = ei(S.tagName);
    return Ir[g.namespaceURI] ? g.namespaceURI === Lt ? Ge(D, S, W) : g.namespaceURI === vn ? Lr(D, S, W) : g.namespaceURI === Ye ? ds(D, S, W) : !!(ne === "application/xhtml+xml" && Ir[g.namespaceURI]) : !1;
  }, xn = function(g) {
    zr(e.removed, {
      element: g
    });
    try {
      k(g).removeChild(g);
    } catch {
      if (v(g), !k(g))
        throw qn("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, Ao = function(g, S, D) {
    try {
      m(g, S);
    } catch {
      try {
        g.removeAttribute(D);
      } catch {
      }
    }
  }, Ti = function(g) {
    ki(g);
    const S = x(g);
    if (S) {
      const W = [];
      Kn(S, (H) => {
        zr(W, H);
      }), Kn(W, (H) => {
        try {
          v(H);
        } catch {
        }
      });
    }
    const D = O(g);
    if (D)
      for (let W = D.length - 1; W >= 0; --W) {
        const H = D[W], K = H && H.name;
        typeof K == "string" && Ao(g, H, K);
      }
  }, Un = function(g, S, D) {
    if (!D)
      try {
        D = S.getAttributeNode(g);
      } catch {
        D = null;
      }
    zr(e.removed, {
      attribute: D || null,
      from: S
    });
    try {
      D ? m(S, D) : S.removeAttribute(g);
    } catch {
      try {
        S.removeAttribute(g);
      } catch {
      }
    }
    if (g === "is")
      if (It || yn)
        try {
          xn(S);
        } catch {
        }
      else
        try {
          S.setAttribute(g, "");
        } catch {
        }
  }, du = function(g) {
    const S = O(g);
    if (S)
      for (let D = S.length - 1; D >= 0; --D) {
        const W = S[D], H = W && W.name;
        typeof H != "string" || ce[U(H)] || Ao(g, W, H);
      }
  }, ki = function(g) {
    const S = [g];
    for (; S.length > 0; ) {
      const D = S.pop();
      C(D) === ut.element && du(D);
      const H = x(D);
      if (H)
        for (let K = H.length - 1; K >= 0; --K)
          S.push(H[K]);
    }
  }, Ro = function(g, S) {
    return At ? g === "patchsrc" ? !0 : g === "for" && S !== "label" && S !== "output" : !1;
  }, hu = function(g) {
    if (!At)
      return;
    const S = [g];
    for (; S.length > 0; ) {
      const D = S.pop(), W = C(D);
      if (W === ut.processingInstruction || W === ut.comment && qe(Ra, D.data)) {
        try {
          v(D);
        } catch {
        }
        continue;
      }
      if (W === ut.element) {
        const K = D, ge = U(N(D));
        try {
          K.hasAttribute && K.hasAttribute("patchsrc") && K.removeAttribute("patchsrc"), K.hasAttribute && K.hasAttribute("for") && Ro("for", ge) && K.removeAttribute("for");
        } catch {
        }
      }
      const H = x(D);
      if (H)
        for (let K = H.length - 1; K >= 0; --K)
          S.push(H[K]);
    }
  }, Po = function(g) {
    let S = null, D = null;
    if (Fn)
      g = "<remove></remove>" + g;
    else {
      const K = ka(g, /^[\r\n\t ]+/);
      D = K && K[0];
    }
    ne === "application/xhtml+xml" && Zt === Ye && (g = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + g + "</body></html>");
    const W = j ? X(g) : g;
    if (Zt === Ye)
      try {
        S = new f().parseFromString(W, ne);
      } catch {
      }
    if (!S || !S.documentElement) {
      S = _e.createDocument(Zt, "template", null);
      try {
        S.documentElement.innerHTML = Pr ? A : W;
      } catch {
      }
    }
    const H = S.body || S.documentElement;
    return g && D && H.insertBefore(t.createTextNode(D), H.childNodes[0] || null), Zt === Ye ? jt.call(S, wt ? "html" : "body")[0] : wt ? S.documentElement : H;
  }, Io = function(g) {
    const S = w ? w(g) : g.ownerDocument;
    return Ce.call(
      S || g,
      g,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Ei = function(g) {
    return g = Ur(g, un, " "), g = Ur(g, fn, " "), g = Ur(g, dn, " "), g;
  }, ms = function(g) {
    var S;
    g.normalize();
    const D = w ? w(g) : g.ownerDocument, W = Ce.call(
      D || g,
      g,
      // eslint-disable-next-line no-bitwise
      c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let H = W.nextNode();
    for (; H; )
      H.data = Ei(H.data), H = W.nextNode();
    const K = (S = g.querySelectorAll) === null || S === void 0 ? void 0 : S.call(g, "template");
    K && Kn(K, (ge) => {
      cr(ge.content) && ms(ge.content);
    });
  }, Si = function(g) {
    const S = b ? b(g) : null;
    return typeof S != "string" || U(S) !== "form" ? !1 : typeof g.nodeName != "string" || typeof g.textContent != "string" || typeof g.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    g.attributes !== O(g) || typeof g.removeAttribute != "function" || // A form descendant named "removeAttributeNode" or "getAttributeNode"
    // shadows these Attr-node methods via [LegacyOverrideBuiltIns].
    // _removeAttribute() / _stripAttributeNode() reach for
    // element.removeAttributeNode(attr) first; when it is shadowed the call
    // throws and the name-based fallback element.removeAttribute(name)
    // ASCII-lowercases its lookup key in an HTML document, silently missing
    // a case-preserved event-handler attribute (e.g. an ONANIMATIONSTART
    // that reached the sanitizer through an XML/XHTML parse). Flag the form
    // so it is removed wholesale, exactly as for the other shadowed methods.
    typeof g.removeAttributeNode != "function" || typeof g.getAttributeNode != "function" || typeof g.setAttribute != "function" || typeof g.namespaceURI != "string" || typeof g.insertBefore != "function" || typeof g.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    g.nodeType !== h(g) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    g.childNodes !== x(g);
  }, cr = function(g) {
    if (!h || typeof g != "object" || g === null)
      return !1;
    try {
      return h(g) === ut.documentFragment;
    } catch {
      return !1;
    }
  }, Fr = function(g) {
    if (!h || typeof g != "object" || g === null)
      return !1;
    try {
      return typeof h(g) == "number";
    } catch {
      return !1;
    }
  };
  function Wt(R, g, S) {
    R.length !== 0 && Kn(R, (D) => {
      D.call(e, g, S, Se);
    });
  }
  const mu = function(g, S) {
    return !!(At && g.hasChildNodes() && !Fr(g.firstElementChild) && qe(Aa, g.textContent) && qe(Aa, g.innerHTML) || At && g.namespaceURI === Ye && ph[S] && (Fr(g.firstElementChild) || typeof g.textContent == "string" && qe(gh[S], g.textContent)) || g.nodeType === ut.processingInstruction || At && g.nodeType === ut.comment && qe(Ra, g.data));
  }, Ni = function(g, S) {
    if (g instanceof RegExp)
      return qe(g, S);
    if (g instanceof Function) {
      for (var D = arguments.length, W = new Array(D > 2 ? D - 2 : 0), H = 2; H < D; H++)
        W[H - 2] = arguments[H];
      return !!g(S, ...W);
    }
    return !1;
  }, pu = function(g, S, D) {
    if (!Vt[S] && Bo(S) && Ni(We.tagNameCheck, S))
      return !1;
    if (q && !le[S]) {
      const W = k(g), H = x(g);
      if (H && W) {
        const K = H.length;
        for (let ge = K - 1; ge >= 0; --ge) {
          const xe = g === D ? _(H[ge], !0) : H[ge];
          W.insertBefore(xe, y(g));
        }
      }
    }
    return xn(g), !0;
  }, Lo = function(g, S, D, W) {
    return g.length === 0 ? S : S === D || S === W ? ft(S) : S;
  }, Fo = function(g, S) {
    return g === S || k(g) !== null ? !1 : (Q && ki(g), !0);
  }, Wo = function(g, S) {
    if (Wt(J.beforeSanitizeElements, g, null), Fo(g, S))
      return !0;
    if (Si(g))
      return xn(g), !0;
    const D = U(N(g));
    if (ae = Lo(J.uponSanitizeElement, ae, Mt, gn), Wt(J.uponSanitizeElement, g, {
      tagName: D,
      allowedTags: ae
    }), Fo(g, S))
      return !0;
    if (mu(g, D))
      return xn(g), !0;
    if (Vt[D] || !(Je.tagCheck instanceof Function && Je.tagCheck(D)) && !ae[D]) {
      const H = pu(g, D, S);
      return H === !1 && Wt(J.afterSanitizeElements, g, null), H;
    }
    if (C(g) === ut.element && !hs(g) || (D === "noscript" || D === "noembed" || D === "noframes") && qe(hh, g.innerHTML))
      return xn(g), !0;
    if (ct && g.nodeType === ut.text) {
      const H = Ei(g.textContent);
      g.textContent !== H && (zr(e.removed, {
        element: g.cloneNode()
      }), g.textContent = H);
    }
    return Wt(J.afterSanitizeElements, g, null), !1;
  }, Yo = function(g, S, D) {
    if (lr[S] || Ro(S, g) || Wn && (S === "id" || S === "name") && (D in t || D in be))
      return !1;
    const W = ce[S] || Je.attributeCheck instanceof Function && Je.attributeCheck(S, g);
    return Xt && qe(hn, S) || In && qe(Dt, S) ? !0 : W ? Bn[S] || qe(ar, Ur(D, Pn, "")) || (S === "src" || S === "xlink:href" || S === "href") && g !== "script" && Ea(D, "data:") === 0 && Ue[g] || Kt && !qe(Ar, Ur(D, Pn, "")) ? !0 : !D : (
      // Condition a) covers a basically valid custom element tag name whose
      // tag passes the configured tagNameCheck and whose attribute name
      // passes the configured attributeNameCheck ...
      Bo(g) && Ni(We.tagNameCheck, g) && Ni(We.attributeNameCheck, S, g) || // Condition b) covers an `is` attribute whose value passes the
      // configured tagNameCheck while customized built-in elements are
      // allowed.
      S === "is" && We.allowCustomizedBuiltInElements && Ni(We.tagNameCheck, D)
    );
  }, gu = se({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Bo = function(g) {
    return !gu[ei(g)] && qe(Rr, g);
  }, _u = function(g, S, D, W) {
    if (j && typeof d == "object" && typeof d.getAttributeType == "function" && !D)
      switch (d.getAttributeType(g, S)) {
        case "TrustedHTML":
          return X(W);
        case "TrustedScriptURL":
          return oe(W);
      }
    return W;
  }, yu = function(g, S, D, W) {
    try {
      return D ? g.setAttributeNS(D, S, W) : g.setAttribute(S, W), Si(g) ? (xn(g), !1) : !0;
    } catch {
      return Un(S, g), !1;
    }
  }, zo = function(g) {
    Wt(J.beforeSanitizeAttributes, g, null);
    const S = g.attributes;
    if (!S || Si(g))
      return;
    ce = Lo(J.uponSanitizeAttribute, ce, mn, _n);
    const D = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ce,
      forceKeepAttr: void 0
    };
    let W = S.length;
    const H = U(g.nodeName);
    for (; W--; ) {
      const K = S[W], ge = K.name, xe = K.namespaceURI, et = K.value, tt = U(ge), gs = et;
      let Ze = ge === "value" ? gs : Xd(gs), Uo = !1;
      if (D.attrName = tt, D.attrValue = Ze, D.keepAttr = !0, D.forceKeepAttr = void 0, Wt(J.uponSanitizeAttribute, g, D), Ze = D.attrValue, Qt && (tt === "id" || tt === "name") && Ea(Ze, Yn) !== 0 && (Un(ge, g, K), Ze = Yn + Ze, Uo = !0), At && qe(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Ze)) {
        Un(ge, g, K);
        continue;
      }
      if (tt === "attributename" && ka(Ze, "href")) {
        Un(ge, g, K);
        continue;
      }
      if (!D.forceKeepAttr) {
        if (!D.keepAttr) {
          Un(ge, g, K);
          continue;
        }
        if (!Ln && qe(mh, Ze)) {
          Un(ge, g, K);
          continue;
        }
        if (ct && (Ze = Ei(Ze)), !Yo(H, tt, Ze)) {
          Un(ge, g, K);
          continue;
        }
        Ze = _u(H, tt, xe, Ze), Ze !== gs && yu(g, ge, xe, Ze) && Uo && Ta(e.removed);
      }
    }
    Wt(J.afterSanitizeAttributes, g, null);
  }, Oi = function(g) {
    let S = null;
    const D = Io(g);
    for (Wt(J.beforeSanitizeShadowDOM, g, null); S = D.nextNode(); )
      if (Wt(J.uponSanitizeShadowNode, S, null), Wo(S, g), zo(S), cr(S.content) && Oi(S.content), C(S) === ut.element) {
        const W = E(S);
        cr(W) && (ps(W), Oi(W));
      }
    Wt(J.afterSanitizeShadowDOM, g, null);
  }, ps = function(g) {
    const S = [{
      node: g,
      shadow: null
    }];
    for (; S.length > 0; ) {
      const D = S.pop();
      if (D.shadow) {
        Oi(D.shadow);
        continue;
      }
      const W = D.node, K = C(W) === ut.element, ge = x(W);
      if (ge)
        for (let xe = ge.length - 1; xe >= 0; --xe)
          S.push({
            node: ge[xe],
            shadow: null
          });
      if (K) {
        const xe = b ? b(W) : null;
        if (typeof xe == "string" && U(xe) === "template") {
          const et = W.content;
          cr(et) && S.push({
            node: et,
            shadow: null
          });
        }
      }
      if (K) {
        const xe = E(W);
        cr(xe) && S.push({
          node: null,
          shadow: xe
        }, {
          node: xe,
          shadow: null
        });
      }
    }
  };
  return e.sanitize = function(R) {
    let g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, S = null, D = null, W = null, H = null;
    if (Pr = !R, Pr && (R = "<!-->"), typeof R != "string" && !Fr(R) && (R = eh(R), typeof R != "string"))
      throw qn("dirty is not a string, aborting");
    if (!e.isSupported)
      return R;
    pn ? (ae = gn, ce = _n) : He(g), (J.uponSanitizeElement.length > 0 || J.uponSanitizeAttribute.length > 0) && (ae = ft(ae)), J.uponSanitizeAttribute.length > 0 && (ce = ft(ce)), e.removed = [];
    const K = Q && typeof R != "string" && Fr(R);
    if (K) {
      hu(R);
      const et = N(R);
      if (typeof et == "string") {
        const tt = U(et);
        if (!ae[tt] || Vt[tt])
          throw Ti(R), qn("root node is forbidden and cannot be sanitized in-place");
      }
      if (Si(R))
        throw Ti(R), qn("root node is clobbered and cannot be sanitized in-place");
      try {
        ps(R);
      } catch (tt) {
        throw Ti(R), tt;
      }
    } else if (Fr(R))
      S = Po("<!---->"), D = S.ownerDocument.importNode(R, !0), D.nodeType === ut.element && D.nodeName === "BODY" || D.nodeName === "HTML" ? S = D : S.appendChild(D), ps(S);
    else {
      if (!It && !ct && !wt && // eslint-disable-next-line unicorn/prefer-includes
      R.indexOf("<") === -1)
        return j && bn ? X(R) : R;
      if (S = Po(R), !S)
        return It ? null : bn ? A : "";
    }
    S && Fn && xn(S.firstChild);
    const ge = K ? R : S;
    try {
      const et = Io(ge);
      for (; W = et.nextNode(); )
        Wo(W, ge), zo(W), cr(W.content) && Oi(W.content);
    } catch (et) {
      throw K && (Ti(R), Kn(e.removed, (tt) => {
        tt.element && ki(tt.element);
      })), et;
    }
    if (K)
      return Kn(e.removed, (et) => {
        et.element && ki(et.element);
      }), ct && ms(R), R;
    if (It) {
      if (ct && ms(S), yn)
        for (H = ze.call(S.ownerDocument); S.firstChild; )
          H.appendChild(S.firstChild);
      else
        H = S;
      return (ce.shadowroot || ce.shadowrootmode) && (H = Fe.call(n, H, !0)), H;
    }
    let xe = wt ? S.outerHTML : S.innerHTML;
    return wt && ae["!doctype"] && S.ownerDocument && S.ownerDocument.doctype && S.ownerDocument.doctype.name && qe(fh, S.ownerDocument.doctype.name) && (xe = "<!DOCTYPE " + S.ownerDocument.doctype.name + `>
` + xe), ct && (xe = Ei(xe)), j && bn ? X(xe) : xe;
  }, e.setConfig = function() {
    let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    He(R), pn = !0, gn = ae, _n = ce;
  }, e.clearConfig = function() {
    Se = null, pn = !1, gn = null, _n = null, j = B, A = "";
  }, e.isValidAttribute = function(R, g, S) {
    Se || He({});
    const D = U(R), W = U(g);
    return Yo(D, W, S);
  }, e.addHook = function(R, g) {
    typeof g == "function" && nt(J, R) && zr(J[R], g);
  }, e.removeHook = function(R, g) {
    if (nt(J, R)) {
      if (g !== void 0) {
        const S = $d(J[R], g);
        return S === -1 ? void 0 : Vd(J[R], S, 1)[0];
      }
      return Ta(J[R]);
    }
  }, e.removeHooks = function(R) {
    nt(J, R) && (J[R] = []);
  }, e.removeAllHooks = function() {
    J = Pa();
  }, e;
}
var Cc = Oc(), Gr = {}, fr = {}, Ii = {}, Tn = {}, $n = {}, Ds = {}, Ia;
function jc() {
  return Ia || (Ia = 1, (function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.Doctype = r.CDATA = r.Tag = r.Style = r.Script = r.Comment = r.Directive = r.Text = r.Root = r.isTag = r.ElementType = void 0;
    var e;
    (function(n) {
      n.Root = "root", n.Text = "text", n.Directive = "directive", n.Comment = "comment", n.Script = "script", n.Style = "style", n.Tag = "tag", n.CDATA = "cdata", n.Doctype = "doctype";
    })(e = r.ElementType || (r.ElementType = {}));
    function t(n) {
      return n.type === e.Tag || n.type === e.Script || n.type === e.Style;
    }
    r.isTag = t, r.Root = e.Root, r.Text = e.Text, r.Directive = e.Directive, r.Comment = e.Comment, r.Script = e.Script, r.Style = e.Style, r.Tag = e.Tag, r.CDATA = e.CDATA, r.Doctype = e.Doctype;
  })(Ds)), Ds;
}
var Z = {}, La;
function Fa() {
  if (La) return Z;
  La = 1;
  var r = Z && Z.__extends || /* @__PURE__ */ (function() {
    var h = function(b, w) {
      return h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(C, N) {
        C.__proto__ = N;
      } || function(C, N) {
        for (var j in N) Object.prototype.hasOwnProperty.call(N, j) && (C[j] = N[j]);
      }, h(b, w);
    };
    return function(b, w) {
      if (typeof w != "function" && w !== null)
        throw new TypeError("Class extends value " + String(w) + " is not a constructor or null");
      h(b, w);
      function C() {
        this.constructor = b;
      }
      b.prototype = w === null ? Object.create(w) : (C.prototype = w.prototype, new C());
    };
  })(), e = Z && Z.__assign || function() {
    return e = Object.assign || function(h) {
      for (var b, w = 1, C = arguments.length; w < C; w++) {
        b = arguments[w];
        for (var N in b) Object.prototype.hasOwnProperty.call(b, N) && (h[N] = b[N]);
      }
      return h;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(Z, "__esModule", { value: !0 }), Z.cloneNode = Z.hasChildren = Z.isDocument = Z.isDirective = Z.isComment = Z.isText = Z.isCDATA = Z.isTag = Z.Element = Z.Document = Z.CDATA = Z.NodeWithChildren = Z.ProcessingInstruction = Z.Comment = Z.Text = Z.DataNode = Z.Node = void 0;
  var t = /* @__PURE__ */ jc(), n = (
    /** @class */
    (function() {
      function h() {
        this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
      }
      return Object.defineProperty(h.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(b) {
          this.parent = b;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(h.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(b) {
          this.prev = b;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(h.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(b) {
          this.next = b;
        },
        enumerable: !1,
        configurable: !0
      }), h.prototype.cloneNode = function(b) {
        return b === void 0 && (b = !1), E(this, b);
      }, h;
    })()
  );
  Z.Node = n;
  var i = (
    /** @class */
    (function(h) {
      r(b, h);
      function b(w) {
        var C = h.call(this) || this;
        return C.data = w, C;
      }
      return Object.defineProperty(b.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(w) {
          this.data = w;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(n)
  );
  Z.DataNode = i;
  var s = (
    /** @class */
    (function(h) {
      r(b, h);
      function b() {
        var w = h !== null && h.apply(this, arguments) || this;
        return w.type = t.ElementType.Text, w;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(i)
  );
  Z.Text = s;
  var o = (
    /** @class */
    (function(h) {
      r(b, h);
      function b() {
        var w = h !== null && h.apply(this, arguments) || this;
        return w.type = t.ElementType.Comment, w;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(i)
  );
  Z.Comment = o;
  var a = (
    /** @class */
    (function(h) {
      r(b, h);
      function b(w, C) {
        var N = h.call(this, C) || this;
        return N.name = w, N.type = t.ElementType.Directive, N;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(i)
  );
  Z.ProcessingInstruction = a;
  var c = (
    /** @class */
    (function(h) {
      r(b, h);
      function b(w) {
        var C = h.call(this) || this;
        return C.children = w, C;
      }
      return Object.defineProperty(b.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var w;
          return (w = this.children[0]) !== null && w !== void 0 ? w : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(b.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(b.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(w) {
          this.children = w;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(n)
  );
  Z.NodeWithChildren = c;
  var u = (
    /** @class */
    (function(h) {
      r(b, h);
      function b() {
        var w = h !== null && h.apply(this, arguments) || this;
        return w.type = t.ElementType.CDATA, w;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(c)
  );
  Z.CDATA = u;
  var f = (
    /** @class */
    (function(h) {
      r(b, h);
      function b() {
        var w = h !== null && h.apply(this, arguments) || this;
        return w.type = t.ElementType.Root, w;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(c)
  );
  Z.Document = f;
  var d = (
    /** @class */
    (function(h) {
      r(b, h);
      function b(w, C, N, j) {
        N === void 0 && (N = []), j === void 0 && (j = w === "script" ? t.ElementType.Script : w === "style" ? t.ElementType.Style : t.ElementType.Tag);
        var A = h.call(this, N) || this;
        return A.name = w, A.attribs = C, A.type = j, A;
      }
      return Object.defineProperty(b.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(b.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(w) {
          this.name = w;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(b.prototype, "attributes", {
        get: function() {
          var w = this;
          return Object.keys(this.attribs).map(function(C) {
            var N, j;
            return {
              name: C,
              value: w.attribs[C],
              namespace: (N = w["x-attribsNamespace"]) === null || N === void 0 ? void 0 : N[C],
              prefix: (j = w["x-attribsPrefix"]) === null || j === void 0 ? void 0 : j[C]
            };
          });
        },
        enumerable: !1,
        configurable: !0
      }), b;
    })(c)
  );
  Z.Element = d;
  function p(h) {
    return (0, t.isTag)(h);
  }
  Z.isTag = p;
  function _(h) {
    return h.type === t.ElementType.CDATA;
  }
  Z.isCDATA = _;
  function v(h) {
    return h.type === t.ElementType.Text;
  }
  Z.isText = v;
  function m(h) {
    return h.type === t.ElementType.Comment;
  }
  Z.isComment = m;
  function y(h) {
    return h.type === t.ElementType.Directive;
  }
  Z.isDirective = y;
  function x(h) {
    return h.type === t.ElementType.Root;
  }
  Z.isDocument = x;
  function k(h) {
    return Object.prototype.hasOwnProperty.call(h, "children");
  }
  Z.hasChildren = k;
  function E(h, b) {
    b === void 0 && (b = !1);
    var w;
    if (v(h))
      w = new s(h.data);
    else if (m(h))
      w = new o(h.data);
    else if (p(h)) {
      var C = b ? O(h.children) : [], N = new d(h.name, e({}, h.attribs), C);
      C.forEach(function(z) {
        return z.parent = N;
      }), h.namespace != null && (N.namespace = h.namespace), h["x-attribsNamespace"] && (N["x-attribsNamespace"] = e({}, h["x-attribsNamespace"])), h["x-attribsPrefix"] && (N["x-attribsPrefix"] = e({}, h["x-attribsPrefix"])), w = N;
    } else if (_(h)) {
      var C = b ? O(h.children) : [], j = new u(C);
      C.forEach(function(P) {
        return P.parent = j;
      }), w = j;
    } else if (x(h)) {
      var C = b ? O(h.children) : [], A = new f(C);
      C.forEach(function(P) {
        return P.parent = A;
      }), h["x-mode"] && (A["x-mode"] = h["x-mode"]), w = A;
    } else if (y(h)) {
      var B = new a(h.name, h.data);
      h["x-name"] != null && (B["x-name"] = h["x-name"], B["x-publicId"] = h["x-publicId"], B["x-systemId"] = h["x-systemId"]), w = B;
    } else
      throw new Error("Not implemented yet: ".concat(h.type));
    return w.startIndex = h.startIndex, w.endIndex = h.endIndex, h.sourceCodeLocation != null && (w.sourceCodeLocation = h.sourceCodeLocation), w;
  }
  Z.cloneNode = E;
  function O(h) {
    for (var b = h.map(function(C) {
      return E(C, !0);
    }), w = 1; w < b.length; w++)
      b[w].prev = b[w - 1], b[w - 1].next = b[w];
    return b;
  }
  return Z;
}
var Wa;
function Dc() {
  return Wa || (Wa = 1, (function(r) {
    var e = $n && $n.__createBinding || (Object.create ? (function(a, c, u, f) {
      f === void 0 && (f = u);
      var d = Object.getOwnPropertyDescriptor(c, u);
      (!d || ("get" in d ? !c.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
        return c[u];
      } }), Object.defineProperty(a, f, d);
    }) : (function(a, c, u, f) {
      f === void 0 && (f = u), a[f] = c[u];
    })), t = $n && $n.__exportStar || function(a, c) {
      for (var u in a) u !== "default" && !Object.prototype.hasOwnProperty.call(c, u) && e(c, a, u);
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.DomHandler = void 0;
    var n = /* @__PURE__ */ jc(), i = /* @__PURE__ */ Fa();
    t(/* @__PURE__ */ Fa(), r);
    var s = {
      withStartIndices: !1,
      withEndIndices: !1,
      xmlMode: !1
    }, o = (
      /** @class */
      (function() {
        function a(c, u, f) {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof u == "function" && (f = u, u = s), typeof c == "object" && (u = c, c = void 0), this.callback = c ?? null, this.options = u ?? s, this.elementCB = f ?? null;
        }
        return a.prototype.onparserinit = function(c) {
          this.parser = c;
        }, a.prototype.onreset = function() {
          this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
        }, a.prototype.onend = function() {
          this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
        }, a.prototype.onerror = function(c) {
          this.handleCallback(c);
        }, a.prototype.onclosetag = function() {
          this.lastNode = null;
          var c = this.tagStack.pop();
          this.options.withEndIndices && (c.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(c);
        }, a.prototype.onopentag = function(c, u) {
          var f = this.options.xmlMode ? n.ElementType.Tag : void 0, d = new i.Element(c, u, void 0, f);
          this.addNode(d), this.tagStack.push(d);
        }, a.prototype.ontext = function(c) {
          var u = this.lastNode;
          if (u && u.type === n.ElementType.Text)
            u.data += c, this.options.withEndIndices && (u.endIndex = this.parser.endIndex);
          else {
            var f = new i.Text(c);
            this.addNode(f), this.lastNode = f;
          }
        }, a.prototype.oncomment = function(c) {
          if (this.lastNode && this.lastNode.type === n.ElementType.Comment) {
            this.lastNode.data += c;
            return;
          }
          var u = new i.Comment(c);
          this.addNode(u), this.lastNode = u;
        }, a.prototype.oncommentend = function() {
          this.lastNode = null;
        }, a.prototype.oncdatastart = function() {
          var c = new i.Text(""), u = new i.CDATA([c]);
          this.addNode(u), c.parent = u, this.lastNode = c;
        }, a.prototype.oncdataend = function() {
          this.lastNode = null;
        }, a.prototype.onprocessinginstruction = function(c, u) {
          var f = new i.ProcessingInstruction(c, u);
          this.addNode(f);
        }, a.prototype.handleCallback = function(c) {
          if (typeof this.callback == "function")
            this.callback(c, this.dom);
          else if (c)
            throw c;
        }, a.prototype.addNode = function(c) {
          var u = this.tagStack[this.tagStack.length - 1], f = u.children[u.children.length - 1];
          this.options.withStartIndices && (c.startIndex = this.parser.startIndex), this.options.withEndIndices && (c.endIndex = this.parser.endIndex), u.children.push(c), f && (c.prev = f, f.next = c), c.parent = u, this.lastNode = null;
        }, a;
      })()
    );
    r.DomHandler = o, r.default = o;
  })($n)), $n;
}
var Ms = {}, Ya;
function bh() {
  return Ya || (Ya = 1, (function(r) {
    Object.defineProperty(r, "__esModule", { value: !0 }), r.CARRIAGE_RETURN_PLACEHOLDER_REGEX = r.CARRIAGE_RETURN_PLACEHOLDER = r.CARRIAGE_RETURN_REGEX = r.CARRIAGE_RETURN = r.CASE_SENSITIVE_TAG_NAMES_MAP = r.CASE_SENSITIVE_TAG_NAMES = void 0, r.CASE_SENSITIVE_TAG_NAMES = [
      "animateMotion",
      "animateTransform",
      "clipPath",
      "feBlend",
      "feColorMatrix",
      "feComponentTransfer",
      "feComposite",
      "feConvolveMatrix",
      "feDiffuseLighting",
      "feDisplacementMap",
      "feDropShadow",
      "feFlood",
      "feFuncA",
      "feFuncB",
      "feFuncG",
      "feFuncR",
      "feGaussianBlur",
      "feImage",
      "feMerge",
      "feMergeNode",
      "feMorphology",
      "feOffset",
      "fePointLight",
      "feSpecularLighting",
      "feSpotLight",
      "feTile",
      "feTurbulence",
      "foreignObject",
      "linearGradient",
      "radialGradient",
      "textPath"
    ], r.CASE_SENSITIVE_TAG_NAMES_MAP = r.CASE_SENSITIVE_TAG_NAMES.reduce(function(e, t) {
      return e[t.toLowerCase()] = t, e;
    }, {}), r.CARRIAGE_RETURN = "\r", r.CARRIAGE_RETURN_REGEX = new RegExp(r.CARRIAGE_RETURN, "g"), r.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now().toString(), "__"), r.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(r.CARRIAGE_RETURN_PLACEHOLDER, "g");
  })(Ms)), Ms;
}
var Ba;
function Mc() {
  if (Ba) return Tn;
  Ba = 1, Object.defineProperty(Tn, "__esModule", { value: !0 }), Tn.formatAttributes = n, Tn.hasOpenTag = s, Tn.escapeSpecialCharacters = o, Tn.revertEscapedCharacters = a, Tn.formatDOM = c;
  var r = /* @__PURE__ */ Dc(), e = bh();
  function t(u) {
    return e.CASE_SENSITIVE_TAG_NAMES_MAP[u];
  }
  function n(u) {
    for (var f = {}, d = 0, p = u.length; d < p; d++) {
      var _ = u[d];
      f[_.name] = _.value;
    }
    return f;
  }
  function i(u) {
    u = u.toLowerCase();
    var f = t(u);
    return f || u;
  }
  function s(u, f) {
    var d = "<" + f, p = u.toLowerCase().indexOf(d);
    if (p === -1)
      return !1;
    var _ = u[p + d.length];
    return _ === ">" || _ === " " || _ === "	" || _ === `
` || _ === "\r" || _ === "/";
  }
  function o(u) {
    return u.replace(e.CARRIAGE_RETURN_REGEX, e.CARRIAGE_RETURN_PLACEHOLDER);
  }
  function a(u) {
    return u.replace(e.CARRIAGE_RETURN_PLACEHOLDER_REGEX, e.CARRIAGE_RETURN);
  }
  function c(u, f, d) {
    var p, _, v, m;
    f === void 0 && (f = null);
    for (var y = [], x, k = 0, E = u.length; k < E; k++) {
      var O = u[k];
      switch (O.nodeType) {
        case 1: {
          var h = i(O.nodeName);
          x = new r.Element(h, n(O.attributes)), x.children = c(
            // template children are on content
            h === "template" ? O.content.childNodes : O.childNodes,
            x
          );
          break;
        }
        case 3:
          x = new r.Text(a((p = O.nodeValue) !== null && p !== void 0 ? p : ""));
          break;
        case 8:
          x = new r.Comment((_ = O.nodeValue) !== null && _ !== void 0 ? _ : "");
          break;
        default:
          continue;
      }
      var b = (v = y[k - 1]) !== null && v !== void 0 ? v : null;
      b && (b.next = x), x.parent = f, x.prev = b, x.next = null, y.push(x);
    }
    return d && (x = new r.ProcessingInstruction(d.substring(0, d.indexOf(" ")).toLowerCase(), d), x.next = (m = y[0]) !== null && m !== void 0 ? m : null, x.parent = f, y.unshift(x), y[1] && (y[1].prev = y[0])), y;
  }
  return Tn;
}
var za;
function vh() {
  if (za) return Ii;
  za = 1, Object.defineProperty(Ii, "__esModule", { value: !0 }), Ii.default = v;
  var r = Mc(), e = "html", t = "head", n = "body", i = /<([a-zA-Z]+[0-9]?)/, s = function(m, y) {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
  }, o = function(m, y) {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
  }, a = typeof window == "object" && window.DOMParser;
  if (typeof a == "function") {
    var c = new a(), u = "text/html";
    o = function(m, y) {
      return y && (m = "<".concat(y, ">").concat(m, "</").concat(y, ">")), c.parseFromString(m, u);
    }, s = o;
  }
  if (typeof document == "object" && document.implementation) {
    var f = document.implementation.createHTMLDocument();
    s = function(m, y) {
      if (y) {
        var x = f.documentElement.querySelector(y);
        return x && (x.innerHTML = m), f;
      }
      return f.documentElement.innerHTML = m, f;
    };
  }
  var d = typeof document == "object" && document.createElement("template"), p;
  d && d.content && (p = function(m) {
    return d.innerHTML = m, d.content.childNodes;
  });
  var _ = (
    /* istanbul ignore next */
    function() {
      return document.createDocumentFragment().childNodes;
    }
  );
  function v(m) {
    var y, x, k, E, O, h;
    m = (0, r.escapeSpecialCharacters)(m);
    var b = i.exec(m), w = (y = b?.[1]) === null || y === void 0 ? void 0 : y.toLowerCase();
    switch (w) {
      case e: {
        var C = o(m);
        if (!(0, r.hasOpenTag)(m, t)) {
          var N = C.querySelector(t);
          (x = N?.parentNode) === null || x === void 0 || x.removeChild(N);
        }
        if (!(0, r.hasOpenTag)(m, n)) {
          var N = C.querySelector(n);
          (k = N?.parentNode) === null || k === void 0 || k.removeChild(N);
        }
        return C.querySelectorAll(e);
      }
      case t:
      case n: {
        var j = s(m).querySelectorAll(w);
        return (0, r.hasOpenTag)(m, n) && (0, r.hasOpenTag)(m, t) ? (O = (E = j[0].parentNode) === null || E === void 0 ? void 0 : E.childNodes) !== null && O !== void 0 ? O : _() : j;
      }
      // low-level tag or text
      default: {
        if (p)
          return p(m);
        var N = s(m, n).querySelector(n);
        return (h = N?.childNodes) !== null && h !== void 0 ? h : _();
      }
    }
  }
  return Ii;
}
var Ua;
function xh() {
  if (Ua) return fr;
  Ua = 1;
  var r = fr && fr.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(fr, "__esModule", { value: !0 }), fr.default = i;
  var e = r(vh()), t = Mc(), n = /<(![a-zA-Z\s]+)>/;
  function i(s) {
    if (typeof s != "string")
      throw new TypeError("First argument must be a string");
    if (!s)
      return [];
    var o = n.exec(s), a = o ? o[1] : void 0;
    return (0, t.formatDOM)((0, e.default)(s), null, a);
  }
  return fr;
}
var Li = {}, Tt = {}, qr = {}, Ha;
function wh() {
  if (Ha) return qr;
  Ha = 1;
  var r = 0;
  qr.SAME = r;
  var e = 1;
  return qr.CAMELCASE = e, qr.possibleStandardNames = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
  }, qr;
}
var Ga;
function Th() {
  if (Ga) return Tt;
  Ga = 1;
  const r = 0, e = 1, t = 2, n = 3, i = 4, s = 5, o = 6;
  function a(h) {
    return u.hasOwnProperty(h) ? u[h] : null;
  }
  function c(h, b, w, C, N, j, A) {
    this.acceptsBooleans = b === t || b === n || b === i, this.attributeName = C, this.attributeNamespace = N, this.mustUseProperty = w, this.propertyName = h, this.type = b, this.sanitizeURL = j, this.removeEmptyString = A;
  }
  const u = {};
  [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
  ].forEach((h) => {
    u[h] = new c(
      h,
      r,
      !1,
      // mustUseProperty
      h,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    ["acceptCharset", "accept-charset"],
    ["className", "class"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"]
  ].forEach(([h, b]) => {
    u[h] = new c(
      h,
      e,
      !1,
      // mustUseProperty
      b,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach((h) => {
    u[h] = new c(
      h,
      t,
      !1,
      // mustUseProperty
      h.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
  ].forEach((h) => {
    u[h] = new c(
      h,
      t,
      !1,
      // mustUseProperty
      h,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
  ].forEach((h) => {
    u[h] = new c(
      h,
      n,
      !1,
      // mustUseProperty
      h.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    u[h] = new c(
      h,
      n,
      !0,
      // mustUseProperty
      h,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "capture",
    "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    u[h] = new c(
      h,
      i,
      !1,
      // mustUseProperty
      h,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "cols",
    "rows",
    "size",
    "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    u[h] = new c(
      h,
      o,
      !1,
      // mustUseProperty
      h,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["rowSpan", "start"].forEach((h) => {
    u[h] = new c(
      h,
      s,
      !1,
      // mustUseProperty
      h.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  });
  const d = /[\-\:]([a-z])/g, p = (h) => h[1].toUpperCase();
  [
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    const b = h.replace(d, p);
    u[b] = new c(
      b,
      e,
      !1,
      // mustUseProperty
      h,
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    const b = h.replace(d, p);
    u[b] = new c(
      b,
      e,
      !1,
      // mustUseProperty
      h,
      "http://www.w3.org/1999/xlink",
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), [
    "xml:base",
    "xml:lang",
    "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach((h) => {
    const b = h.replace(d, p);
    u[b] = new c(
      b,
      e,
      !1,
      // mustUseProperty
      h,
      "http://www.w3.org/XML/1998/namespace",
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  }), ["tabIndex", "crossOrigin"].forEach((h) => {
    u[h] = new c(
      h,
      e,
      !1,
      // mustUseProperty
      h.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
      // removeEmptyString
    );
  });
  const _ = "xlinkHref";
  u[_] = new c(
    "xlinkHref",
    e,
    !1,
    // mustUseProperty
    "xlink:href",
    "http://www.w3.org/1999/xlink",
    !0,
    // sanitizeURL
    !1
    // removeEmptyString
  ), ["src", "href", "action", "formAction"].forEach((h) => {
    u[h] = new c(
      h,
      e,
      !1,
      // mustUseProperty
      h.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0
      // removeEmptyString
    );
  });
  const {
    CAMELCASE: v,
    SAME: m,
    possibleStandardNames: y
  } = wh(), k = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD" + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", E = RegExp.prototype.test.bind(
    // eslint-disable-next-line no-misleading-character-class
    new RegExp("^(data|aria)-[" + k + "]*$")
  ), O = Object.keys(
    y
  ).reduce((h, b) => {
    const w = y[b];
    return w === m ? h[b] = b : w === v ? h[b.toLowerCase()] = b : h[b] = w, h;
  }, {});
  return Tt.BOOLEAN = n, Tt.BOOLEANISH_STRING = t, Tt.NUMERIC = s, Tt.OVERLOADED_BOOLEAN = i, Tt.POSITIVE_NUMERIC = o, Tt.RESERVED = r, Tt.STRING = e, Tt.getPropertyInfo = a, Tt.isCustomAttribute = E, Tt.possibleStandardNames = O, Tt;
}
var $r = {}, dr = {}, As, qa;
function kh() {
  if (qa) return As;
  qa = 1;
  var r = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, e = /\n/g, t = /^\s*/, n = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, a = /^\s+|\s+$/g, c = `
`, u = "/", f = "*", d = "", p = "comment", _ = "declaration";
  function v(y, x) {
    if (typeof y != "string")
      throw new TypeError("First argument must be a string");
    if (!y) return [];
    x = x || {};
    var k = 1, E = 1;
    function O(P) {
      var I = P.match(e);
      I && (k += I.length);
      var X = P.lastIndexOf(c);
      E = ~X ? P.length - X : E + P.length;
    }
    function h() {
      var P = { line: k, column: E };
      return function(I) {
        return I.position = new b(P), N(), I;
      };
    }
    function b(P) {
      this.start = P, this.end = { line: k, column: E }, this.source = x.source;
    }
    b.prototype.content = y;
    function w(P) {
      var I = new Error(
        x.source + ":" + k + ":" + E + ": " + P
      );
      if (I.reason = P, I.filename = x.source, I.line = k, I.column = E, I.source = y, !x.silent) throw I;
    }
    function C(P) {
      var I = P.exec(y);
      if (I) {
        var X = I[0];
        return O(X), y = y.slice(X.length), I;
      }
    }
    function N() {
      C(t);
    }
    function j(P) {
      var I;
      for (P = P || []; I = A(); )
        I !== !1 && P.push(I);
      return P;
    }
    function A() {
      var P = h();
      if (!(u != y.charAt(0) || f != y.charAt(1))) {
        for (var I = 2; d != y.charAt(I) && (f != y.charAt(I) || u != y.charAt(I + 1)); )
          ++I;
        if (I += 2, d === y.charAt(I - 1))
          return w("End of comment missing");
        var X = y.slice(2, I - 2);
        return E += 2, O(X), y = y.slice(I), E += 2, P({
          type: p,
          comment: X
        });
      }
    }
    function B() {
      var P = h(), I = C(n);
      if (I) {
        if (A(), !C(i)) return w("property missing ':'");
        var X = C(s), oe = P({
          type: _,
          property: m(I[0].replace(r, d)),
          value: X ? m(X[0].replace(r, d)) : d
        });
        return C(o), oe;
      }
    }
    function z() {
      var P = [];
      j(P);
      for (var I; I = B(); )
        I !== !1 && (P.push(I), j(P));
      return P;
    }
    return N(), z();
  }
  function m(y) {
    return y ? y.replace(a, d) : d;
  }
  return As = v, As;
}
var $a;
function Eh() {
  if ($a) return dr;
  $a = 1;
  var r = dr && dr.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(dr, "__esModule", { value: !0 }), dr.default = t;
  const e = r(kh());
  function t(n, i) {
    let s = null;
    if (!n || typeof n != "string")
      return s;
    const o = (0, e.default)(n), a = typeof i == "function";
    return o.forEach((c) => {
      if (c.type !== "declaration")
        return;
      const { property: u, value: f } = c;
      a ? i(u, f, c) : f && (s = s || {}, s[u] = f);
    }), s;
  }
  return dr;
}
var Vr = {}, Va;
function Sh() {
  if (Va) return Vr;
  Va = 1, Object.defineProperty(Vr, "__esModule", { value: !0 }), Vr.camelCase = void 0;
  var r = /^--[a-zA-Z0-9_-]+$/, e = /-([a-z])/g, t = /^[^-]+$/, n = /^-(webkit|moz|ms|o|khtml)-/, i = /^-(ms)-/, s = function(u) {
    return !u || t.test(u) || r.test(u);
  }, o = function(u, f) {
    return f.toUpperCase();
  }, a = function(u, f) {
    return "".concat(f, "-");
  }, c = function(u, f) {
    return f === void 0 && (f = {}), s(u) ? u : (u = u.toLowerCase(), f.reactCompat ? u = u.replace(i, a) : u = u.replace(n, a), u.replace(e, o));
  };
  return Vr.camelCase = c, Vr;
}
var Xr, Xa;
function Nh() {
  if (Xa) return Xr;
  Xa = 1;
  var r = Xr && Xr.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  }, e = r(Eh()), t = Sh();
  function n(i, s) {
    var o = {};
    return !i || typeof i != "string" || (0, e.default)(i, function(a, c) {
      a && c && (o[(0, t.camelCase)(a, s)] = c);
    }), o;
  }
  return n.default = n, Xr = n, Xr;
}
var Ka;
function Ac() {
  return Ka || (Ka = 1, (function(r) {
    var e = $r && $r.__importDefault || function(f) {
      return f && f.__esModule ? f : { default: f };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.returnFirstArg = r.canTextBeChildOfNode = r.ELEMENTS_WITH_NO_TEXT_CHILDREN = r.PRESERVE_CUSTOM_ATTRIBUTES = void 0, r.isCustomComponent = s, r.setStyleProp = a;
    var t = F, n = e(Nh()), i = /* @__PURE__ */ new Set([
      "annotation-xml",
      "color-profile",
      "font-face",
      "font-face-src",
      "font-face-uri",
      "font-face-format",
      "font-face-name",
      "missing-glyph"
    ]);
    function s(f, d) {
      return f.includes("-") ? !i.has(f) : !!(d && typeof d.is == "string");
    }
    var o = {
      reactCompat: !0
    };
    function a(f, d) {
      if (typeof f == "string") {
        if (!f.trim()) {
          d.style = {};
          return;
        }
        try {
          d.style = (0, n.default)(f, o);
        } catch {
          d.style = {};
        }
      }
    }
    r.PRESERVE_CUSTOM_ATTRIBUTES = Number(t.version.split(".")[0]) >= 16, r.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
      "tr",
      "tbody",
      "thead",
      "tfoot",
      "colgroup",
      "table",
      "head",
      "html",
      "frameset"
    ]);
    var c = function(f) {
      return !r.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(f.name);
    };
    r.canTextBeChildOfNode = c;
    var u = function(f) {
      return f;
    };
    r.returnFirstArg = u;
  })($r)), $r;
}
var Qa;
function Rc() {
  if (Qa) return Li;
  Qa = 1, Object.defineProperty(Li, "__esModule", { value: !0 }), Li.default = s;
  var r = Th(), e = Ac(), t = ["checked", "value"], n = ["input", "select", "textarea"], i = {
    reset: !0,
    submit: !0
  };
  function s(a, c) {
    a === void 0 && (a = {});
    var u = {}, f = !!(a.type && i[a.type]);
    for (var d in a) {
      var p = a[d];
      if ((0, r.isCustomAttribute)(d)) {
        u[d] = p;
        continue;
      }
      var _ = d.toLowerCase(), v = o(_);
      if (v) {
        var m = (0, r.getPropertyInfo)(v);
        switch (t.includes(v) && n.includes(c) && !f && (v = o("default" + _)), u[v] = p, m?.type) {
          case r.BOOLEAN:
            u[v] = !0;
            break;
          case r.OVERLOADED_BOOLEAN:
            p === "" && (u[v] = !0);
            break;
        }
        continue;
      }
      e.PRESERVE_CUSTOM_ATTRIBUTES && (u[d] = p);
    }
    return (0, e.setStyleProp)(a.style, u), u;
  }
  function o(a) {
    return r.possibleStandardNames[a];
  }
  return Li;
}
var hr = {}, Za;
function Oh() {
  if (Za) return hr;
  Za = 1;
  var r = hr && hr.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  };
  Object.defineProperty(hr, "__esModule", { value: !0 }), hr.default = s;
  var e = F, t = r(Rc()), n = Ac(), i = {
    cloneElement: e.cloneElement,
    createElement: e.createElement,
    isValidElement: e.isValidElement
  };
  function s(a, c) {
    var u, f, d, p, _;
    c === void 0 && (c = {});
    for (var v = [], m = typeof c.replace == "function", y = (u = c.transform) !== null && u !== void 0 ? u : n.returnFirstArg, x = (f = c.library) !== null && f !== void 0 ? f : i, k = x.cloneElement, E = x.createElement, O = x.isValidElement, h = a.length, b = 0; b < h; b++) {
      var w = a[b];
      if (m) {
        var C = (d = c.replace) === null || d === void 0 ? void 0 : d.call(c, w, b);
        if (O(C)) {
          h > 1 && (C = k(C, {
            key: (p = C.key) !== null && p !== void 0 ? p : b
          })), v.push(y(C, w, b));
          continue;
        }
      }
      if (w.type === "text") {
        var N = !w.data.trim().length;
        if (N && w.parent && !(0, n.canTextBeChildOfNode)(w.parent) || c.trim && N)
          continue;
        v.push(y(w.data, w, b));
        continue;
      }
      var j = w, A = {};
      o(j) ? ((0, n.setStyleProp)(j.attribs.style, j.attribs), A = j.attribs) : j.attribs && (A = (0, t.default)(j.attribs, j.name));
      var B = void 0;
      switch (w.type) {
        case "script":
        case "style":
          w.children[0] && (A.dangerouslySetInnerHTML = {
            __html: w.children[0].data
          });
          break;
        case "tag":
          w.name === "textarea" && w.children[0] ? A.defaultValue = w.children[0].data : !((_ = w.children) === null || _ === void 0) && _.length && (B = s(w.children, c));
          break;
        // skip all other cases (e.g., comment)
        default:
          continue;
      }
      h > 1 && (A.key = b), v.push(y(E(w.name, A, B), w, b));
    }
    return v.length === 1 ? v[0] : v;
  }
  function o(a) {
    return n.PRESERVE_CUSTOM_ATTRIBUTES && a.type === "tag" && (0, n.isCustomComponent)(a.name, a.attribs);
  }
  return hr;
}
var Ja;
function Ch() {
  return Ja || (Ja = 1, (function(r) {
    var e = Gr && Gr.__importDefault || function(c) {
      return c && c.__esModule ? c : { default: c };
    };
    Object.defineProperty(r, "__esModule", { value: !0 }), r.htmlToDOM = r.domToReact = r.attributesToProps = r.Text = r.ProcessingInstruction = r.Element = r.Comment = void 0, r.default = a;
    var t = e(xh());
    r.htmlToDOM = t.default;
    var n = e(Rc());
    r.attributesToProps = n.default;
    var i = e(Oh());
    r.domToReact = i.default;
    var s = /* @__PURE__ */ Dc();
    Object.defineProperty(r, "Comment", { enumerable: !0, get: function() {
      return s.Comment;
    } }), Object.defineProperty(r, "Element", { enumerable: !0, get: function() {
      return s.Element;
    } }), Object.defineProperty(r, "ProcessingInstruction", { enumerable: !0, get: function() {
      return s.ProcessingInstruction;
    } }), Object.defineProperty(r, "Text", { enumerable: !0, get: function() {
      return s.Text;
    } });
    var o = { lowerCaseAttributeNames: !1 };
    function a(c, u) {
      var f;
      if (typeof c != "string")
        throw new TypeError("First argument must be a string");
      return c ? (0, i.default)((0, t.default)(c, (f = u?.htmlparser2) !== null && f !== void 0 ? f : o), u) : [];
    }
  })(Gr)), Gr;
}
var jh = Ch();
const el = /* @__PURE__ */ bl(jh), Pc = el.default || el;
function Zg(r) {
  const { content: e, tableConfig: t, paginated: n = !1, minWidth: i = "690px" } = r, s = [10, 25, 50, 100], [o, a] = Pe(1), [c, u] = Pe(10), f = yl(), d = Iu(o, Math.ceil(e.length / c), 5);
  function p(v, m) {
    return Object.keys(v.columns).filter(
      (y) => !(v.columns[y]?.hideIfEmpty === !0 && !m.some((x) => x?.[y] !== null))
    );
  }
  function _(v, m) {
    const y = t.columns[v];
    if (!y) return null;
    if (y?.render)
      return y.render(m);
    const x = m[v];
    if (x === null || x === "" || x === void 0) return "";
    if (y?.data_type === "link") {
      const k = `<a href=${x?.url ?? "#"}>${x?.text ?? ""}</a>`;
      return Pc(Cc.sanitize(k, { ADD_ATTR: ["target"] }));
    }
    return x;
  }
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs("div", { className: "flex-col content-table-container", children: [
    n && /* @__PURE__ */ l.jsx("div", { className: "flex-row full right", children: /* @__PURE__ */ l.jsxs("div", { className: "flex-inline", children: [
      "Rows: ",
      s.map((v, m) => /* @__PURE__ */ l.jsx(
        "button",
        {
          className: ["text-only primary bold", c === v ? "underline" : null].filter(Boolean).join(" "),
          onClick: () => u(v),
          children: v
        },
        m
      ))
    ] }) }),
    /* @__PURE__ */ l.jsxs("table", { className: "full content-table", style: { minWidth: i }, children: [
      /* @__PURE__ */ l.jsx("thead", { children: /* @__PURE__ */ l.jsx("tr", { children: p(t, e).map((v, m) => (
        // Render column styles, if provided. If no mobile styling is set, the
        // desktop styles will be used on mobile also if provided.
        /* @__PURE__ */ l.jsx(
          "th",
          {
            style: f ? t.columns[v]?.headingStyles?.mobile || (t.columns[v]?.headingStyles?.desktop ?? {}) : t.columns[v]?.headingStyles?.desktop ?? {},
            children: t.columns[v].hideLabel ? "" : t.columns[v].label
          },
          v + m + "-header"
        )
      )) }) }),
      /* @__PURE__ */ l.jsx("tbody", { children: (n ? e.slice((o - 1) * c, o * c) : e).map((v, m) => /* @__PURE__ */ l.jsx("tr", { children: p(t, e).map((y, x) => /* @__PURE__ */ l.jsx(
        "td",
        {
          style: f ? t.columns[y]?.dataStyles?.mobile || (t.columns[y]?.dataStyles?.desktop ?? {}) : t.columns[y]?.dataStyles?.desktop ?? {},
          children: _(y, v)
        },
        y + x
      )) }, v?.id || m)) }),
      n && e.length > c && /* @__PURE__ */ l.jsx("tfoot", { className: "pagination", children: /* @__PURE__ */ l.jsx("tr", { children: /* @__PURE__ */ l.jsx("td", { colSpan: Object.keys(t.columns).length, children: /* @__PURE__ */ l.jsx("div", { className: "flex-row full center", children: /* @__PURE__ */ l.jsx("div", { className: "flex-inline middle pagination-wrapper", children: d.map(
        (v, m) => typeof v == "number" ? /* @__PURE__ */ l.jsx(
          "button",
          {
            className: ["icon-only primary pagination-button", o === v ? "selected" : null].filter(Boolean).join(" "),
            onClick: () => a(v),
            children: v
          },
          m
        ) : /* @__PURE__ */ l.jsx("span", { children: "…" }, m)
      ) }) }) }) }) })
    ] })
  ] }) });
}
function Jg() {
  return /* @__PURE__ */ l.jsx("div", { className: "block flex-row content-table-filters", children: "filters go here!!!" });
}
function e_() {
  const [r] = sr();
  return /* @__PURE__ */ l.jsx("header", { className: "header-navigation", children: /* @__PURE__ */ l.jsx("nav", { className: "primary", children: /* @__PURE__ */ l.jsx("div", { className: "nav-wrapper", children: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Ve, { to: "/", children: /* @__PURE__ */ l.jsx(gi, { type: r }) }) }) }) }) });
}
function t_() {
  const [r, e] = Lu("dismissed_alerts", []), { dealerAccessApiScope: t, dealerAccessApiHost: n } = is(), { data: i, loading: s, error: o } = so(), a = ns({ scopes: [t] }), { data: c, isLoading: u } = ir({
    enabled: !!a,
    queryKey: ["dealerAccessApiToken"],
    queryFn: () => a()
  }), f = rs(c?.accessTokenClaims), { error: d, data: p } = ir({
    enabled: !!a,
    queryKey: ["alerts"],
    queryFn: () => a().then((m) => Uu(n, m.accessToken)).then((m) => m.json())
  }), [_, v] = Fu("showDealerSwitch", !1);
  return cn(() => v(!1), []), d && console.error(d), o && console.error(o), /* @__PURE__ */ l.jsx("header", { className: "page-header", children: /* @__PURE__ */ l.jsxs("section", { className: "header-navigation", children: [
    /* @__PURE__ */ l.jsx(Cd, { user: f, dealerInfo: i, loading: s || u }),
    /* @__PURE__ */ l.jsx(jd, { user: f, dealerInfo: i }),
    /* @__PURE__ */ l.jsx("div", { className: "alerts-container", children: p && p?.data?.length > 0 && p?.data.map(
      (m) => r.includes(m.id) ? null : /* @__PURE__ */ l.jsx(
        Tc,
        {
          id: m.id,
          dismissedAlerts: r,
          setDismissedAlerts: e,
          className: "flex-row center middle",
          children: /* @__PURE__ */ l.jsxs("div", { className: "flex-row middle", children: [
            /* @__PURE__ */ l.jsx(G, { glyph: "exclamation-circle", className: "xl" }),
            Pc(Cc.sanitize(m.body?.value))
          ] })
        },
        m.id
      )
    ) }),
    /* @__PURE__ */ l.jsx(
      Rd,
      {
        show: _,
        setShow: v,
        dealerInfo: i
      }
    )
  ] }) });
}
function Dh(r, e, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: r,
    timeZoneName: t
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const Mh = {}, ti = {};
function nn(r, e) {
  try {
    const n = (Mh[r] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: r,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return n in ti ? ti[n] : tl(n, n.split(":"));
  } catch {
    if (r in ti) return ti[r];
    const t = r?.match(Ah);
    return t ? tl(r, t.slice(1)) : NaN;
  }
}
const Ah = /([+-]\d\d):?(\d\d)?/;
function tl(r, e) {
  const t = +(e[0] || 0), n = +(e[1] || 0), i = +(e[2] || 0) / 60;
  return ti[r] = t * 60 + n > 0 ? t * 60 + n + i : t * 60 - n - i;
}
class Gt extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(nn(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Ic(this, e)) : this.setTime(Date.now());
  }
  static tz(e, ...t) {
    return t.length ? new Gt(...t, e) : new Gt(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new Gt(+this, e);
  }
  getTimezoneOffset() {
    const e = -nn(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), es(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new Gt(+new Date(e), this.timeZone);
  }
  //#endregion
}
const nl = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((r) => {
  if (!nl.test(r)) return;
  const e = r.replace(nl, "$1UTC");
  Gt.prototype[e] && (r.startsWith("get") ? Gt.prototype[r] = function() {
    return this.internal[e]();
  } : (Gt.prototype[r] = function() {
    return Date.prototype[e].apply(this.internal, arguments), Rh(this), +this;
  }, Gt.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), es(this), +this;
  }));
});
function es(r) {
  r.internal.setTime(+r), r.internal.setUTCSeconds(r.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-nn(r.timeZone, r) * 60));
}
function Rh(r) {
  Date.prototype.setFullYear.call(r, r.internal.getUTCFullYear(), r.internal.getUTCMonth(), r.internal.getUTCDate()), Date.prototype.setHours.call(r, r.internal.getUTCHours(), r.internal.getUTCMinutes(), r.internal.getUTCSeconds(), r.internal.getUTCMilliseconds()), Ic(r);
}
function Ic(r, e) {
  const t = Array.isArray(e) ? Ph(e) : +r.internal, n = nn(r.timeZone, r), i = n > 0 ? Math.floor(n) : Math.ceil(n), s = /* @__PURE__ */ new Date(+r);
  s.setUTCHours(s.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+s)).getTimezoneOffset(), c = o - a;
  let u = o;
  if (c && o !== i) {
    const N = Date.prototype.getHours.apply(r), j = Array.isArray(e) ? e[3] || 0 : r.internal.getUTCHours();
    if (N !== j) {
      const A = /* @__PURE__ */ new Date(+r), B = o - i;
      B && A.setUTCMinutes(A.getUTCMinutes() + B);
      const z = nn(r.timeZone, A);
      (z > 0 ? Math.floor(z) : Math.ceil(z)) === i && (u = a);
    }
  }
  const f = u - i;
  f && Date.prototype.setUTCMinutes.call(r, Date.prototype.getUTCMinutes.call(r) + f);
  const d = /* @__PURE__ */ new Date(+r);
  d.setUTCSeconds(0);
  const p = o > 0 ? d.getSeconds() : (d.getSeconds() - 60) % 60, _ = Math.round(-(nn(r.timeZone, r) * 60)) % 60;
  (_ || p) && Date.prototype.setUTCSeconds.call(r, Date.prototype.getUTCSeconds.call(r) + _ + p);
  const v = nn(r.timeZone, r), m = v > 0 ? Math.floor(v) : Math.ceil(v), x = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset() - m, k = m !== i, E = x - f, O = m - i, h = t - m * 60 * 1e3, b = O > 0 && rl(r) - t === O * 60 * 1e3 && rl(r, h) !== t;
  if (k && E && !b) {
    Date.prototype.setUTCMinutes.call(r, Date.prototype.getUTCMinutes.call(r) + E);
    const N = nn(r.timeZone, r), j = N > 0 ? Math.floor(N) : Math.ceil(N), A = m - j;
    A && E < 0 && Date.prototype.setUTCMinutes.call(r, Date.prototype.getUTCMinutes.call(r) + A);
  }
  es(r);
  const C = (e ? t : t + _ * 1e3) - +r.internal;
  C && Math.abs(C) < 1800 * 1e3 && (Date.prototype.setTime.call(r, +r + C), es(r));
}
function Ph(r) {
  return Date.UTC(r[0], r.length > 1 ? r[1] : 0, r.length > 2 ? r[2] : 1, ...r.slice(3));
}
function rl(r, e) {
  const t = new Date(e ?? +r);
  return t.setUTCSeconds(t.getUTCSeconds() - Math.round(-nn(r.timeZone, t) * 60)), +t;
}
class $e extends Gt {
  //#region static
  static tz(e, ...t) {
    return t.length ? new $e(...t, e) : new $e(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, t, n] = this.tzComponents(), i = `${e}${t}:${n}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, t, n, i] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${n} ${t} ${i}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [t, n, i] = this.tzComponents();
    return `${e} GMT${t}${n}${i} (${Dh(this.timeZone, this)})`;
  }
  toLocaleString(e, t) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, t) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, t) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), t = e > 0 ? "-" : "+", n = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), i = String(Math.abs(e) % 60).padStart(2, "0");
    return [t, n, i];
  }
  //#endregion
  withTimeZone(e) {
    return new $e(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new $e(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Lc = 6048e5, Ih = 864e5, il = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Ae(r, e) {
  return typeof r == "function" ? r(e) : r && typeof r == "object" && il in r ? r[il](e) : r instanceof Date ? new r.constructor(e) : new Date(e);
}
function de(r, e) {
  return Ae(e || r, r);
}
function Fc(r, e, t) {
  const n = de(r, t?.in);
  return isNaN(e) ? Ae(r, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function Wc(r, e, t) {
  const n = de(r, t?.in);
  if (isNaN(e)) return Ae(r, NaN);
  if (!e)
    return n;
  const i = n.getDate(), s = Ae(r, n.getTime());
  s.setMonth(n.getMonth() + e + 1, 0);
  const o = s.getDate();
  return i >= o ? s : (n.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    i
  ), n);
}
let Lh = {};
function vi() {
  return Lh;
}
function jr(r, e) {
  const t = vi(), n = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, i = de(r, e?.in), s = i.getDay(), o = (s < n ? 7 : 0) + s - n;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function _i(r, e) {
  return jr(r, { ...e, weekStartsOn: 1 });
}
function Yc(r, e) {
  const t = de(r, e?.in), n = t.getFullYear(), i = Ae(t, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const s = _i(i), o = Ae(t, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const a = _i(o);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function sl(r) {
  const e = de(r), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +r - +t;
}
function Mr(r, ...e) {
  const t = Ae.bind(
    null,
    e.find((n) => typeof n == "object")
  );
  return e.map(t);
}
function yi(r, e) {
  const t = de(r, e?.in);
  return t.setHours(0, 0, 0, 0), t;
}
function No(r, e, t) {
  const [n, i] = Mr(
    t?.in,
    r,
    e
  ), s = yi(n), o = yi(i), a = +s - sl(s), c = +o - sl(o);
  return Math.round((a - c) / Ih);
}
function Fh(r, e) {
  const t = Yc(r, e), n = Ae(r, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), _i(n);
}
function Wh(r, e, t) {
  return Fc(r, e * 7, t);
}
function Yh(r, e, t) {
  return Wc(r, e * 12, t);
}
function Bh(r, e) {
  let t, n = e?.in;
  return r.forEach((i) => {
    !n && typeof i == "object" && (n = Ae.bind(null, i));
    const s = de(i, n);
    (!t || t < s || isNaN(+s)) && (t = s);
  }), Ae(n, t || NaN);
}
function zh(r, e) {
  let t, n = e?.in;
  return r.forEach((i) => {
    !n && typeof i == "object" && (n = Ae.bind(null, i));
    const s = de(i, n);
    (!t || t > s || isNaN(+s)) && (t = s);
  }), Ae(n, t || NaN);
}
function Uh(r, e, t) {
  const [n, i] = Mr(
    t?.in,
    r,
    e
  );
  return +yi(n) == +yi(i);
}
function Bc(r) {
  return r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function Hh(r) {
  return !(!Bc(r) && typeof r != "number" || isNaN(+de(r)));
}
function zc(r, e, t) {
  const [n, i] = Mr(
    t?.in,
    r,
    e
  ), s = n.getFullYear() - i.getFullYear(), o = n.getMonth() - i.getMonth();
  return s * 12 + o;
}
function Gh(r, e) {
  const t = de(r, e?.in), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Uc(r, e) {
  const [t, n] = Mr(r, e.start, e.end);
  return { start: t, end: n };
}
function qh(r, e) {
  const { start: t, end: n } = Uc(e?.in, r);
  let i = +t > +n;
  const s = i ? +t : +n, o = i ? n : t;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let a = 1;
  const c = [];
  for (; +o <= s; )
    c.push(Ae(t, o)), o.setMonth(o.getMonth() + a);
  return i ? c.reverse() : c;
}
function $h(r, e) {
  const t = de(r, e?.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Vh(r, e) {
  const t = de(r, e?.in), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Hc(r, e) {
  const t = de(r, e?.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Xh(r, e) {
  const { start: t, end: n } = Uc(e?.in, r);
  let i = +t > +n;
  const s = i ? +t : +n, o = i ? n : t;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let a = 1;
  const c = [];
  for (; +o <= s; )
    c.push(Ae(t, o)), o.setFullYear(o.getFullYear() + a);
  return i ? c.reverse() : c;
}
function Gc(r, e) {
  const t = vi(), n = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, i = de(r, e?.in), s = i.getDay(), o = (s < n ? -7 : 0) + 6 - (s - n);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
function Kh(r, e) {
  return Gc(r, { ...e, weekStartsOn: 1 });
}
const Qh = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Zh = (r, e, t) => {
  let n;
  const i = Qh[r];
  return typeof i == "string" ? n = i : e === 1 ? n = i.one : n = i.other.replace("{{count}}", e.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Rs(r) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : r.defaultWidth;
    return r.formats[t] || r.formats[r.defaultWidth];
  };
}
const Jh = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, em = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, tm = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nm = {
  date: Rs({
    formats: Jh,
    defaultWidth: "full"
  }),
  time: Rs({
    formats: em,
    defaultWidth: "full"
  }),
  dateTime: Rs({
    formats: tm,
    defaultWidth: "full"
  })
}, rm = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, im = (r, e, t, n) => rm[r];
function Kr(r) {
  return (e, t) => {
    const n = t?.context ? String(t.context) : "standalone";
    let i;
    if (n === "formatting" && r.formattingValues) {
      const o = r.defaultFormattingWidth || r.defaultWidth, a = t?.width ? String(t.width) : o;
      i = r.formattingValues[a] || r.formattingValues[o];
    } else {
      const o = r.defaultWidth, a = t?.width ? String(t.width) : r.defaultWidth;
      i = r.values[a] || r.values[o];
    }
    const s = r.argumentCallback ? r.argumentCallback(e) : e;
    return i[s];
  };
}
const sm = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, om = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, am = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, lm = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, cm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, um = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, fm = (r, e) => {
  const t = Number(r), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, dm = {
  ordinalNumber: fm,
  era: Kr({
    values: sm,
    defaultWidth: "wide"
  }),
  quarter: Kr({
    values: om,
    defaultWidth: "wide",
    argumentCallback: (r) => r - 1
  }),
  month: Kr({
    values: am,
    defaultWidth: "wide"
  }),
  day: Kr({
    values: lm,
    defaultWidth: "wide"
  }),
  dayPeriod: Kr({
    values: cm,
    defaultWidth: "wide",
    formattingValues: um,
    defaultFormattingWidth: "wide"
  })
};
function Qr(r) {
  return (e, t = {}) => {
    const n = t.width, i = n && r.matchPatterns[n] || r.matchPatterns[r.defaultMatchWidth], s = e.match(i);
    if (!s)
      return null;
    const o = s[0], a = n && r.parsePatterns[n] || r.parsePatterns[r.defaultParseWidth], c = Array.isArray(a) ? mm(a, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      hm(a, (d) => d.test(o))
    );
    let u;
    u = r.valueCallback ? r.valueCallback(c) : c, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const f = e.slice(o.length);
    return { value: u, rest: f };
  };
}
function hm(r, e) {
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t) && e(r[t]))
      return t;
}
function mm(r, e) {
  for (let t = 0; t < r.length; t++)
    if (e(r[t]))
      return t;
}
function pm(r) {
  return (e, t = {}) => {
    const n = e.match(r.matchPattern);
    if (!n) return null;
    const i = n[0], s = e.match(r.parsePattern);
    if (!s) return null;
    let o = r.valueCallback ? r.valueCallback(s[0]) : s[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const a = e.slice(i.length);
    return { value: o, rest: a };
  };
}
const gm = /^(\d+)(th|st|nd|rd)?/i, _m = /\d+/i, ym = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bm = {
  any: [/^b/i, /^(a|c)/i]
}, vm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, xm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Tm = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, km = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Em = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Sm = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Nm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Om = {
  ordinalNumber: pm({
    matchPattern: gm,
    parsePattern: _m,
    valueCallback: (r) => parseInt(r, 10)
  }),
  era: Qr({
    matchPatterns: ym,
    defaultMatchWidth: "wide",
    parsePatterns: bm,
    defaultParseWidth: "any"
  }),
  quarter: Qr({
    matchPatterns: vm,
    defaultMatchWidth: "wide",
    parsePatterns: xm,
    defaultParseWidth: "any",
    valueCallback: (r) => r + 1
  }),
  month: Qr({
    matchPatterns: wm,
    defaultMatchWidth: "wide",
    parsePatterns: Tm,
    defaultParseWidth: "any"
  }),
  day: Qr({
    matchPatterns: km,
    defaultMatchWidth: "wide",
    parsePatterns: Em,
    defaultParseWidth: "any"
  }),
  dayPeriod: Qr({
    matchPatterns: Sm,
    defaultMatchWidth: "any",
    parsePatterns: Nm,
    defaultParseWidth: "any"
  })
}, _r = {
  code: "en-US",
  formatDistance: Zh,
  formatLong: nm,
  formatRelative: im,
  localize: dm,
  match: Om,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Cm(r, e) {
  const t = de(r, e?.in);
  return No(t, Hc(t)) + 1;
}
function Oo(r, e) {
  const t = de(r, e?.in), n = +_i(t) - +Fh(t);
  return Math.round(n / Lc) + 1;
}
function qc(r, e) {
  const t = de(r, e?.in), n = t.getFullYear(), i = vi(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = Ae(e?.in || r, 0);
  o.setFullYear(n + 1, 0, s), o.setHours(0, 0, 0, 0);
  const a = jr(o, e), c = Ae(e?.in || r, 0);
  c.setFullYear(n, 0, s), c.setHours(0, 0, 0, 0);
  const u = jr(c, e);
  return +t >= +a ? n + 1 : +t >= +u ? n : n - 1;
}
function jm(r, e) {
  const t = vi(), n = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, i = qc(r, e), s = Ae(e?.in || r, 0);
  return s.setFullYear(i, 0, n), s.setHours(0, 0, 0, 0), jr(s, e);
}
function Co(r, e) {
  const t = de(r, e?.in), n = +jr(t, e) - +jm(t, e);
  return Math.round(n / Lc) + 1;
}
function fe(r, e) {
  const t = r < 0 ? "-" : "", n = Math.abs(r).toString().padStart(e, "0");
  return t + n;
}
const kn = {
  // Year
  y(r, e) {
    const t = r.getFullYear(), n = t > 0 ? t : 1 - t;
    return fe(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(r, e) {
    const t = r.getMonth();
    return e === "M" ? String(t + 1) : fe(t + 1, 2);
  },
  // Day of the month
  d(r, e) {
    return fe(r.getDate(), e.length);
  },
  // AM or PM
  a(r, e) {
    const t = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(r, e) {
    return fe(r.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(r, e) {
    return fe(r.getHours(), e.length);
  },
  // Minute
  m(r, e) {
    return fe(r.getMinutes(), e.length);
  },
  // Second
  s(r, e) {
    return fe(r.getSeconds(), e.length);
  },
  // Fraction of second
  S(r, e) {
    const t = e.length, n = r.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return fe(i, e.length);
  }
}, mr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ol = {
  // Era
  G: function(r, e, t) {
    const n = r.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(r, e, t) {
    if (e === "yo") {
      const n = r.getFullYear(), i = n > 0 ? n : 1 - n;
      return t.ordinalNumber(i, { unit: "year" });
    }
    return kn.y(r, e);
  },
  // Local week-numbering year
  Y: function(r, e, t, n) {
    const i = qc(r, n), s = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const o = s % 100;
      return fe(o, 2);
    }
    return e === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : fe(s, e.length);
  },
  // ISO week-numbering year
  R: function(r, e) {
    const t = Yc(r);
    return fe(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, e) {
    const t = r.getFullYear();
    return fe(t, e.length);
  },
  // Quarter
  Q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return fe(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return fe(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return kn.M(r, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return fe(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(r, e, t, n) {
    const i = Co(r, n);
    return e === "wo" ? t.ordinalNumber(i, { unit: "week" }) : fe(i, e.length);
  },
  // ISO week of year
  I: function(r, e, t) {
    const n = Oo(r);
    return e === "Io" ? t.ordinalNumber(n, { unit: "week" }) : fe(n, e.length);
  },
  // Day of the month
  d: function(r, e, t) {
    return e === "do" ? t.ordinalNumber(r.getDate(), { unit: "date" }) : kn.d(r, e);
  },
  // Day of year
  D: function(r, e, t) {
    const n = Cm(r);
    return e === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : fe(n, e.length);
  },
  // Day of week
  E: function(r, e, t) {
    const n = r.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, e, t, n) {
    const i = r.getDay(), s = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return fe(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, e, t, n) {
    const i = r.getDay(), s = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return fe(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, e, t) {
    const n = r.getDay(), i = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return fe(i, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, e, t) {
    const i = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, e, t) {
    const n = r.getHours();
    let i;
    switch (n === 12 ? i = mr.noon : n === 0 ? i = mr.midnight : i = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, e, t) {
    const n = r.getHours();
    let i;
    switch (n >= 17 ? i = mr.evening : n >= 12 ? i = mr.afternoon : n >= 4 ? i = mr.morning : i = mr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, e, t) {
    if (e === "ho") {
      let n = r.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return kn.h(r, e);
  },
  // Hour [0-23]
  H: function(r, e, t) {
    return e === "Ho" ? t.ordinalNumber(r.getHours(), { unit: "hour" }) : kn.H(r, e);
  },
  // Hour [0-11]
  K: function(r, e, t) {
    const n = r.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : fe(n, e.length);
  },
  // Hour [1-24]
  k: function(r, e, t) {
    let n = r.getHours();
    return n === 0 && (n = 24), e === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : fe(n, e.length);
  },
  // Minute
  m: function(r, e, t) {
    return e === "mo" ? t.ordinalNumber(r.getMinutes(), { unit: "minute" }) : kn.m(r, e);
  },
  // Second
  s: function(r, e, t) {
    return e === "so" ? t.ordinalNumber(r.getSeconds(), { unit: "second" }) : kn.s(r, e);
  },
  // Fraction of second
  S: function(r, e) {
    return kn.S(r, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, e, t) {
    const n = r.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return ll(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Qn(n);
      // Hours and minutes with `:` delimiter
      default:
        return Qn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return ll(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Qn(n);
      // Hours and minutes with `:` delimiter
      default:
        return Qn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + al(n, ":");
      default:
        return "GMT" + Qn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + al(n, ":");
      default:
        return "GMT" + Qn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(r, e, t) {
    const n = Math.trunc(+r / 1e3);
    return fe(n, e.length);
  },
  // Milliseconds timestamp
  T: function(r, e, t) {
    return fe(+r, e.length);
  }
};
function al(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), i = Math.trunc(n / 60), s = n % 60;
  return s === 0 ? t + String(i) : t + String(i) + e + fe(s, 2);
}
function ll(r, e) {
  return r % 60 === 0 ? (r > 0 ? "-" : "+") + fe(Math.abs(r) / 60, 2) : Qn(r, e);
}
function Qn(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), i = fe(Math.trunc(n / 60), 2), s = fe(n % 60, 2);
  return t + i + e + s;
}
const cl = (r, e) => {
  switch (r) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, $c = (r, e) => {
  switch (r) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, Dm = (r, e) => {
  const t = r.match(/(P+)(p+)?/) || [], n = t[1], i = t[2];
  if (!i)
    return cl(r, e);
  let s;
  switch (n) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", cl(n, e)).replace("{{time}}", $c(i, e));
}, Mm = {
  p: $c,
  P: Dm
}, Am = /^D+$/, Rm = /^Y+$/, Pm = ["D", "DD", "YY", "YYYY"];
function Im(r) {
  return Am.test(r);
}
function Lm(r) {
  return Rm.test(r);
}
function Fm(r, e, t) {
  const n = Wm(r, e, t);
  if (console.warn(n), Pm.includes(r)) throw new RangeError(n);
}
function Wm(r, e, t) {
  const n = r[0] === "Y" ? "years" : "days of the month";
  return `Use \`${r.toLowerCase()}\` instead of \`${r}\` (in \`${e}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ym = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Bm = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, zm = /^'([^]*?)'?$/, Um = /''/g, Hm = /[a-zA-Z]/;
function ni(r, e, t) {
  const n = vi(), i = t?.locale ?? n.locale ?? _r, s = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, a = de(r, t?.in);
  if (!Hh(a))
    throw new RangeError("Invalid time value");
  let c = e.match(Bm).map((f) => {
    const d = f[0];
    if (d === "p" || d === "P") {
      const p = Mm[d];
      return p(f, i.formatLong);
    }
    return f;
  }).join("").match(Ym).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const d = f[0];
    if (d === "'")
      return { isToken: !1, value: Gm(f) };
    if (ol[d])
      return { isToken: !0, value: f };
    if (d.match(Hm))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: f };
  });
  i.localize.preprocessor && (c = i.localize.preprocessor(a, c));
  const u = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: i
  };
  return c.map((f) => {
    if (!f.isToken) return f.value;
    const d = f.value;
    (!t?.useAdditionalWeekYearTokens && Lm(d) || !t?.useAdditionalDayOfYearTokens && Im(d)) && Fm(d, e, String(r));
    const p = ol[d[0]];
    return p(a, d, i.localize, u);
  }).join("");
}
function Gm(r) {
  const e = r.match(zm);
  return e ? e[1].replace(Um, "'") : r;
}
function qm(r, e) {
  const t = de(r, e?.in), n = t.getFullYear(), i = t.getMonth(), s = Ae(t, 0);
  return s.setFullYear(n, i + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function $m(r, e) {
  return de(r, e?.in).getMonth();
}
function Vm(r, e) {
  return de(r, e?.in).getFullYear();
}
function Xm(r, e) {
  return +de(r) > +de(e);
}
function Km(r, e) {
  return +de(r) < +de(e);
}
function Qm(r, e, t) {
  const [n, i] = Mr(
    t?.in,
    r,
    e
  );
  return n.getFullYear() === i.getFullYear() && n.getMonth() === i.getMonth();
}
function Zm(r, e, t) {
  const [n, i] = Mr(
    t?.in,
    r,
    e
  );
  return n.getFullYear() === i.getFullYear();
}
function Jm(r, e, t) {
  const n = de(r, t?.in), i = n.getFullYear(), s = n.getDate(), o = Ae(r, 0);
  o.setFullYear(i, e, 15), o.setHours(0, 0, 0, 0);
  const a = qm(o);
  return n.setMonth(e, Math.min(s, a)), n;
}
function ep(r, e, t) {
  const n = de(r, t?.in);
  return isNaN(+n) ? Ae(r, NaN) : (n.setFullYear(e), n);
}
const ul = 5, tp = 4;
function np(r, e) {
  const t = e.startOfMonth(r), n = t.getDay() > 0 ? t.getDay() : 7, i = e.addDays(r, -n + 1), s = e.addDays(i, ul * 7 - 1);
  return e.getMonth(r) === e.getMonth(s) ? ul : tp;
}
function Vc(r, e) {
  const t = e.startOfMonth(r), n = t.getDay();
  return n === 1 ? t : n === 0 ? e.addDays(t, -6) : e.addDays(t, -1 * (n - 1));
}
function rp(r, e) {
  const t = Vc(r, e), n = np(r, e);
  return e.addDays(t, n * 7 - 1);
}
const Xc = {
  ..._r,
  labels: {
    labelDayButton: (r, e, t, n) => {
      let i;
      n && typeof n.format == "function" ? i = n.format.bind(n) : i = (o, a) => ni(o, a, { locale: _r, ...t });
      let s = i(r, "PPPP");
      return e.today && (s = `Today, ${s}`), e.selected && (s = `${s}, selected`), s;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (r) => `Week ${r}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (r, e, t) => {
      let n;
      return t && typeof t.format == "function" ? n = t.format.bind(t) : n = (i, s) => ni(i, s, { locale: _r, ...e }), n(r, "LLLL yyyy");
    },
    labelGridcell: (r, e, t, n) => {
      let i;
      n && typeof n.format == "function" ? i = n.format.bind(n) : i = (o, a) => ni(o, a, { locale: _r, ...t });
      let s = i(r, "PPPP");
      return e?.today && (s = `Today, ${s}`), s;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (r, e, t) => {
      let n;
      return t && typeof t.format == "function" ? n = t.format.bind(t) : n = (i, s) => ni(i, s, { locale: _r, ...e }), n(r, "cccc");
    }
  }
};
class xt {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, t) {
    this.today = () => {
      if (this.overrides?.today)
        return this.overrides.today();
      if (this.options.timeZone)
        return $e.tz(this.options.timeZone);
      const n = this.options.Date ?? Date;
      return new n();
    }, this.newDate = (n, i, s) => this.overrides?.newDate ? this.overrides.newDate(n, i, s) : this.options.timeZone ? new $e(n, i, s, this.options.timeZone) : new Date(n, i, s), this.addDays = (n, i) => this.overrides?.addDays ? this.overrides.addDays(n, i) : Fc(n, i), this.addMonths = (n, i) => this.overrides?.addMonths ? this.overrides.addMonths(n, i) : Wc(n, i), this.addWeeks = (n, i) => this.overrides?.addWeeks ? this.overrides.addWeeks(n, i) : Wh(n, i), this.addYears = (n, i) => this.overrides?.addYears ? this.overrides.addYears(n, i) : Yh(n, i), this.differenceInCalendarDays = (n, i) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(n, i) : No(n, i), this.differenceInCalendarMonths = (n, i) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(n, i) : zc(n, i), this.eachMonthOfInterval = (n) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(n) : qh(n), this.eachYearOfInterval = (n) => {
      const i = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(n) : Xh(n), s = new Set(i.map((a) => this.getYear(a)));
      if (s.size === i.length)
        return i;
      const o = [];
      return s.forEach((a) => {
        o.push(new Date(a, 0, 1));
      }), o;
    }, this.endOfBroadcastWeek = (n) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(n) : rp(n, this), this.endOfISOWeek = (n) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(n) : Kh(n), this.endOfMonth = (n) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(n) : Gh(n), this.endOfWeek = (n, i) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(n, i) : Gc(n, this.options), this.endOfYear = (n) => this.overrides?.endOfYear ? this.overrides.endOfYear(n) : Vh(n), this.format = (n, i, s) => {
      const o = this.overrides?.format ? this.overrides.format(n, i, this.options) : ni(n, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(o) : o;
    }, this.getISOWeek = (n) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(n) : Oo(n), this.getMonth = (n, i) => this.overrides?.getMonth ? this.overrides.getMonth(n, this.options) : $m(n, this.options), this.getYear = (n, i) => this.overrides?.getYear ? this.overrides.getYear(n, this.options) : Vm(n, this.options), this.getWeek = (n, i) => this.overrides?.getWeek ? this.overrides.getWeek(n, this.options) : Co(n, this.options), this.isAfter = (n, i) => this.overrides?.isAfter ? this.overrides.isAfter(n, i) : Xm(n, i), this.isBefore = (n, i) => this.overrides?.isBefore ? this.overrides.isBefore(n, i) : Km(n, i), this.isDate = (n) => this.overrides?.isDate ? this.overrides.isDate(n) : Bc(n), this.isSameDay = (n, i) => this.overrides?.isSameDay ? this.overrides.isSameDay(n, i) : Uh(n, i), this.isSameMonth = (n, i) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(n, i) : Qm(n, i), this.isSameYear = (n, i) => this.overrides?.isSameYear ? this.overrides.isSameYear(n, i) : Zm(n, i), this.max = (n) => this.overrides?.max ? this.overrides.max(n) : Bh(n), this.min = (n) => this.overrides?.min ? this.overrides.min(n) : zh(n), this.setMonth = (n, i) => this.overrides?.setMonth ? this.overrides.setMonth(n, i) : Jm(n, i), this.setYear = (n, i) => this.overrides?.setYear ? this.overrides.setYear(n, i) : ep(n, i), this.startOfBroadcastWeek = (n, i) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(n, this) : Vc(n, this), this.startOfDay = (n) => this.overrides?.startOfDay ? this.overrides.startOfDay(n) : yi(n), this.startOfISOWeek = (n) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(n) : _i(n), this.startOfMonth = (n) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(n) : $h(n), this.startOfWeek = (n, i) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(n, this.options) : jr(n, this.options), this.startOfYear = (n) => this.overrides?.startOfYear ? this.overrides.startOfYear(n) : Hc(n), this.options = { locale: Xc, ...e }, this.overrides = t;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, t = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), n = {};
    for (let i = 0; i < 10; i++)
      n[i.toString()] = t.format(i);
    return n;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const t = this.getDigitMap();
    return e.replace(/\d/g, (n) => t[n] || n);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && xt.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: t, timeZone: n, numerals: i } = this.options, s = t?.code;
    if (s && xt.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: n,
          numberingSystem: i
        }).format(e);
      } catch {
      }
    const o = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, o);
  }
}
xt.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const $t = new xt();
class Kc {
  constructor(e, t, n = $t) {
    this.date = e, this.displayMonth = t, this.outside = !!(t && !n.isSameMonth(e, t)), this.dateLib = n, this.isoDate = n.format(e, "yyyy-MM-dd"), this.displayMonthId = n.format(t, "yyyy-MM"), this.dateMonthId = n.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class ip {
  constructor(e, t) {
    this.date = e, this.weeks = t;
  }
}
class sp {
  constructor(e, t) {
    this.days = t, this.weekNumber = e;
  }
}
function op(r) {
  return F.createElement("span", { ...r });
}
function ap(r) {
  const { size: e = 24, orientation: t = "left", className: n, style: i } = r;
  return F.createElement(
    "svg",
    { className: n, style: i, width: e, height: e, viewBox: "0 0 24 24" },
    t === "up" && F.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    t === "down" && F.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    t === "left" && F.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    t === "right" && F.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function lp(r) {
  const { day: e, modifiers: t, ...n } = r;
  return F.createElement("td", { ...n });
}
function cp(r) {
  const { day: e, modifiers: t, ...n } = r, i = F.useRef(null);
  return F.useEffect(() => {
    t.focused && i.current?.focus();
  }, [t.focused]), F.createElement("button", { ref: i, ...n });
}
var Y;
(function(r) {
  r.Root = "root", r.Chevron = "chevron", r.Day = "day", r.DayButton = "day_button", r.CaptionLabel = "caption_label", r.Dropdowns = "dropdowns", r.Dropdown = "dropdown", r.DropdownRoot = "dropdown_root", r.Footer = "footer", r.MonthGrid = "month_grid", r.MonthCaption = "month_caption", r.MonthsDropdown = "months_dropdown", r.Month = "month", r.Months = "months", r.Nav = "nav", r.NextMonthButton = "button_next", r.PreviousMonthButton = "button_previous", r.Week = "week", r.Weeks = "weeks", r.Weekday = "weekday", r.Weekdays = "weekdays", r.WeekNumber = "week_number", r.WeekNumberHeader = "week_number_header", r.YearsDropdown = "years_dropdown";
})(Y || (Y = {}));
var we;
(function(r) {
  r.disabled = "disabled", r.hidden = "hidden", r.outside = "outside", r.focused = "focused", r.today = "today";
})(we || (we = {}));
var Pt;
(function(r) {
  r.range_end = "range_end", r.range_middle = "range_middle", r.range_start = "range_start", r.selected = "selected";
})(Pt || (Pt = {}));
var dt;
(function(r) {
  r.weeks_before_enter = "weeks_before_enter", r.weeks_before_exit = "weeks_before_exit", r.weeks_after_enter = "weeks_after_enter", r.weeks_after_exit = "weeks_after_exit", r.caption_after_enter = "caption_after_enter", r.caption_after_exit = "caption_after_exit", r.caption_before_enter = "caption_before_enter", r.caption_before_exit = "caption_before_exit";
})(dt || (dt = {}));
const Qc = wu(void 0);
function ls() {
  const r = Tu(Qc);
  if (r === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return r;
}
function up(r) {
  const { options: e, className: t, ...n } = r, { classNames: i, components: s, styles: o } = ls(), a = [i[Y.Dropdown], t].join(" "), c = e?.find(({ value: u }) => u === n.value);
  return F.createElement(
    "span",
    { "data-disabled": n.disabled, className: i[Y.DropdownRoot], style: o?.[Y.DropdownRoot] },
    F.createElement(s.Select, { className: a, ...n }, e?.map(({ value: u, label: f, disabled: d }) => F.createElement(s.Option, { key: u, value: u, disabled: d }, f))),
    F.createElement(
      "span",
      { className: i[Y.CaptionLabel], style: o?.[Y.CaptionLabel], "aria-hidden": !0 },
      c?.label,
      F.createElement(s.Chevron, { orientation: "down", size: 18, className: i[Y.Chevron], style: o?.[Y.Chevron] })
    )
  );
}
function fp(r) {
  return F.createElement("div", { ...r });
}
function dp(r) {
  return F.createElement("div", { ...r });
}
function hp(r) {
  const { calendarMonth: e, displayIndex: t, ...n } = r;
  return F.createElement("div", { ...n }, r.children);
}
function mp(r) {
  const { calendarMonth: e, displayIndex: t, ...n } = r;
  return F.createElement("div", { ...n });
}
function pp(r) {
  return F.createElement("table", { ...r });
}
function gp(r) {
  return F.createElement("div", { ...r });
}
function _p(r) {
  const { components: e } = ls();
  return F.createElement(e.Dropdown, { ...r });
}
function yp(r) {
  const { onPreviousClick: e, onNextClick: t, previousMonth: n, nextMonth: i, ...s } = r, { components: o, classNames: a, styles: c, labels: { labelPrevious: u, labelNext: f } } = ls(), d = Et((_) => {
    i && t?.(_);
  }, [i, t]), p = Et((_) => {
    n && e?.(_);
  }, [n, e]);
  return F.createElement(
    "nav",
    { ...s },
    F.createElement(
      o.PreviousMonthButton,
      { type: "button", className: a[Y.PreviousMonthButton], style: c?.[Y.PreviousMonthButton], tabIndex: n ? void 0 : -1, "aria-disabled": n ? void 0 : !0, "aria-label": u(n), onClick: p },
      F.createElement(o.Chevron, { disabled: n ? void 0 : !0, className: a[Y.Chevron], style: c?.[Y.Chevron], orientation: "left" })
    ),
    F.createElement(
      o.NextMonthButton,
      { type: "button", className: a[Y.NextMonthButton], style: c?.[Y.NextMonthButton], tabIndex: i ? void 0 : -1, "aria-disabled": i ? void 0 : !0, "aria-label": f(i), onClick: d },
      F.createElement(o.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: a[Y.Chevron], style: c?.[Y.Chevron] })
    )
  );
}
function bp(r) {
  return F.createElement("button", { ...r });
}
function vp(r) {
  return F.createElement("option", { ...r });
}
function xp(r) {
  return F.createElement("button", { ...r });
}
function wp(r) {
  const { rootRef: e, ...t } = r;
  return F.createElement("div", { ...t, ref: e });
}
function Tp(r) {
  return F.createElement("select", { ...r });
}
function kp(r) {
  const { week: e, ...t } = r;
  return F.createElement("tr", { ...t });
}
function Ep(r) {
  return F.createElement("th", { ...r });
}
function Sp(r) {
  return F.createElement(
    "thead",
    { "aria-hidden": !0 },
    F.createElement("tr", { ...r })
  );
}
function Np(r) {
  const { week: e, ...t } = r;
  return F.createElement("th", { ...t });
}
function Op(r) {
  return F.createElement("th", { ...r });
}
function Cp(r) {
  return F.createElement("tbody", { ...r });
}
function jp(r) {
  const { components: e } = ls();
  return F.createElement(e.Dropdown, { ...r });
}
const Dp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CaptionLabel: op,
  Chevron: ap,
  Day: lp,
  DayButton: cp,
  Dropdown: up,
  DropdownNav: fp,
  Footer: dp,
  Month: hp,
  MonthCaption: mp,
  MonthGrid: pp,
  Months: gp,
  MonthsDropdown: _p,
  Nav: yp,
  NextMonthButton: bp,
  Option: vp,
  PreviousMonthButton: xp,
  Root: wp,
  Select: Tp,
  Week: kp,
  WeekNumber: Np,
  WeekNumberHeader: Op,
  Weekday: Ep,
  Weekdays: Sp,
  Weeks: Cp,
  YearsDropdown: jp
}, Symbol.toStringTag, { value: "Module" }));
function rn(r, e, t = !1, n = $t) {
  let { from: i, to: s } = r;
  const { differenceInCalendarDays: o, isSameDay: a } = n;
  return i && s ? (o(s, i) < 0 && ([i, s] = [s, i]), o(e, i) >= (t ? 1 : 0) && o(s, e) >= (t ? 1 : 0)) : !t && s ? a(s, e) : !t && i ? a(i, e) : !1;
}
function jo(r) {
  return !!(r && typeof r == "object" && "before" in r && "after" in r);
}
function cs(r) {
  return !!(r && typeof r == "object" && "from" in r);
}
function Do(r) {
  return !!(r && typeof r == "object" && "after" in r);
}
function Mo(r) {
  return !!(r && typeof r == "object" && "before" in r);
}
function Zc(r) {
  return !!(r && typeof r == "object" && "dayOfWeek" in r);
}
function Jc(r, e) {
  return Array.isArray(r) && r.every(e.isDate);
}
function sn(r, e, t = $t) {
  const n = Array.isArray(e) ? e : [e], { isSameDay: i, differenceInCalendarDays: s, isAfter: o } = t;
  return n.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (t.isDate(a))
      return i(r, a);
    if (Jc(a, t))
      return a.some((c) => i(r, c));
    if (cs(a))
      return rn(a, r, !1, t);
    if (Zc(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(r.getDay()) : a.dayOfWeek === r.getDay();
    if (jo(a)) {
      const c = s(a.before, r), u = s(a.after, r), f = c > 0, d = u < 0;
      return o(a.before, a.after) ? d && f : f || d;
    }
    return Do(a) ? s(r, a.after) > 0 : Mo(a) ? s(a.before, r) > 0 : typeof a == "function" ? a(r) : !1;
  });
}
function Mp(r, e, t, n, i) {
  const { disabled: s, hidden: o, modifiers: a, showOutsideDays: c, broadcastCalendar: u, today: f = i.today() } = e, { isSameDay: d, isSameMonth: p, startOfMonth: _, isBefore: v, endOfMonth: m, isAfter: y } = i, x = t && _(t), k = n && m(n), E = {
    [we.focused]: [],
    [we.outside]: [],
    [we.disabled]: [],
    [we.hidden]: [],
    [we.today]: []
  }, O = {};
  for (const h of r) {
    const { date: b, displayMonth: w } = h, C = !!(w && !p(b, w)), N = !!(x && v(b, x)), j = !!(k && y(b, k)), A = !!(s && sn(b, s, i)), B = !!(o && sn(b, o, i)) || N || j || // Broadcast calendar will show outside days as default
    !u && !c && C || u && c === !1 && C, z = d(b, f);
    C && E.outside.push(h), A && E.disabled.push(h), B && E.hidden.push(h), z && E.today.push(h), a && Object.keys(a).forEach((P) => {
      const I = a?.[P];
      I && sn(b, I, i) && (O[P] ? O[P].push(h) : O[P] = [h]);
    });
  }
  return (h) => {
    const b = {
      [we.focused]: !1,
      [we.disabled]: !1,
      [we.hidden]: !1,
      [we.outside]: !1,
      [we.today]: !1
    }, w = {};
    for (const C in E) {
      const N = E[C];
      b[C] = N.some((j) => j === h);
    }
    for (const C in O)
      w[C] = O[C].some((N) => N === h);
    return {
      ...b,
      // custom modifiers should override all the previous ones
      ...w
    };
  };
}
function Ap(r, e, t = {}) {
  return Object.entries(r).filter(([, i]) => i === !0).reduce((i, [s]) => (t[s] ? i.push(t[s]) : e[we[s]] ? i.push(e[we[s]]) : e[Pt[s]] && i.push(e[Pt[s]]), i), [e[Y.Day]]);
}
function Rp(r) {
  return {
    ...Dp,
    ...r
  };
}
function Pp(r) {
  const e = {
    "data-mode": r.mode ?? void 0,
    "data-required": "required" in r ? r.required : void 0,
    "data-multiple-months": r.numberOfMonths && r.numberOfMonths > 1 || void 0,
    "data-week-numbers": r.showWeekNumber || void 0,
    "data-broadcast-calendar": r.broadcastCalendar || void 0,
    "data-nav-layout": r.navLayout || void 0
  };
  return Object.entries(r).forEach(([t, n]) => {
    t.startsWith("data-") && (e[t] = n);
  }), e;
}
function Ip() {
  const r = {};
  for (const e in Y)
    r[Y[e]] = `rdp-${Y[e]}`;
  for (const e in we)
    r[we[e]] = `rdp-${we[e]}`;
  for (const e in Pt)
    r[Pt[e]] = `rdp-${Pt[e]}`;
  for (const e in dt)
    r[dt[e]] = `rdp-${dt[e]}`;
  return r;
}
function Lp(r, e, t) {
  return (t ?? new xt(e)).formatMonthYear(r);
}
function Fp(r, e, t) {
  return (t ?? new xt(e)).format(r, "d");
}
function Wp(r, e = $t) {
  return e.format(r, "LLLL");
}
function Yp(r, e, t) {
  return (t ?? new xt(e)).format(r, "cccccc");
}
function Bp(r, e = $t) {
  return r < 10 ? e.formatNumber(`0${r.toLocaleString()}`) : e.formatNumber(`${r.toLocaleString()}`);
}
function zp() {
  return "";
}
function Up(r, e = $t) {
  return e.format(r, "yyyy");
}
const Hp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Lp,
  formatDay: Fp,
  formatMonthDropdown: Wp,
  formatWeekNumber: Bp,
  formatWeekNumberHeader: zp,
  formatWeekdayName: Yp,
  formatYearDropdown: Up
}, Symbol.toStringTag, { value: "Module" }));
function Gp(r) {
  return {
    ...Hp,
    ...r
  };
}
function eu(r, e, t, n) {
  let i = (n ?? new xt(t)).format(r, "PPPP");
  return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
}
function tu(r, e, t) {
  return (t ?? new xt(e)).formatMonthYear(r);
}
function nu(r, e, t, n) {
  let i = (n ?? new xt(t)).format(r, "PPPP");
  return e?.today && (i = `Today, ${i}`), i;
}
function ru(r) {
  return "Choose the Month";
}
function iu() {
  return "";
}
const qp = "Go to the Next Month";
function su(r, e) {
  return qp;
}
function ou(r) {
  return "Go to the Previous Month";
}
function au(r, e, t) {
  return (t ?? new xt(e)).format(r, "cccc");
}
function lu(r, e) {
  return `Week ${r}`;
}
function cu(r) {
  return "Week Number";
}
function uu(r) {
  return "Choose the Year";
}
const $p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelDayButton: eu,
  labelGrid: tu,
  labelGridcell: nu,
  labelMonthDropdown: ru,
  labelNav: iu,
  labelNext: su,
  labelPrevious: ou,
  labelWeekNumber: lu,
  labelWeekNumberHeader: cu,
  labelWeekday: au,
  labelYearDropdown: uu
}, Symbol.toStringTag, { value: "Module" })), Rt = (r, e, t) => e || (t ? typeof t == "function" ? t : (...n) => t : r);
function Vp(r, e) {
  const t = e.locale?.labels ?? {};
  return {
    ...$p,
    ...r ?? {},
    labelDayButton: Rt(eu, r?.labelDayButton, t.labelDayButton),
    labelMonthDropdown: Rt(ru, r?.labelMonthDropdown, t.labelMonthDropdown),
    labelNext: Rt(su, r?.labelNext, t.labelNext),
    labelPrevious: Rt(ou, r?.labelPrevious, t.labelPrevious),
    labelWeekNumber: Rt(lu, r?.labelWeekNumber, t.labelWeekNumber),
    labelYearDropdown: Rt(uu, r?.labelYearDropdown, t.labelYearDropdown),
    labelGrid: Rt(tu, r?.labelGrid, t.labelGrid),
    labelGridcell: Rt(nu, r?.labelGridcell, t.labelGridcell),
    labelNav: Rt(iu, r?.labelNav, t.labelNav),
    labelWeekNumberHeader: Rt(cu, r?.labelWeekNumberHeader, t.labelWeekNumberHeader),
    labelWeekday: Rt(au, r?.labelWeekday, t.labelWeekday)
  };
}
function Xp(r, e, t, n, i) {
  const { startOfMonth: s, startOfYear: o, endOfYear: a, eachMonthOfInterval: c, getMonth: u } = i;
  return c({
    start: o(r),
    end: a(r)
  }).map((p) => {
    const _ = n.formatMonthDropdown(p, i), v = u(p), m = e && p < s(e) || t && p > s(t) || !1;
    return { value: v, label: _, disabled: m };
  });
}
function Kp(r, e = {}, t = {}) {
  let n = { ...e?.[Y.Day] };
  return Object.entries(r).filter(([, i]) => i === !0).forEach(([i]) => {
    n = {
      ...n,
      ...t?.[i]
    };
  }), n;
}
function Qp(r, e, t, n) {
  const i = n ?? r.today(), s = t ? r.startOfBroadcastWeek(i, r) : e ? r.startOfISOWeek(i) : r.startOfWeek(i), o = [];
  for (let a = 0; a < 7; a++) {
    const c = r.addDays(s, a);
    o.push(c);
  }
  return o;
}
function Zp(r, e, t, n, i = !1) {
  if (!r || !e)
    return;
  const { startOfYear: s, endOfYear: o, eachYearOfInterval: a, getYear: c } = n, u = s(r), f = o(e), d = a({ start: u, end: f });
  return i && d.reverse(), d.map((p) => {
    const _ = t.formatYearDropdown(p, n);
    return {
      value: c(p),
      label: _,
      disabled: !1
    };
  });
}
function Jp(r, e = {}) {
  const { weekStartsOn: t, locale: n } = e, i = t ?? n?.options?.weekStartsOn ?? 0, s = (a) => {
    const c = typeof a == "number" || typeof a == "string" ? new Date(a) : a;
    return new $e(c.getFullYear(), c.getMonth(), c.getDate(), 12, 0, 0, r);
  }, o = (a) => {
    const c = s(a);
    return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => s($e.tz(r)),
    newDate: (a, c, u) => new $e(a, c, u, 12, 0, 0, r),
    startOfDay: (a) => s(a),
    startOfWeek: (a, c) => {
      const u = s(a), f = c?.weekStartsOn ?? i, d = (u.getDay() - f + 7) % 7;
      return u.setDate(u.getDate() - d), u;
    },
    startOfISOWeek: (a) => {
      const c = s(a), u = (c.getDay() - 1 + 7) % 7;
      return c.setDate(c.getDate() - u), c;
    },
    startOfMonth: (a) => {
      const c = s(a);
      return c.setDate(1), c;
    },
    startOfYear: (a) => {
      const c = s(a);
      return c.setMonth(0, 1), c;
    },
    endOfWeek: (a, c) => {
      const u = s(a), p = (((c?.weekStartsOn ?? i) + 6) % 7 - u.getDay() + 7) % 7;
      return u.setDate(u.getDate() + p), u;
    },
    endOfISOWeek: (a) => {
      const c = s(a), u = (7 - c.getDay()) % 7;
      return c.setDate(c.getDate() + u), c;
    },
    endOfMonth: (a) => {
      const c = s(a);
      return c.setMonth(c.getMonth() + 1, 0), c;
    },
    endOfYear: (a) => {
      const c = s(a);
      return c.setMonth(11, 31), c;
    },
    eachMonthOfInterval: (a) => {
      const c = s(a.start), u = s(a.end), f = [], d = new $e(c.getFullYear(), c.getMonth(), 1, 12, 0, 0, r), p = u.getFullYear() * 12 + u.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= p; )
        f.push(new $e(d, r)), d.setMonth(d.getMonth() + 1, 1);
      return f;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (a, c) => {
      const u = s(a);
      return u.setDate(u.getDate() + c), u;
    },
    addWeeks: (a, c) => {
      const u = s(a);
      return u.setDate(u.getDate() + c * 7), u;
    },
    addMonths: (a, c) => {
      const u = s(a);
      return u.setMonth(u.getMonth() + c), u;
    },
    addYears: (a, c) => {
      const u = s(a);
      return u.setFullYear(u.getFullYear() + c), u;
    },
    eachYearOfInterval: (a) => {
      const c = s(a.start), u = s(a.end), f = [], d = new $e(c.getFullYear(), 0, 1, 12, 0, 0, r);
      for (; d.getFullYear() <= u.getFullYear(); )
        f.push(new $e(d, r)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return f;
    },
    getWeek: (a, c) => {
      const u = o(a);
      return Co(u, {
        weekStartsOn: c?.weekStartsOn ?? i,
        firstWeekContainsDate: c?.firstWeekContainsDate ?? n?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (a) => {
      const c = o(a);
      return Oo(c);
    },
    differenceInCalendarDays: (a, c) => {
      const u = o(a), f = o(c);
      return No(u, f);
    },
    differenceInCalendarMonths: (a, c) => {
      const u = o(a), f = o(c);
      return zc(u, f);
    }
  };
}
const xi = (r) => r instanceof HTMLElement ? r : null, Ps = (r) => [
  ...r.querySelectorAll("[data-animated-month]") ?? []
], eg = (r) => xi(r.querySelector("[data-animated-month]")), Is = (r) => xi(r.querySelector("[data-animated-caption]")), Ls = (r) => xi(r.querySelector("[data-animated-weeks]")), tg = (r) => xi(r.querySelector("[data-animated-nav]")), ng = (r) => xi(r.querySelector("[data-animated-weekdays]"));
function rg(r, e, { classNames: t, months: n, focused: i, dateLib: s }) {
  const o = _t(null), a = _t(n), c = _t(!1);
  pl(() => {
    const u = a.current;
    if (a.current = n, !e || !r.current || // safety check because the ref can be set to anything by consumers
    !(r.current instanceof HTMLElement) || // validation required for the animation to work as expected
    n.length === 0 || u.length === 0 || n.length !== u.length)
      return;
    const f = s.isSameMonth(n[0].date, u[0].date), d = s.isAfter(n[0].date, u[0].date), p = d ? t[dt.caption_after_enter] : t[dt.caption_before_enter], _ = d ? t[dt.weeks_after_enter] : t[dt.weeks_before_enter], v = o.current, m = r.current.cloneNode(!0);
    if (m instanceof HTMLElement ? (Ps(m).forEach((E) => {
      if (!(E instanceof HTMLElement))
        return;
      const O = eg(E);
      O && E.contains(O) && E.removeChild(O);
      const h = Is(E);
      h && h.classList.remove(p);
      const b = Ls(E);
      b && b.classList.remove(_);
    }), o.current = m) : o.current = null, c.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    i)
      return;
    const y = v instanceof HTMLElement ? Ps(v) : [], x = Ps(r.current);
    if (x?.every((k) => k instanceof HTMLElement) && y?.every((k) => k instanceof HTMLElement)) {
      c.current = !0, r.current.style.isolation = "isolate";
      const k = tg(r.current);
      k && (k.style.zIndex = "1"), x.forEach((E, O) => {
        const h = y[O];
        if (!h)
          return;
        E.style.position = "relative", E.style.overflow = "hidden";
        const b = Is(E);
        b && b.classList.add(p);
        const w = Ls(E);
        w && w.classList.add(_);
        const C = () => {
          c.current = !1, r.current && (r.current.style.isolation = ""), k && (k.style.zIndex = ""), b && b.classList.remove(p), w && w.classList.remove(_), E.style.position = "", E.style.overflow = "", E.contains(h) && E.removeChild(h);
        };
        h.style.pointerEvents = "none", h.style.position = "absolute", h.style.overflow = "hidden", h.setAttribute("aria-hidden", "true");
        const N = ng(h);
        N && (N.style.opacity = "0");
        const j = Is(h);
        j && (j.classList.add(d ? t[dt.caption_before_exit] : t[dt.caption_after_exit]), j.addEventListener("animationend", C));
        const A = Ls(h);
        A && A.classList.add(d ? t[dt.weeks_before_exit] : t[dt.weeks_after_exit]), E.insertBefore(h, E.firstChild);
      });
    }
  });
}
function ig(r, e, t, n) {
  const i = r[0], s = r[r.length - 1], { ISOWeek: o, fixedWeeks: a, broadcastCalendar: c } = t ?? {}, { addDays: u, differenceInCalendarDays: f, differenceInCalendarMonths: d, endOfBroadcastWeek: p, endOfISOWeek: _, endOfMonth: v, endOfWeek: m, isAfter: y, startOfBroadcastWeek: x, startOfISOWeek: k, startOfWeek: E } = n, O = c ? x(i, n) : o ? k(i) : E(i), h = c ? p(s) : o ? _(v(s)) : m(v(s)), b = e && (c ? p(e) : o ? _(e) : m(e)), w = b && y(h, b) ? b : h, C = f(w, O), N = d(s, i) + 1, j = [];
  for (let z = 0; z <= C; z++) {
    const P = u(O, z);
    j.push(P);
  }
  const B = (c ? 35 : 42) * N;
  if (a && j.length < B) {
    const z = B - j.length;
    for (let P = 0; P < z; P++) {
      const I = u(j[j.length - 1], 1);
      j.push(I);
    }
  }
  return j;
}
function sg(r) {
  const e = [];
  return r.reduce((t, n) => {
    const i = n.weeks.reduce((s, o) => s.concat(o.days.slice()), e.slice());
    return t.concat(i.slice());
  }, e.slice());
}
function og(r, e, t, n) {
  const { numberOfMonths: i = 1 } = t, s = [];
  for (let o = 0; o < i; o++) {
    const a = n.addMonths(r, o);
    if (e && a > e)
      break;
    s.push(a);
  }
  return s;
}
function fl(r, e, t, n) {
  const { month: i, defaultMonth: s, today: o = n.today(), numberOfMonths: a = 1 } = r;
  let c = i || s || o;
  const { differenceInCalendarMonths: u, addMonths: f, startOfMonth: d } = n;
  if (t && u(t, c) < a - 1) {
    const p = -1 * (a - 1);
    c = f(t, p);
  }
  return e && u(c, e) < 0 && (c = e), d(c);
}
function ag(r, e, t, n) {
  const { addDays: i, endOfBroadcastWeek: s, endOfISOWeek: o, endOfMonth: a, endOfWeek: c, getISOWeek: u, getWeek: f, startOfBroadcastWeek: d, startOfISOWeek: p, startOfWeek: _ } = n, v = r.reduce((m, y) => {
    const x = t.broadcastCalendar ? d(y, n) : t.ISOWeek ? p(y) : _(y), k = t.broadcastCalendar ? s(y) : t.ISOWeek ? o(a(y)) : c(a(y)), E = e.filter((w) => w >= x && w <= k), O = t.broadcastCalendar ? 35 : 42;
    if (t.fixedWeeks && E.length < O) {
      const w = e.filter((C) => {
        const N = O - E.length;
        return C > k && C <= i(k, N);
      });
      E.push(...w);
    }
    const h = E.reduce((w, C) => {
      const N = t.ISOWeek ? u(C) : f(C), j = w.find((B) => B.weekNumber === N), A = new Kc(C, y, n);
      return j ? j.days.push(A) : w.push(new sp(N, [A])), w;
    }, []), b = new ip(y, h);
    return m.push(b), m;
  }, []);
  return t.reverseMonths ? v.reverse() : v;
}
function lg(r, e) {
  let { startMonth: t, endMonth: n } = r;
  const { startOfYear: i, startOfDay: s, startOfMonth: o, endOfMonth: a, addYears: c, endOfYear: u, today: f } = e, d = r.captionLayout === "dropdown" || r.captionLayout === "dropdown-years";
  return t ? t = o(t) : !t && d && (t = i(c(r.today ?? f(), -100))), n ? n = a(n) : !n && d && (n = u(r.today ?? f())), [
    t && s(t),
    n && s(n)
  ];
}
function cg(r, e, t, n) {
  if (t.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: s = 1 } = t, { startOfMonth: o, addMonths: a, differenceInCalendarMonths: c } = n, u = i ? s : 1, f = o(r);
  if (!e)
    return a(f, u);
  if (!(c(e, r) < s))
    return a(f, u);
}
function ug(r, e, t, n) {
  if (t.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: s } = t, { startOfMonth: o, addMonths: a, differenceInCalendarMonths: c } = n, u = i ? s ?? 1 : 1, f = o(r);
  if (!e)
    return a(f, -u);
  if (!(c(f, e) <= 0))
    return a(f, -u);
}
function fg(r) {
  const e = [];
  return r.reduce((t, n) => t.concat(n.weeks.slice()), e.slice());
}
function us(r, e) {
  const [t, n] = Pe(r);
  return [e === void 0 ? t : e, n];
}
function dg(r, e) {
  const [t, n] = lg(r, e), { startOfMonth: i, endOfMonth: s } = e, o = fl(r, t, n, e), [a, c] = us(
    o,
    // initialMonth is always computed from props.month if provided
    r.month ? o : void 0
  );
  cn(() => {
    const O = fl(r, t, n, e);
    c(O);
  }, [r.timeZone]);
  const { months: u, weeks: f, days: d, previousMonth: p, nextMonth: _ } = Fi(() => {
    const O = og(a, n, { numberOfMonths: r.numberOfMonths }, e), h = ig(O, r.endMonth ? s(r.endMonth) : void 0, {
      ISOWeek: r.ISOWeek,
      fixedWeeks: r.fixedWeeks,
      broadcastCalendar: r.broadcastCalendar
    }, e), b = ag(O, h, {
      broadcastCalendar: r.broadcastCalendar,
      fixedWeeks: r.fixedWeeks,
      ISOWeek: r.ISOWeek,
      reverseMonths: r.reverseMonths
    }, e), w = fg(b), C = sg(b), N = ug(a, t, r, e), j = cg(a, n, r, e);
    return {
      months: b,
      weeks: w,
      days: C,
      previousMonth: N,
      nextMonth: j
    };
  }, [
    e,
    a.getTime(),
    n?.getTime(),
    t?.getTime(),
    r.disableNavigation,
    r.broadcastCalendar,
    r.endMonth?.getTime(),
    r.fixedWeeks,
    r.ISOWeek,
    r.numberOfMonths,
    r.pagedNavigation,
    r.reverseMonths
  ]), { disableNavigation: v, onMonthChange: m } = r, y = (O) => f.some((h) => h.days.some((b) => b.isEqualTo(O))), x = (O) => {
    if (v)
      return;
    let h = i(O);
    t && h < i(t) && (h = i(t)), n && h > i(n) && (h = i(n)), c(h), m?.(h);
  };
  return {
    months: u,
    weeks: f,
    days: d,
    navStart: t,
    navEnd: n,
    previousMonth: p,
    nextMonth: _,
    goToMonth: x,
    goToDay: (O) => {
      y(O) || x(O.date);
    }
  };
}
var Yt;
(function(r) {
  r[r.Today = 0] = "Today", r[r.Selected = 1] = "Selected", r[r.LastFocused = 2] = "LastFocused", r[r.FocusedModifier = 3] = "FocusedModifier";
})(Yt || (Yt = {}));
function dl(r) {
  return !r[we.disabled] && !r[we.hidden] && !r[we.outside];
}
function hg(r, e, t, n) {
  let i, s = -1;
  for (const o of r) {
    const a = e(o);
    dl(a) && (a[we.focused] && s < Yt.FocusedModifier ? (i = o, s = Yt.FocusedModifier) : n?.isEqualTo(o) && s < Yt.LastFocused ? (i = o, s = Yt.LastFocused) : t(o.date) && s < Yt.Selected ? (i = o, s = Yt.Selected) : a[we.today] && s < Yt.Today && (i = o, s = Yt.Today));
  }
  return i || (i = r.find((o) => dl(e(o)))), i;
}
function mg(r, e, t, n, i, s, o) {
  const { ISOWeek: a, broadcastCalendar: c } = s, { addDays: u, addMonths: f, addWeeks: d, addYears: p, endOfBroadcastWeek: _, endOfISOWeek: v, endOfWeek: m, max: y, min: x, startOfBroadcastWeek: k, startOfISOWeek: E, startOfWeek: O } = o;
  let b = {
    day: u,
    week: d,
    month: f,
    year: p,
    startOfWeek: (w) => c ? k(w, o) : a ? E(w) : O(w),
    endOfWeek: (w) => c ? _(w) : a ? v(w) : m(w)
  }[r](t, e === "after" ? 1 : -1);
  return e === "before" && n ? b = y([n, b]) : e === "after" && i && (b = x([i, b])), b;
}
function fu(r, e, t, n, i, s, o, a = 0) {
  if (a > 365)
    return;
  const c = mg(r, e, t.date, n, i, s, o), u = !!(s.disabled && sn(c, s.disabled, o)), f = !!(s.hidden && sn(c, s.hidden, o)), d = c, p = new Kc(c, d, o);
  return !u && !f ? p : fu(r, e, p, n, i, s, o, a + 1);
}
function pg(r, e, t, n, i) {
  const { autoFocus: s } = r, [o, a] = Pe(), c = hg(e.days, t, n || (() => !1), o), [u, f] = Pe(s ? c : void 0);
  return {
    isFocusTarget: (m) => !!c?.isEqualTo(m),
    setFocused: f,
    focused: u,
    blur: () => {
      a(u), f(void 0);
    },
    moveFocus: (m, y) => {
      if (!u)
        return;
      const x = fu(m, y, u, e.navStart, e.navEnd, r, i);
      x && (r.disableNavigation && !e.days.some((E) => E.isEqualTo(x)) || (e.goToDay(x), f(x)));
    }
  };
}
function gg(r, e) {
  const { selected: t, required: n, onSelect: i } = r, [s, o] = us(t, i ? t : void 0), a = i ? t : s, { isSameDay: c } = e, u = (_) => a?.some((v) => c(v, _)) ?? !1, { min: f, max: d } = r;
  return {
    selected: a,
    select: (_, v, m) => {
      let y = [...a ?? []];
      if (u(_)) {
        if (a?.length === f || n && a?.length === 1)
          return;
        y = a?.filter((x) => !c(x, _));
      } else
        a?.length === d ? y = [_] : y = [...y, _];
      return i || o(y), i?.(y, _, v, m), y;
    },
    isSelected: u
  };
}
function _g(r, e, t = 0, n = 0, i = !1, s = $t) {
  const { from: o, to: a } = e || {}, { isSameDay: c, isAfter: u, isBefore: f } = s;
  let d;
  if (!o && !a)
    d = { from: r, to: t > 0 ? void 0 : r };
  else if (o && !a)
    c(o, r) ? t === 0 ? d = { from: o, to: r } : i ? d = { from: o, to: void 0 } : d = void 0 : f(r, o) ? d = { from: r, to: o } : d = { from: o, to: r };
  else if (o && a)
    if (c(o, r) && c(a, r))
      i ? d = { from: o, to: a } : d = void 0;
    else if (c(o, r))
      d = { from: o, to: t > 0 ? void 0 : r };
    else if (c(a, r))
      d = { from: r, to: t > 0 ? void 0 : r };
    else if (f(r, o))
      d = { from: r, to: a };
    else if (u(r, o))
      d = { from: o, to: r };
    else if (u(r, a))
      d = { from: o, to: r };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const p = s.differenceInCalendarDays(d.to, d.from);
    n > 0 && p > n ? d = { from: r, to: void 0 } : t > 1 && p < t && (d = { from: r, to: void 0 });
  }
  return d;
}
function yg(r, e, t = $t) {
  const n = Array.isArray(e) ? e : [e];
  let i = r.from;
  const s = t.differenceInCalendarDays(r.to, r.from), o = Math.min(s, 6);
  for (let a = 0; a <= o; a++) {
    if (n.includes(i.getDay()))
      return !0;
    i = t.addDays(i, 1);
  }
  return !1;
}
function hl(r, e, t = $t) {
  return rn(r, e.from, !1, t) || rn(r, e.to, !1, t) || rn(e, r.from, !1, t) || rn(e, r.to, !1, t);
}
function bg(r, e, t = $t) {
  const n = Array.isArray(e) ? e : [e];
  if (n.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : t.isDate(a) ? rn(r, a, !1, t) : Jc(a, t) ? a.some((c) => rn(r, c, !1, t)) : cs(a) ? a.from && a.to ? hl(r, { from: a.from, to: a.to }, t) : !1 : Zc(a) ? yg(r, a.dayOfWeek, t) : jo(a) ? t.isAfter(a.before, a.after) ? hl(r, {
    from: t.addDays(a.after, 1),
    to: t.addDays(a.before, -1)
  }, t) : sn(r.from, a, t) || sn(r.to, a, t) : Do(a) || Mo(a) ? sn(r.from, a, t) || sn(r.to, a, t) : !1))
    return !0;
  const o = n.filter((a) => typeof a == "function");
  if (o.length) {
    let a = r.from;
    const c = t.differenceInCalendarDays(r.to, r.from);
    for (let u = 0; u <= c; u++) {
      if (o.some((f) => f(a)))
        return !0;
      a = t.addDays(a, 1);
    }
  }
  return !1;
}
function vg(r, e) {
  const { disabled: t, excludeDisabled: n, resetOnSelect: i, selected: s, required: o, onSelect: a } = r, [c, u] = us(s, a ? s : void 0), f = a ? s : c;
  return {
    selected: f,
    select: (_, v, m) => {
      const { min: y, max: x } = r;
      let k;
      if (_) {
        const E = f?.from, O = f?.to, h = !!E && !!O, b = !!E && !!O && e.isSameDay(E, O) && e.isSameDay(_, E);
        i && (h || !f?.from) ? !o && b ? k = void 0 : k = { from: _, to: void 0 } : k = _g(_, f, y, x, o, e);
      }
      return n && t && k?.from && k.to && bg({ from: k.from, to: k.to }, t, e) && (k.from = _, k.to = void 0), a || u(k), a?.(k, _, v, m), k;
    },
    isSelected: (_) => f && rn(f, _, !1, e)
  };
}
function xg(r, e) {
  const { selected: t, required: n, onSelect: i } = r, [s, o] = us(t, i ? t : void 0), a = i ? t : s, { isSameDay: c } = e;
  return {
    selected: a,
    select: (d, p, _) => {
      let v = d;
      return !n && a && a && c(d, a) && (v = void 0), i || o(v), i?.(v, d, p, _), v;
    },
    isSelected: (d) => a ? c(a, d) : !1
  };
}
function wg(r, e) {
  const t = xg(r, e), n = gg(r, e), i = vg(r, e);
  switch (r.mode) {
    case "single":
      return t;
    case "multiple":
      return n;
    case "range":
      return i;
    default:
      return;
  }
}
function Nt(r, e) {
  return r instanceof $e && r.timeZone === e ? r : new $e(r, e);
}
function pr(r, e, t) {
  return Nt(r, e);
}
function ml(r, e, t) {
  return typeof r == "boolean" || typeof r == "function" ? r : r instanceof Date ? pr(r, e) : Array.isArray(r) ? r.map((n) => n instanceof Date ? pr(n, e) : n) : cs(r) ? {
    ...r,
    from: r.from ? Nt(r.from, e) : r.from,
    to: r.to ? Nt(r.to, e) : r.to
  } : jo(r) ? {
    before: pr(r.before, e),
    after: pr(r.after, e)
  } : Do(r) ? {
    after: pr(r.after, e)
  } : Mo(r) ? {
    before: pr(r.before, e)
  } : r;
}
function Fs(r, e, t) {
  return r && (Array.isArray(r) ? r.map((n) => ml(n, e)) : ml(r, e));
}
function Tg(r) {
  let e = r;
  const t = e.timeZone;
  if (t && (e = {
    ...r,
    timeZone: t
  }, e.today && (e.today = Nt(e.today, t)), e.month && (e.month = Nt(e.month, t)), e.defaultMonth && (e.defaultMonth = Nt(e.defaultMonth, t)), e.startMonth && (e.startMonth = Nt(e.startMonth, t)), e.endMonth && (e.endMonth = Nt(e.endMonth, t)), e.mode === "single" && e.selected ? e.selected = Nt(e.selected, t) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((q) => Nt(q, t)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? Nt(e.selected.from, t) : e.selected.from,
    to: e.selected.to ? Nt(e.selected.to, t) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Fs(e.disabled, t)), e.hidden !== void 0 && (e.hidden = Fs(e.hidden, t)), e.modifiers)) {
    const q = {};
    Object.keys(e.modifiers).forEach((Q) => {
      q[Q] = Fs(e.modifiers?.[Q], t);
    }), e.modifiers = q;
  }
  const { components: n, formatters: i, labels: s, dateLib: o, locale: a, classNames: c } = Fi(() => {
    const q = { ...Xc, ...e.locale }, Q = e.broadcastCalendar ? 1 : e.weekStartsOn, $ = e.noonSafe && e.timeZone ? Jp(e.timeZone, {
      weekStartsOn: Q,
      locale: q
    }) : void 0, le = e.dateLib && $ ? { ...$, ...e.dateLib } : e.dateLib ?? $, te = new xt({
      locale: q,
      weekStartsOn: Q,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, le);
    return {
      dateLib: te,
      components: Rp(e.components),
      formatters: Gp(e.formatters),
      labels: Vp(e.labels, te.options),
      locale: q,
      classNames: { ...Ip(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: o.today() });
  const { captionLayout: u, mode: f, navLayout: d, numberOfMonths: p = 1, onDayBlur: _, onDayClick: v, onDayFocus: m, onDayKeyDown: y, onDayMouseEnter: x, onDayMouseLeave: k, onNextClick: E, onPrevClick: O, showWeekNumber: h, styles: b } = e, { formatCaption: w, formatDay: C, formatMonthDropdown: N, formatWeekNumber: j, formatWeekNumberHeader: A, formatWeekdayName: B, formatYearDropdown: z } = i, P = dg(e, o), { days: I, months: X, navStart: oe, navEnd: Oe, previousMonth: pe, nextMonth: _e, goToMonth: Ce } = P, ze = Mp(I, e, oe, Oe, o), { isSelected: jt, select: Fe, selected: J } = wg(e, o) ?? {}, { blur: un, focused: fn, isFocusTarget: dn, moveFocus: hn, setFocused: Dt } = pg(e, P, ze, jt ?? (() => !1), o), { labelDayButton: Ar, labelGridcell: Pn, labelGrid: Rr, labelMonthDropdown: ar, labelNav: ae, labelPrevious: Mt, labelNext: ce, labelWeekday: mn, labelWeekNumber: We, labelWeekNumberHeader: Vt, labelYearDropdown: lr } = s, Je = Fi(() => Qp(o, e.ISOWeek, e.broadcastCalendar, e.today), [o, e.ISOWeek, e.broadcastCalendar, e.today]), In = f !== void 0 || v !== void 0, Xt = Et(() => {
    pe && (Ce(pe), O?.(pe));
  }, [pe, Ce, O]), Kt = Et(() => {
    _e && (Ce(_e), E?.(_e));
  }, [Ce, _e, E]), Ln = Et((q, Q) => ($) => {
    $.preventDefault(), $.stopPropagation(), Dt(q), !Q.disabled && (Fe?.(q.date, Q, $), v?.(q.date, Q, $));
  }, [Fe, v, Dt]), ct = Et((q, Q) => ($) => {
    Dt(q), m?.(q.date, Q, $);
  }, [m, Dt]), At = Et((q, Q) => ($) => {
    un(), _?.(q.date, Q, $);
  }, [un, _]), wt = Et((q, Q) => ($) => {
    const le = {
      ArrowLeft: [
        $.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        $.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [$.shiftKey ? "year" : "week", "after"],
      ArrowUp: [$.shiftKey ? "year" : "week", "before"],
      PageUp: [$.shiftKey ? "year" : "month", "before"],
      PageDown: [$.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (le[$.key]) {
      $.preventDefault(), $.stopPropagation();
      const [te, Ue] = le[$.key];
      hn(te, Ue);
    }
    y?.(q.date, Q, $);
  }, [hn, y, e.dir]), pn = Et((q, Q) => ($) => {
    x?.(q.date, Q, $);
  }, [x]), gn = Et((q, Q) => ($) => {
    k?.(q.date, Q, $);
  }, [k]), _n = Et((q, Q) => ($) => {
    const le = Number($.target.value), te = o.setMonth(o.startOfMonth(q), le);
    Ce(o.addMonths(te, -Q));
  }, [o, Ce]), Fn = Et((q, Q) => ($) => {
    const le = Number($.target.value), te = o.setYear(o.startOfMonth(q), le);
    Ce(o.addMonths(te, -Q));
  }, [o, Ce]), { className: It, style: yn } = Fi(() => ({
    className: [c[Y.Root], e.className].filter(Boolean).join(" "),
    style: { ...b?.[Y.Root], ...e.style }
  }), [c, e.className, e.style, b]), bn = Pp(e), Wn = (q) => {
    const Q = b?.[Y.Dropdown], $ = b?.[q];
    if (!(!Q && !$))
      return {
        ...Q,
        ...$
      };
  }, Qt = _t(null);
  rg(Qt, !!e.animate, {
    classNames: c,
    months: X,
    focused: fn,
    dateLib: o
  });
  const Yn = {
    dayPickerProps: e,
    selected: J,
    select: Fe,
    isSelected: jt,
    months: X,
    nextMonth: _e,
    previousMonth: pe,
    goToMonth: Ce,
    getModifiers: ze,
    components: n,
    classNames: c,
    styles: b,
    labels: s,
    formatters: i
  };
  return F.createElement(
    Qc.Provider,
    { value: Yn },
    F.createElement(
      n.Root,
      { rootRef: e.animate ? Qt : void 0, className: It, style: yn, dir: e.dir, id: e.id, lang: e.lang ?? a.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...bn },
      F.createElement(
        n.Months,
        { className: c[Y.Months], style: b?.[Y.Months] },
        !e.hideNavigation && !d && F.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: c[Y.Nav], style: b?.[Y.Nav], "aria-label": ae(), onPreviousClick: Xt, onNextClick: Kt, previousMonth: pe, nextMonth: _e }),
        X.map((q, Q) => {
          const $ = e.reverseMonths ? X.length - 1 - Q : Q;
          return F.createElement(
            n.Month,
            {
              "data-animated-month": e.animate ? "true" : void 0,
              className: c[Y.Month],
              style: b?.[Y.Month],
              // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
              key: Q,
              displayIndex: Q,
              calendarMonth: q
            },
            d === "around" && !e.hideNavigation && Q === 0 && F.createElement(
              n.PreviousMonthButton,
              { type: "button", className: c[Y.PreviousMonthButton], style: b?.[Y.PreviousMonthButton], tabIndex: pe ? void 0 : -1, "aria-disabled": pe ? void 0 : !0, "aria-label": Mt(pe), onClick: Xt, "data-animated-button": e.animate ? "true" : void 0 },
              F.createElement(n.Chevron, { disabled: pe ? void 0 : !0, className: c[Y.Chevron], style: b?.[Y.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
            ),
            F.createElement(n.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: c[Y.MonthCaption], style: b?.[Y.MonthCaption], calendarMonth: q, displayIndex: Q }, u?.startsWith("dropdown") ? F.createElement(
              n.DropdownNav,
              { className: c[Y.Dropdowns], style: b?.[Y.Dropdowns] },
              (() => {
                const le = u === "dropdown" || u === "dropdown-months" ? F.createElement(n.MonthsDropdown, { key: "month", className: c[Y.MonthsDropdown], "aria-label": ar(), disabled: !!e.disableNavigation, onChange: _n(q.date, $), options: Xp(q.date, oe, Oe, i, o), style: Wn(Y.MonthsDropdown), value: o.getMonth(q.date) }) : F.createElement("span", { key: "month" }, N(q.date, o)), te = u === "dropdown" || u === "dropdown-years" ? F.createElement(n.YearsDropdown, { key: "year", className: c[Y.YearsDropdown], "aria-label": lr(o.options), disabled: !!e.disableNavigation, onChange: Fn(q.date, $), options: Zp(oe, Oe, i, o, !!e.reverseYears), style: Wn(Y.YearsDropdown), value: o.getYear(q.date) }) : F.createElement("span", { key: "year" }, z(q.date, o));
                return o.getMonthYearOrder() === "year-first" ? [te, le] : [le, te];
              })(),
              F.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, w(q.date, o.options, o))
            ) : F.createElement(n.CaptionLabel, { className: c[Y.CaptionLabel], style: b?.[Y.CaptionLabel], role: "status", "aria-live": "polite" }, w(q.date, o.options, o))),
            d === "around" && !e.hideNavigation && Q === p - 1 && F.createElement(
              n.NextMonthButton,
              { type: "button", className: c[Y.NextMonthButton], style: b?.[Y.NextMonthButton], tabIndex: _e ? void 0 : -1, "aria-disabled": _e ? void 0 : !0, "aria-label": ce(_e), onClick: Kt, "data-animated-button": e.animate ? "true" : void 0 },
              F.createElement(n.Chevron, { disabled: _e ? void 0 : !0, className: c[Y.Chevron], style: b?.[Y.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
            ),
            Q === p - 1 && d === "after" && !e.hideNavigation && F.createElement(n.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: c[Y.Nav], style: b?.[Y.Nav], "aria-label": ae(), onPreviousClick: Xt, onNextClick: Kt, previousMonth: pe, nextMonth: _e }),
            F.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": Rr(q.date, o.options, o) || void 0, className: c[Y.MonthGrid], style: b?.[Y.MonthGrid] },
              !e.hideWeekdays && F.createElement(
                n.Weekdays,
                { "data-animated-weekdays": e.animate ? "true" : void 0, className: c[Y.Weekdays], style: b?.[Y.Weekdays] },
                h && F.createElement(n.WeekNumberHeader, { "aria-label": Vt(o.options), className: c[Y.WeekNumberHeader], style: b?.[Y.WeekNumberHeader], scope: "col" }, A()),
                Je.map((le) => F.createElement(n.Weekday, { "aria-label": mn(le, o.options, o), className: c[Y.Weekday], key: String(le), style: b?.[Y.Weekday], scope: "col" }, B(le, o.options, o)))
              ),
              F.createElement(n.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: c[Y.Weeks], style: b?.[Y.Weeks] }, q.weeks.map((le) => F.createElement(
                n.Week,
                { className: c[Y.Week], key: le.weekNumber, style: b?.[Y.Week], week: le },
                h && F.createElement(n.WeekNumber, { week: le, style: b?.[Y.WeekNumber], "aria-label": We(le.weekNumber, {
                  locale: a
                }), className: c[Y.WeekNumber], scope: "row", role: "rowheader" }, j(le.weekNumber, o)),
                le.days.map((te) => {
                  const { date: Ue } = te, ee = ze(te);
                  if (ee[we.focused] = !ee.hidden && !!fn?.isEqualTo(te), ee[Pt.selected] = jt?.(Ue) || ee.selected, cs(J)) {
                    const { from: Lt, to: Ye } = J;
                    ee[Pt.range_start] = !!(Lt && Ye && o.isSameDay(Ue, Lt)), ee[Pt.range_end] = !!(Lt && Ye && o.isSameDay(Ue, Ye)), ee[Pt.range_middle] = rn(J, Ue, !0, o);
                  }
                  const Bn = Kp(ee, b, e.modifiersStyles), zn = Ap(ee, c, e.modifiersClassNames), vn = !In && !ee.hidden ? Pn(Ue, ee, o.options, o) : void 0;
                  return F.createElement(n.Day, { key: `${te.isoDate}_${te.displayMonthId}`, day: te, modifiers: ee, className: zn.join(" "), style: Bn, role: "gridcell", "aria-selected": ee.selected || void 0, "aria-label": vn, "data-day": te.isoDate, "data-month": te.outside ? te.dateMonthId : void 0, "data-selected": ee.selected || void 0, "data-disabled": ee.disabled || void 0, "data-hidden": ee.hidden || void 0, "data-outside": te.outside || void 0, "data-focused": ee.focused || void 0, "data-today": ee.today || void 0 }, !ee.hidden && In ? F.createElement(n.DayButton, { className: c[Y.DayButton], style: b?.[Y.DayButton], type: "button", day: te, modifiers: ee, disabled: !ee.focused && ee.disabled || void 0, "aria-disabled": ee.focused && ee.disabled || void 0, tabIndex: dn(te) ? 0 : -1, "aria-label": Ar(Ue, ee, o.options, o), onClick: Ln(te, ee), onBlur: At(te, ee), onFocus: ct(te, ee), onKeyDown: wt(te, ee), onMouseEnter: pn(te, ee), onMouseLeave: gn(te, ee) }, C(Ue, o.options, o)) : !ee.hidden && C(te.date, o.options, o));
                })
              )))
            )
          );
        })
      ),
      e.footer && F.createElement(n.Footer, { className: c[Y.Footer], style: b?.[Y.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function kg(r) {
  return /* @__PURE__ */ l.jsx("div", { className: "date-picker", children: /* @__PURE__ */ l.jsx(Tg, { ...r }) });
}
function n_({
  title: r,
  content: e,
  children: t,
  icon: n = /* @__PURE__ */ l.jsx(G, { glyph: "info-circle" }),
  valign: i = "bottom",
  halign: s = "center"
}) {
  return /* @__PURE__ */ l.jsxs("div", { className: `info-tooltip info-tooltip--v-${i} info-tooltip--h-${s}`, children: [
    /* @__PURE__ */ l.jsx("div", { className: "info-tooltip-icon", children: n }),
    /* @__PURE__ */ l.jsxs("div", { className: "info-tooltip-popup", children: [
      r && /* @__PURE__ */ l.jsx("div", { className: "info-tooltip-title", children: r }),
      /* @__PURE__ */ l.jsx("div", { className: "info-tooltip-content", children: e || t })
    ] })
  ] });
}
function r_({
  value: r = "",
  id: e,
  name: t,
  onClear: n,
  ...i
}) {
  const [s, o] = Pe(!0), a = _t(null);
  return cn(() => {
    function c(u) {
      a.current && !a.current.contains(u.target) && o(!1);
    }
    return document.addEventListener("mousedown", c), () => {
      document.removeEventListener("mousedown", c);
    };
  }, []), /* @__PURE__ */ l.jsxs("div", { className: "date-picker-input", ref: a, children: [
    /* @__PURE__ */ l.jsxs("div", { className: "input-wrapper", children: [
      /* @__PURE__ */ l.jsx(
        "input",
        {
          readOnly: !0,
          id: e,
          name: t,
          value: r,
          type: "text",
          pattern: "^(1[0-2]|[1-9])\\/(3[01]|[12][0-9]|[1-9])\\/\\d{4}$",
          maxLength: 10
        }
      ),
      r && // clear date
      /* @__PURE__ */ l.jsx(
        "button",
        {
          className: "icon-only date-clear-button",
          onClick: () => n(),
          children: /* @__PURE__ */ l.jsx(G, { glyph: "x-lg" })
        }
      ),
      /* @__PURE__ */ l.jsx(
        "button",
        {
          className: "icon-only",
          onClick: (c) => {
            c.preventDefault(), o(!s);
          },
          children: /* @__PURE__ */ l.jsx(G, { glyph: "calendar-event" })
        }
      )
    ] }),
    s && /* @__PURE__ */ l.jsx("div", { className: "date-picker-popup", children: /* @__PURE__ */ l.jsx(kg, { ...i }) })
  ] });
}
export {
  Pg as Accordion,
  gd as AccordionPanel,
  Tc as AlertBanner,
  Zn as AlertBox,
  Xn as AlertMessage,
  Ig as AppContextProvider,
  Lg as AuthCallback,
  Wg as AuthProvider,
  Fg as AuthRouteGuard,
  zg as BasicDivisionFooter,
  e_ as BasicHeader,
  yd as Breadcrumbs,
  bd as ContentBlock,
  Yg as ContentBlockSkeleton,
  Zg as ContentTable,
  Jg as ContentTableFilters,
  kg as DatePicker,
  r_ as DatePickerInput,
  t_ as DealerAccessHeader,
  Cd as DealerAccessPrimaryNavigation,
  jd as DealerAccessSecondaryNavigation,
  Gg as DealerDivisionGuard,
  Xg as DealerMaskMessage,
  ba as ErrorBoundary,
  va as ErrorDisplay,
  Bg as ErrorDisplayComponent,
  G as Icon,
  n_ as InfoToolTip,
  Hg as Layout,
  kd as LoadingBars,
  Ji as LoadingCircle,
  Sd as LoadingEllipsis,
  Od as LoadingGears,
  _d as Login,
  gi as Logo,
  kc as Modal,
  qg as PageNotFound,
  So as PageTitle,
  $g as ProgressBar,
  Dd as QuickLinksMenu,
  Vg as ResponsiveGrid,
  Ld as SideDrawer,
  Id as Sidebar,
  Qg as StyleGuide,
  Rd as SwitchDealerModal,
  Ui as Tab,
  Fd as TabbedContent,
  Kg as Theme,
  Pd as Unauthorized,
  Ug as ValidationTooltip
};
//# sourceMappingURL=index.js.map
